(function() {
  'use strict';

  angular
    .module('client', ['ngSanitize','ngAnimate', 'ui.router', 'ui.bootstrap', 'ui.tinymce']);

})();

(function() {
	'use strict';

	angular
	.module('client')
	.filter('truncate', truncate);

	/** @ngInject */
	function truncate() {
		Math.trunc = Math.trunc || function(x) {
			if (isNaN(x)) {
				return NaN;
			}
			if (x > 0) {
				return Math.floor(x);
			}
			return Math.ceil(x);
		};

		return function(val, places) {
			var truncated = Math.trunc(val * Math.pow(10, places)) / Math.pow(10, places).toFixed(places);

			return truncated;
		}
	}
})();
(function() {
	'use strict';

	angular
	.module('client')
	.factory('statusData', statusData);

	/** @ngInject */
	function statusData($rootScope, $http, $q) {
		var results = [];
		var service = {
			getStatus : getStatus,
			getChartData : getChartData,
			getEnv : getEnv,
			getSystemEnv : getSystemEnv,
			getNotifications : getNotifications,
			getLists : getLists,
			updateEnv : updateEnv,
			updateTimestamp : updateTimestamp,
			data : results,
			env : 'ext-prod-live',
			envUrl: 'api/v1/Environment'
		};

		return service;


		/*****************************************************************************
		Handle Success
		*****************************************************************************/

		function handleSuccess(response, name) {
			results[name] = response.data;
		}


		/*****************************************************************************
		Handle Error
		*****************************************************************************/

		function handleError(response) {
			throw response;
		}


		/*****************************************************************************
		Get Data
		*****************************************************************************/

		function getStatus(env) {
			var url = '/api/v1/status';
			var param = {
				params : {
					environment: env
				}
			};

			// Get Status
			return $http.get(url, param)
				.then(function(response) {
					results['status'] = response.data;

					// Broadcast to app that new Notifications are available
					$rootScope.$broadcast('statusUpdated', results);

					return response;
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Get Notifications
		*****************************************************************************/

		function getNotifications(env) {
			var url = '/api/v1/Notifications?env='+env;

			return $http.get(url)
				.then(function(response) {
					results['notifications'] = response.data.notifications;

					// Broadcast to app that new Notifications are available
					$rootScope.$broadcast('notificationUpdated', results);

					return response;
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Get All Components
		*****************************************************************************/

		function getLists(env, combine) {
			var url = '/api/v1/ServiceAndComponentList';
			var param = {
				params : {
					environment: env,
					isCombined: (combine) ? combine : false
				}
			};

			return $http.get(url, param)
				.then(function(response) {
					results['components'] = response.data.components;
					results['services'] = response.data.services;

					return results;
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Get Chart Data
		*****************************************************************************/

		function getChartData(chartParams) {
			var chartUrl = '/api/v1/GraphData';

			return $http.get(chartUrl, chartParams)
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Get Environments
		*****************************************************************************/

		function getEnv(apiUrl) {
			apiUrl ? service.envUrl = apiUrl: service.envUrl;

			return $http.get(service.envUrl).then(function(data) {
				return data;
			});
		}


		/*****************************************************************************
		Get Current System Environment
		*****************************************************************************/

		function getSystemEnv() {
			var url = '/api/v1/EnvSettings';

			return $http.get(url).then(function(data) {
				return data;
			});
		}


		/*****************************************************************************
		Update Environment
		*****************************************************************************/

		function updateEnv(env) {
			service.env = env;
			$rootScope.$broadcast('envUpdated', env);
		}


		/*****************************************************************************
		Update Time Stamp
		*****************************************************************************/

		function updateTimestamp(time) {
			return $rootScope.$broadcast('timeUpdated', time);
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.directive('status', status);

	/** @ngInject */
	function status() {
		var directive = {
			restrict: 'A',
			templateUrl: 'app/components/status/status.html'
		};

		return directive;
	}

})();
(function() {
	'use strict';

	angular
	.module('client')
	.directive('spinner', spinner);

	/** @ngInject */
	function spinner() {
		var directive = {
			restrict: 'E',
			template: '<span class="spinner" ng-if="show">Loading...</span>',
			controller: SpinnerController
		};

		return directive;

		/** @ngInject */
		function SpinnerController($scope) {
			$scope.show = false;

			$scope.$on('showSpinner', function(response, data) {
				$scope.show = true;
			});
			$scope.$on('hideSpinner', function(response, data) {
				$scope.show = false;
			});
		}

	}

})();
/*
Scroll Follow
Component must be configured like:
<element ng-class="{'follow':follow}" scroll-follow>
	<element class="content">
		...
	</element>
</element>
*/

(function() {
	'use strict';

	angular
	.module('client')
	.directive('scrollFollow', scrollFollow);

	/** @ngInject */
	function scrollFollow($window) {
		var directive = {
			restrict: 'A',
			link: link,
			scope: {
				offset: '=offset'
			},
			controller: ScrollFollowController
		};

		return directive;

		/** @ngInject */
		function ScrollFollowController($scope) {
			return $scope;
		}

		function link(scope, element, attrs, controller) {
			var $this = $(element);
			var $content = $this.find('.content');

			controller.$parent.follow = false;

			angular.element($window).on('scroll', function () {
				if (this.pageYOffset >= scope.offset) {
					$this.height($content.height());

					controller.$parent.follow = true;
				} else {
					// Revert height to auto
					$this.height('auto');

					controller.$parent.follow = false;
				}
				controller.$apply();
			});
		}
	}

})();
(function() {
	'use strict';

	angular
	.module('client')
	.filter('prettyTime', prettyTime);

	/** @ngInject */
	function prettyTime() {
		return function(time) {
			// Moment Time
			var mt = moment(time*1000);

			if (!mt.isDST()) {
				// Get local offset
				var offset = moment.parseZone().utcOffset();

				// Apply offset
				var ft = mt.utcOffset(offset);

				time = moment(ft);
			} else {
				time = mt;
			}

			// Format time to local
			var ts = Math.floor(new Date(time.format('MMM/DD/YYYY, hh:mm:ss a')).getTime());

			return ts;
		};
	}
})();
(function() {
	'use strict';

	angular
	.module('client')
	.filter('prettyService', prettyService);

	/** @ngInject */
	function prettyService() {
		return function(string, services) {
			if (services.length) {
				for (var i = 0; i < services.length; i++) {
					if (services[i].metric===string) {
						string = services[i].name;
						break;
					}
				}
			}

			return string;
		};
	}
})();
(function() {
	'use strict';

	angular
	.module('client')
	.filter('prettyEnv', prettyEnv);

	/** @ngInject */
	function prettyEnv() {
		return function(env, route) {
			switch(env) {
				case 'ext-prod-live':
					env = 'Live';
					break;
				case 'ext-prod-sim':
					env = 'Simulation';
					break;
				case 'ext-alt-live':
					env = 'Crypto';
					break;
			}
			return env;
		};
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.filter('prettyComponent', prettyComponent);

	/** @ngInject */
	function prettyComponent() {
		return function(string, components) {
			if (components.length) {
				for (var i = 0; i < components.length; i++) {
					if (components[i].backendName===string) {
						string = components[i].name;
						break;
					}
				}
			}

			return string;
		};
	}
})();
(function() {
	'use strict';

	angular
	.module('client')
	.directive('pageAlert', pageAlert);

	/** @ngInject */
	function pageAlert() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/pageAlert/pageAlert.html',
			controller: PageAlertController,
			controllerAs: 'vm'
		};

		return directive;

		/** @ngInject */
		function PageAlertController($scope, $q, $filter, statusData, $sce) {
			var vm = this;

			// Data
			vm.environment = statusData.env;
			vm.alerts = [];
			vm.servicesList = [];
			vm.componentsList = [];

			// UI
			vm.showAllSystemsOperational = false;

			// Actions
			vm.closeAlert = closeAlert;

			/*****************************************************************************
			Get list of services first, if not present
			*****************************************************************************/

			function getLists() {
				return statusData.getLists(vm.environment, true)
					.then(function(response) {
						// Clear lists
						vm.servicesList = [];
						vm.componentsList = [];

						// Apply new data
						vm.servicesList = response.services;
						vm.componentsList = response.components;

						return response;
					});
			}


			/*****************************************************************************
			Update Alerts
			*****************************************************************************/

			function updateAlerts(data) {
				var incidents = 0;

				vm.alerts = [];

				angular.forEach(data.notifications, function(obj) {
					if (obj.notification_status===2 && obj.notification_type===2 || obj.notification_status===2 && obj.notification_type===4 || obj.notification_status===2 && obj.notification_type===5) {
						incidents++;
					}
					// Ongoing messages. These will be displayed as a Page Alert
					if (obj.notification_status===2) {

						if (obj.messages.length > 1) {
							obj.messages = $filter('orderBy')(obj.messages, 'ts', true);
						}

						// Pick latest message
						obj.latest_message = obj.messages[0].message;
						obj.customer_action = obj.messages[0].customer_action;
						obj.last_updated_ts = obj.messages[0].ts;

						vm.alerts.push(obj);
					}
				});

				// Check Status when all notifications have been retrieved
				$q.all(vm.alerts).then(function() {
					// Toggle "All Systems Operational" message
					if (data.status && data.status.status==='Up' && !incidents) {
						vm.showAllSystemsOperational=true;
					} else {
						vm.showAllSystemsOperational=false;
					}
				});
			}

			$scope.$on('notificationUpdated', function(event, data) {
				updateAlerts(data);
			});

			$scope.$on('statusUpdated', function(event, data) {
				updateAlerts(data);
			});


			/*****************************************************************************
			Actions
			*****************************************************************************/

			function closeAlert(index) {
				vm.alerts.splice(index, 1);
			}


			/*****************************************************************************
			Update Data
			*****************************************************************************/

			$scope.$on('envUpdated', function(response, env) {
				vm.environment = env;
				getLists();
			});
		}

	}

})();

(function() {
	'use strict';

	angular
	.module('client')
	.directive('lastUpdated', lastUpdated);

	/** @ngInject */
	function lastUpdated() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/lastUpdated/lastUpdated.html',
			controller: lastUpdatedController
		};

		return directive;

		/** @ngInject */
		function lastUpdatedController($scope, statusData) {
			// Data
			$scope.newTime = moment().format();

			$scope.$on('timeUpdated', function(response, time) {
				$scope.newTime = time;
			});
		}

	}

})();


(function() {
	'use strict';

	angular
	.module('client')
	.directive('infiniteScroll', infiniteScroll);

	/** @ngInject */
	function infiniteScroll($window) {
		var directive = {
			restrict: 'E',
			scope:{
				parentController:'=',
				pageSize:'='
			},
			link: link,
			controller: InfiniteScrollController

		};

		return directive;

		/** @ngInject */
		function InfiniteScrollController($scope) {
			return $scope;
		}

		/** @ngInject */
		function link($rootScope, scope, element, attrs, controller) {
			$(window).unbind().scroll(function() {
				// When scrolling reaches bottom of page
				if (($(window).scrollTop() + $(window).height()).toFixed() == $(document).height() && $(window).scrollTop() !== 0) {
					attrs.parentController.pageSize = attrs.parentController.pageSize + 30;
					attrs.$apply();
				}
				// When scrolling reaches top of page
				else if ($(window).scrollTop() <= 0) {
					attrs.parentController.pageSize = attrs.pageSize;
					attrs.$apply();
			}
		});
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.filter('fullHtml', fullHtml);

	/** @ngInject */
	function fullHtml($sce) {
		return function(html) {
			return $sce.trustAsHtml(html);
		};
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.directive('environments', environments);

	/** @ngInject */
	function environments() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/environments/environments.html',
			controller: EnvironmentsController
		};

		return directive;

		/** @ngInject */
		function EnvironmentsController($scope, statusData, $filter) {
		// UI
		$scope.env = statusData.env;
		$scope.currRoute = '';
		$scope.error = false;
		$scope.errorDetails = '';


		// Data
		$scope.envList = [];

		// Actions
		$scope.updateEnv = updateEnv;


		/*****************************************************************************
		Get Environments
		*****************************************************************************/

		function getEnvironments(apiUrl){
			statusData.getEnv(apiUrl).then(function(response) {
				var vip = ['ext-prod-live','ext-prod-sim','ext-alt-live'];

				// Always keep Live(ext-prod-live), Simulation(ext-prod-sim), & Crypto(ext-alt-live) at the top of the menu
				$scope.envList = _.union(vip, response.data);
			}).catch(function(error) {
				$scope.error = true;
				$scope.errorDetails = error.status + ' ' + error.statusText;
			});
		}


		/*****************************************************************************
		Update Environments
		*****************************************************************************/

		function updateEnv(env) {
			statusData.updateEnv(env);
		}

		$scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
			$scope.currRoute = toState.name;

			if (toState.name === 'home' || toState.name === 'service') {
				statusData.env = toParams.environment;
				getEnvironments('api/v1/Environment');
			} else {
				statusData.env = $scope.env;
				getEnvironments('api/v1/Environment/include-real-time-market');
			}
		});

		$scope.$on('envUpdated', function(response, env) {
			$scope.env = env;
		});
	}

}

})();

(function() {
	'use strict';

	angular
	.module('client')
	.directive('adminNav', adminNav);

	/** @ngInject */
	function adminNav() {
		var directive = {
			restrict: 'E',
			templateUrl: 'app/components/adminNav/adminNav.html',
			controller: AdminNavController
		};

		return directive;

		/** @ngInject */
		function AdminNavController($scope, statusData) {
			// UI
			$scope.env = statusData.env;

			// Update environment on change
			$scope.$on('envUpdated', function(response, env) {
				$scope.env = env;
			});
		}
	}

})();

(function() {
	'use strict';

	angular
	.module('client')
	.filter('color', color);

	/** @ngInject */
	function color() {
		return function(pcnt) {
			var green1 = '408C40';
			var green2 = '5C9F43';
			var green3 = '80B246';
			var green4 = 'ADC648';
			var green5 = 'D9CF48';
			var green6 = 'EDB647';
			var red6 = 'EEA145';
			var red5 = 'EA9047';
			var red4 = 'E68148';
			var red3 = 'E2724A';
			var red2 = 'DE654C';
			var red1 = 'D9524E';
			var newColor;

			if (pcnt===0) {
				newColor = red1;
			}
			else if (pcnt>0 && pcnt<=10) {
				newColor = red2;
			}
			else if (pcnt>10 && pcnt<=20) {
				newColor = red3;
			}
			else if (pcnt>20 && pcnt<=30) {
				newColor = red4;
			}
			else if (pcnt>30 && pcnt<=40) {
				newColor = red5;
			}
			else if (pcnt>40 && pcnt<=50) {
				newColor = red6;
			}
			else if (pcnt>50 && pcnt<=60) {
				newColor = green6;
			}
			else if (pcnt>60 && pcnt<=70) {
				newColor = green5;
			}
			else if (pcnt>70 && pcnt<=80) {
				newColor = green4;
			}
			else if (pcnt>80 && pcnt<=90) {
				newColor = green3;
			}
			else if (pcnt>90 && pcnt<100) {
				newColor = green2;
			}
			else if (pcnt===100) {
				newColor = green1;
			}

			return '#' + newColor;
		};
	}
})();
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */
if("undefined"==typeof jQuery)throw new Error("Bootstrap's JavaScript requires jQuery");+function(a){"use strict";var b=a.fn.jquery.split(" ")[0].split(".");if(b[0]<2&&b[1]<9||1==b[0]&&9==b[1]&&b[2]<1||b[0]>3)throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4")}(jQuery),+function(a){"use strict";function b(){var a=document.createElement("bootstrap"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}a.fn.emulateTransitionEnd=function(b){var c=!1,d=this;a(this).one("bsTransitionEnd",function(){c=!0});var e=function(){c||a(d).trigger(a.support.transition.end)};return setTimeout(e,b),this},a(function(){a.support.transition=b(),a.support.transition&&(a.event.special.bsTransitionEnd={bindType:a.support.transition.end,delegateType:a.support.transition.end,handle:function(b){if(a(b.target).is(this))return b.handleObj.handler.apply(this,arguments)}})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var c=a(this),e=c.data("bs.alert");e||c.data("bs.alert",e=new d(this)),"string"==typeof b&&e[b].call(c)})}var c='[data-dismiss="alert"]',d=function(b){a(b).on("click",c,this.close)};d.VERSION="3.3.7",d.TRANSITION_DURATION=150,d.prototype.close=function(b){function c(){g.detach().trigger("closed.bs.alert").remove()}var e=a(this),f=e.attr("data-target");f||(f=e.attr("href"),f=f&&f.replace(/.*(?=#[^\s]*$)/,""));var g=a("#"===f?[]:f);b&&b.preventDefault(),g.length||(g=e.closest(".alert")),g.trigger(b=a.Event("close.bs.alert")),b.isDefaultPrevented()||(g.removeClass("in"),a.support.transition&&g.hasClass("fade")?g.one("bsTransitionEnd",c).emulateTransitionEnd(d.TRANSITION_DURATION):c())};var e=a.fn.alert;a.fn.alert=b,a.fn.alert.Constructor=d,a.fn.alert.noConflict=function(){return a.fn.alert=e,this},a(document).on("click.bs.alert.data-api",c,d.prototype.close)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.button"),f="object"==typeof b&&b;e||d.data("bs.button",e=new c(this,f)),"toggle"==b?e.toggle():b&&e.setState(b)})}var c=function(b,d){this.$element=a(b),this.options=a.extend({},c.DEFAULTS,d),this.isLoading=!1};c.VERSION="3.3.7",c.DEFAULTS={loadingText:"loading..."},c.prototype.setState=function(b){var c="disabled",d=this.$element,e=d.is("input")?"val":"html",f=d.data();b+="Text",null==f.resetText&&d.data("resetText",d[e]()),setTimeout(a.proxy(function(){d[e](null==f[b]?this.options[b]:f[b]),"loadingText"==b?(this.isLoading=!0,d.addClass(c).attr(c,c).prop(c,!0)):this.isLoading&&(this.isLoading=!1,d.removeClass(c).removeAttr(c).prop(c,!1))},this),0)},c.prototype.toggle=function(){var a=!0,b=this.$element.closest('[data-toggle="buttons"]');if(b.length){var c=this.$element.find("input");"radio"==c.prop("type")?(c.prop("checked")&&(a=!1),b.find(".active").removeClass("active"),this.$element.addClass("active")):"checkbox"==c.prop("type")&&(c.prop("checked")!==this.$element.hasClass("active")&&(a=!1),this.$element.toggleClass("active")),c.prop("checked",this.$element.hasClass("active")),a&&c.trigger("change")}else this.$element.attr("aria-pressed",!this.$element.hasClass("active")),this.$element.toggleClass("active")};var d=a.fn.button;a.fn.button=b,a.fn.button.Constructor=c,a.fn.button.noConflict=function(){return a.fn.button=d,this},a(document).on("click.bs.button.data-api",'[data-toggle^="button"]',function(c){var d=a(c.target).closest(".btn");b.call(d,"toggle"),a(c.target).is('input[type="radio"], input[type="checkbox"]')||(c.preventDefault(),d.is("input,button")?d.trigger("focus"):d.find("input:visible,button:visible").first().trigger("focus"))}).on("focus.bs.button.data-api blur.bs.button.data-api",'[data-toggle^="button"]',function(b){a(b.target).closest(".btn").toggleClass("focus",/^focus(in)?$/.test(b.type))})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.carousel"),f=a.extend({},c.DEFAULTS,d.data(),"object"==typeof b&&b),g="string"==typeof b?b:f.slide;e||d.data("bs.carousel",e=new c(this,f)),"number"==typeof b?e.to(b):g?e[g]():f.interval&&e.pause().cycle()})}var c=function(b,c){this.$element=a(b),this.$indicators=this.$element.find(".carousel-indicators"),this.options=c,this.paused=null,this.sliding=null,this.interval=null,this.$active=null,this.$items=null,this.options.keyboard&&this.$element.on("keydown.bs.carousel",a.proxy(this.keydown,this)),"hover"==this.options.pause&&!("ontouchstart"in document.documentElement)&&this.$element.on("mouseenter.bs.carousel",a.proxy(this.pause,this)).on("mouseleave.bs.carousel",a.proxy(this.cycle,this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=600,c.DEFAULTS={interval:5e3,pause:"hover",wrap:!0,keyboard:!0},c.prototype.keydown=function(a){if(!/input|textarea/i.test(a.target.tagName)){switch(a.which){case 37:this.prev();break;case 39:this.next();break;default:return}a.preventDefault()}},c.prototype.cycle=function(b){return b||(this.paused=!1),this.interval&&clearInterval(this.interval),this.options.interval&&!this.paused&&(this.interval=setInterval(a.proxy(this.next,this),this.options.interval)),this},c.prototype.getItemIndex=function(a){return this.$items=a.parent().children(".item"),this.$items.index(a||this.$active)},c.prototype.getItemForDirection=function(a,b){var c=this.getItemIndex(b),d="prev"==a&&0===c||"next"==a&&c==this.$items.length-1;if(d&&!this.options.wrap)return b;var e="prev"==a?-1:1,f=(c+e)%this.$items.length;return this.$items.eq(f)},c.prototype.to=function(a){var b=this,c=this.getItemIndex(this.$active=this.$element.find(".item.active"));if(!(a>this.$items.length-1||a<0))return this.sliding?this.$element.one("slid.bs.carousel",function(){b.to(a)}):c==a?this.pause().cycle():this.slide(a>c?"next":"prev",this.$items.eq(a))},c.prototype.pause=function(b){return b||(this.paused=!0),this.$element.find(".next, .prev").length&&a.support.transition&&(this.$element.trigger(a.support.transition.end),this.cycle(!0)),this.interval=clearInterval(this.interval),this},c.prototype.next=function(){if(!this.sliding)return this.slide("next")},c.prototype.prev=function(){if(!this.sliding)return this.slide("prev")},c.prototype.slide=function(b,d){var e=this.$element.find(".item.active"),f=d||this.getItemForDirection(b,e),g=this.interval,h="next"==b?"left":"right",i=this;if(f.hasClass("active"))return this.sliding=!1;var j=f[0],k=a.Event("slide.bs.carousel",{relatedTarget:j,direction:h});if(this.$element.trigger(k),!k.isDefaultPrevented()){if(this.sliding=!0,g&&this.pause(),this.$indicators.length){this.$indicators.find(".active").removeClass("active");var l=a(this.$indicators.children()[this.getItemIndex(f)]);l&&l.addClass("active")}var m=a.Event("slid.bs.carousel",{relatedTarget:j,direction:h});return a.support.transition&&this.$element.hasClass("slide")?(f.addClass(b),f[0].offsetWidth,e.addClass(h),f.addClass(h),e.one("bsTransitionEnd",function(){f.removeClass([b,h].join(" ")).addClass("active"),e.removeClass(["active",h].join(" ")),i.sliding=!1,setTimeout(function(){i.$element.trigger(m)},0)}).emulateTransitionEnd(c.TRANSITION_DURATION)):(e.removeClass("active"),f.addClass("active"),this.sliding=!1,this.$element.trigger(m)),g&&this.cycle(),this}};var d=a.fn.carousel;a.fn.carousel=b,a.fn.carousel.Constructor=c,a.fn.carousel.noConflict=function(){return a.fn.carousel=d,this};var e=function(c){var d,e=a(this),f=a(e.attr("data-target")||(d=e.attr("href"))&&d.replace(/.*(?=#[^\s]+$)/,""));if(f.hasClass("carousel")){var g=a.extend({},f.data(),e.data()),h=e.attr("data-slide-to");h&&(g.interval=!1),b.call(f,g),h&&f.data("bs.carousel").to(h),c.preventDefault()}};a(document).on("click.bs.carousel.data-api","[data-slide]",e).on("click.bs.carousel.data-api","[data-slide-to]",e),a(window).on("load",function(){a('[data-ride="carousel"]').each(function(){var c=a(this);b.call(c,c.data())})})}(jQuery),+function(a){"use strict";function b(b){var c,d=b.attr("data-target")||(c=b.attr("href"))&&c.replace(/.*(?=#[^\s]+$)/,"");return a(d)}function c(b){return this.each(function(){var c=a(this),e=c.data("bs.collapse"),f=a.extend({},d.DEFAULTS,c.data(),"object"==typeof b&&b);!e&&f.toggle&&/show|hide/.test(b)&&(f.toggle=!1),e||c.data("bs.collapse",e=new d(this,f)),"string"==typeof b&&e[b]()})}var d=function(b,c){this.$element=a(b),this.options=a.extend({},d.DEFAULTS,c),this.$trigger=a('[data-toggle="collapse"][href="#'+b.id+'"],[data-toggle="collapse"][data-target="#'+b.id+'"]'),this.transitioning=null,this.options.parent?this.$parent=this.getParent():this.addAriaAndCollapsedClass(this.$element,this.$trigger),this.options.toggle&&this.toggle()};d.VERSION="3.3.7",d.TRANSITION_DURATION=350,d.DEFAULTS={toggle:!0},d.prototype.dimension=function(){var a=this.$element.hasClass("width");return a?"width":"height"},d.prototype.show=function(){if(!this.transitioning&&!this.$element.hasClass("in")){var b,e=this.$parent&&this.$parent.children(".panel").children(".in, .collapsing");if(!(e&&e.length&&(b=e.data("bs.collapse"),b&&b.transitioning))){var f=a.Event("show.bs.collapse");if(this.$element.trigger(f),!f.isDefaultPrevented()){e&&e.length&&(c.call(e,"hide"),b||e.data("bs.collapse",null));var g=this.dimension();this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded",!0),this.$trigger.removeClass("collapsed").attr("aria-expanded",!0),this.transitioning=1;var h=function(){this.$element.removeClass("collapsing").addClass("collapse in")[g](""),this.transitioning=0,this.$element.trigger("shown.bs.collapse")};if(!a.support.transition)return h.call(this);var i=a.camelCase(["scroll",g].join("-"));this.$element.one("bsTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])}}}},d.prototype.hide=function(){if(!this.transitioning&&this.$element.hasClass("in")){var b=a.Event("hide.bs.collapse");if(this.$element.trigger(b),!b.isDefaultPrevented()){var c=this.dimension();this.$element[c](this.$element[c]())[0].offsetHeight,this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded",!1),this.$trigger.addClass("collapsed").attr("aria-expanded",!1),this.transitioning=1;var e=function(){this.transitioning=0,this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")};return a.support.transition?void this.$element[c](0).one("bsTransitionEnd",a.proxy(e,this)).emulateTransitionEnd(d.TRANSITION_DURATION):e.call(this)}}},d.prototype.toggle=function(){this[this.$element.hasClass("in")?"hide":"show"]()},d.prototype.getParent=function(){return a(this.options.parent).find('[data-toggle="collapse"][data-parent="'+this.options.parent+'"]').each(a.proxy(function(c,d){var e=a(d);this.addAriaAndCollapsedClass(b(e),e)},this)).end()},d.prototype.addAriaAndCollapsedClass=function(a,b){var c=a.hasClass("in");a.attr("aria-expanded",c),b.toggleClass("collapsed",!c).attr("aria-expanded",c)};var e=a.fn.collapse;a.fn.collapse=c,a.fn.collapse.Constructor=d,a.fn.collapse.noConflict=function(){return a.fn.collapse=e,this},a(document).on("click.bs.collapse.data-api",'[data-toggle="collapse"]',function(d){var e=a(this);e.attr("data-target")||d.preventDefault();var f=b(e),g=f.data("bs.collapse"),h=g?"toggle":e.data();c.call(f,h)})}(jQuery),+function(a){"use strict";function b(b){var c=b.attr("data-target");c||(c=b.attr("href"),c=c&&/#[A-Za-z]/.test(c)&&c.replace(/.*(?=#[^\s]*$)/,""));var d=c&&a(c);return d&&d.length?d:b.parent()}function c(c){c&&3===c.which||(a(e).remove(),a(f).each(function(){var d=a(this),e=b(d),f={relatedTarget:this};e.hasClass("open")&&(c&&"click"==c.type&&/input|textarea/i.test(c.target.tagName)&&a.contains(e[0],c.target)||(e.trigger(c=a.Event("hide.bs.dropdown",f)),c.isDefaultPrevented()||(d.attr("aria-expanded","false"),e.removeClass("open").trigger(a.Event("hidden.bs.dropdown",f)))))}))}function d(b){return this.each(function(){var c=a(this),d=c.data("bs.dropdown");d||c.data("bs.dropdown",d=new g(this)),"string"==typeof b&&d[b].call(c)})}var e=".dropdown-backdrop",f='[data-toggle="dropdown"]',g=function(b){a(b).on("click.bs.dropdown",this.toggle)};g.VERSION="3.3.7",g.prototype.toggle=function(d){var e=a(this);if(!e.is(".disabled, :disabled")){var f=b(e),g=f.hasClass("open");if(c(),!g){"ontouchstart"in document.documentElement&&!f.closest(".navbar-nav").length&&a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click",c);var h={relatedTarget:this};if(f.trigger(d=a.Event("show.bs.dropdown",h)),d.isDefaultPrevented())return;e.trigger("focus").attr("aria-expanded","true"),f.toggleClass("open").trigger(a.Event("shown.bs.dropdown",h))}return!1}},g.prototype.keydown=function(c){if(/(38|40|27|32)/.test(c.which)&&!/input|textarea/i.test(c.target.tagName)){var d=a(this);if(c.preventDefault(),c.stopPropagation(),!d.is(".disabled, :disabled")){var e=b(d),g=e.hasClass("open");if(!g&&27!=c.which||g&&27==c.which)return 27==c.which&&e.find(f).trigger("focus"),d.trigger("click");var h=" li:not(.disabled):visible a",i=e.find(".dropdown-menu"+h);if(i.length){var j=i.index(c.target);38==c.which&&j>0&&j--,40==c.which&&j<i.length-1&&j++,~j||(j=0),i.eq(j).trigger("focus")}}}};var h=a.fn.dropdown;a.fn.dropdown=d,a.fn.dropdown.Constructor=g,a.fn.dropdown.noConflict=function(){return a.fn.dropdown=h,this},a(document).on("click.bs.dropdown.data-api",c).on("click.bs.dropdown.data-api",".dropdown form",function(a){a.stopPropagation()}).on("click.bs.dropdown.data-api",f,g.prototype.toggle).on("keydown.bs.dropdown.data-api",f,g.prototype.keydown).on("keydown.bs.dropdown.data-api",".dropdown-menu",g.prototype.keydown)}(jQuery),+function(a){"use strict";function b(b,d){return this.each(function(){var e=a(this),f=e.data("bs.modal"),g=a.extend({},c.DEFAULTS,e.data(),"object"==typeof b&&b);f||e.data("bs.modal",f=new c(this,g)),"string"==typeof b?f[b](d):g.show&&f.show(d)})}var c=function(b,c){this.options=c,this.$body=a(document.body),this.$element=a(b),this.$dialog=this.$element.find(".modal-dialog"),this.$backdrop=null,this.isShown=null,this.originalBodyPad=null,this.scrollbarWidth=0,this.ignoreBackdropClick=!1,this.options.remote&&this.$element.find(".modal-content").load(this.options.remote,a.proxy(function(){this.$element.trigger("loaded.bs.modal")},this))};c.VERSION="3.3.7",c.TRANSITION_DURATION=300,c.BACKDROP_TRANSITION_DURATION=150,c.DEFAULTS={backdrop:!0,keyboard:!0,show:!0},c.prototype.toggle=function(a){return this.isShown?this.hide():this.show(a)},c.prototype.show=function(b){var d=this,e=a.Event("show.bs.modal",{relatedTarget:b});this.$element.trigger(e),this.isShown||e.isDefaultPrevented()||(this.isShown=!0,this.checkScrollbar(),this.setScrollbar(),this.$body.addClass("modal-open"),this.escape(),this.resize(),this.$element.on("click.dismiss.bs.modal",'[data-dismiss="modal"]',a.proxy(this.hide,this)),this.$dialog.on("mousedown.dismiss.bs.modal",function(){d.$element.one("mouseup.dismiss.bs.modal",function(b){a(b.target).is(d.$element)&&(d.ignoreBackdropClick=!0)})}),this.backdrop(function(){var e=a.support.transition&&d.$element.hasClass("fade");d.$element.parent().length||d.$element.appendTo(d.$body),d.$element.show().scrollTop(0),d.adjustDialog(),e&&d.$element[0].offsetWidth,d.$element.addClass("in"),d.enforceFocus();var f=a.Event("shown.bs.modal",{relatedTarget:b});e?d.$dialog.one("bsTransitionEnd",function(){d.$element.trigger("focus").trigger(f)}).emulateTransitionEnd(c.TRANSITION_DURATION):d.$element.trigger("focus").trigger(f)}))},c.prototype.hide=function(b){b&&b.preventDefault(),b=a.Event("hide.bs.modal"),this.$element.trigger(b),this.isShown&&!b.isDefaultPrevented()&&(this.isShown=!1,this.escape(),this.resize(),a(document).off("focusin.bs.modal"),this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"),this.$dialog.off("mousedown.dismiss.bs.modal"),a.support.transition&&this.$element.hasClass("fade")?this.$element.one("bsTransitionEnd",a.proxy(this.hideModal,this)).emulateTransitionEnd(c.TRANSITION_DURATION):this.hideModal())},c.prototype.enforceFocus=function(){a(document).off("focusin.bs.modal").on("focusin.bs.modal",a.proxy(function(a){document===a.target||this.$element[0]===a.target||this.$element.has(a.target).length||this.$element.trigger("focus")},this))},c.prototype.escape=function(){this.isShown&&this.options.keyboard?this.$element.on("keydown.dismiss.bs.modal",a.proxy(function(a){27==a.which&&this.hide()},this)):this.isShown||this.$element.off("keydown.dismiss.bs.modal")},c.prototype.resize=function(){this.isShown?a(window).on("resize.bs.modal",a.proxy(this.handleUpdate,this)):a(window).off("resize.bs.modal")},c.prototype.hideModal=function(){var a=this;this.$element.hide(),this.backdrop(function(){a.$body.removeClass("modal-open"),a.resetAdjustments(),a.resetScrollbar(),a.$element.trigger("hidden.bs.modal")})},c.prototype.removeBackdrop=function(){this.$backdrop&&this.$backdrop.remove(),this.$backdrop=null},c.prototype.backdrop=function(b){var d=this,e=this.$element.hasClass("fade")?"fade":"";if(this.isShown&&this.options.backdrop){var f=a.support.transition&&e;if(this.$backdrop=a(document.createElement("div")).addClass("modal-backdrop "+e).appendTo(this.$body),this.$element.on("click.dismiss.bs.modal",a.proxy(function(a){return this.ignoreBackdropClick?void(this.ignoreBackdropClick=!1):void(a.target===a.currentTarget&&("static"==this.options.backdrop?this.$element[0].focus():this.hide()))},this)),f&&this.$backdrop[0].offsetWidth,this.$backdrop.addClass("in"),!b)return;f?this.$backdrop.one("bsTransitionEnd",b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):b()}else if(!this.isShown&&this.$backdrop){this.$backdrop.removeClass("in");var g=function(){d.removeBackdrop(),b&&b()};a.support.transition&&this.$element.hasClass("fade")?this.$backdrop.one("bsTransitionEnd",g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION):g()}else b&&b()},c.prototype.handleUpdate=function(){this.adjustDialog()},c.prototype.adjustDialog=function(){var a=this.$element[0].scrollHeight>document.documentElement.clientHeight;this.$element.css({paddingLeft:!this.bodyIsOverflowing&&a?this.scrollbarWidth:"",paddingRight:this.bodyIsOverflowing&&!a?this.scrollbarWidth:""})},c.prototype.resetAdjustments=function(){this.$element.css({paddingLeft:"",paddingRight:""})},c.prototype.checkScrollbar=function(){var a=window.innerWidth;if(!a){var b=document.documentElement.getBoundingClientRect();a=b.right-Math.abs(b.left)}this.bodyIsOverflowing=document.body.clientWidth<a,this.scrollbarWidth=this.measureScrollbar()},c.prototype.setScrollbar=function(){var a=parseInt(this.$body.css("padding-right")||0,10);this.originalBodyPad=document.body.style.paddingRight||"",this.bodyIsOverflowing&&this.$body.css("padding-right",a+this.scrollbarWidth)},c.prototype.resetScrollbar=function(){this.$body.css("padding-right",this.originalBodyPad)},c.prototype.measureScrollbar=function(){var a=document.createElement("div");a.className="modal-scrollbar-measure",this.$body.append(a);var b=a.offsetWidth-a.clientWidth;return this.$body[0].removeChild(a),b};var d=a.fn.modal;a.fn.modal=b,a.fn.modal.Constructor=c,a.fn.modal.noConflict=function(){return a.fn.modal=d,this},a(document).on("click.bs.modal.data-api",'[data-toggle="modal"]',function(c){var d=a(this),e=d.attr("href"),f=a(d.attr("data-target")||e&&e.replace(/.*(?=#[^\s]+$)/,"")),g=f.data("bs.modal")?"toggle":a.extend({remote:!/#/.test(e)&&e},f.data(),d.data());d.is("a")&&c.preventDefault(),f.one("show.bs.modal",function(a){a.isDefaultPrevented()||f.one("hidden.bs.modal",function(){d.is(":visible")&&d.trigger("focus")})}),b.call(f,g,this)})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tooltip"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.tooltip",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.type=null,this.options=null,this.enabled=null,this.timeout=null,this.hoverState=null,this.$element=null,this.inState=null,this.init("tooltip",a,b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.DEFAULTS={animation:!0,placement:"top",selector:!1,template:'<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',trigger:"hover focus",title:"",delay:0,html:!1,container:!1,viewport:{selector:"body",padding:0}},c.prototype.init=function(b,c,d){if(this.enabled=!0,this.type=b,this.$element=a(c),this.options=this.getOptions(d),this.$viewport=this.options.viewport&&a(a.isFunction(this.options.viewport)?this.options.viewport.call(this,this.$element):this.options.viewport.selector||this.options.viewport),this.inState={click:!1,hover:!1,focus:!1},this.$element[0]instanceof document.constructor&&!this.options.selector)throw new Error("`selector` option must be specified when initializing "+this.type+" on the window.document object!");for(var e=this.options.trigger.split(" "),f=e.length;f--;){var g=e[f];if("click"==g)this.$element.on("click."+this.type,this.options.selector,a.proxy(this.toggle,this));else if("manual"!=g){var h="hover"==g?"mouseenter":"focusin",i="hover"==g?"mouseleave":"focusout";this.$element.on(h+"."+this.type,this.options.selector,a.proxy(this.enter,this)),this.$element.on(i+"."+this.type,this.options.selector,a.proxy(this.leave,this))}}this.options.selector?this._options=a.extend({},this.options,{trigger:"manual",selector:""}):this.fixTitle()},c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.getOptions=function(b){return b=a.extend({},this.getDefaults(),this.$element.data(),b),b.delay&&"number"==typeof b.delay&&(b.delay={show:b.delay,hide:b.delay}),b},c.prototype.getDelegateOptions=function(){var b={},c=this.getDefaults();return this._options&&a.each(this._options,function(a,d){c[a]!=d&&(b[a]=d)}),b},c.prototype.enter=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);return c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusin"==b.type?"focus":"hover"]=!0),c.tip().hasClass("in")||"in"==c.hoverState?void(c.hoverState="in"):(clearTimeout(c.timeout),c.hoverState="in",c.options.delay&&c.options.delay.show?void(c.timeout=setTimeout(function(){"in"==c.hoverState&&c.show()},c.options.delay.show)):c.show())},c.prototype.isInStateTrue=function(){for(var a in this.inState)if(this.inState[a])return!0;return!1},c.prototype.leave=function(b){var c=b instanceof this.constructor?b:a(b.currentTarget).data("bs."+this.type);if(c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c)),b instanceof a.Event&&(c.inState["focusout"==b.type?"focus":"hover"]=!1),!c.isInStateTrue())return clearTimeout(c.timeout),c.hoverState="out",c.options.delay&&c.options.delay.hide?void(c.timeout=setTimeout(function(){"out"==c.hoverState&&c.hide()},c.options.delay.hide)):c.hide()},c.prototype.show=function(){var b=a.Event("show.bs."+this.type);if(this.hasContent()&&this.enabled){this.$element.trigger(b);var d=a.contains(this.$element[0].ownerDocument.documentElement,this.$element[0]);if(b.isDefaultPrevented()||!d)return;var e=this,f=this.tip(),g=this.getUID(this.type);this.setContent(),f.attr("id",g),this.$element.attr("aria-describedby",g),this.options.animation&&f.addClass("fade");var h="function"==typeof this.options.placement?this.options.placement.call(this,f[0],this.$element[0]):this.options.placement,i=/\s?auto?\s?/i,j=i.test(h);j&&(h=h.replace(i,"")||"top"),f.detach().css({top:0,left:0,display:"block"}).addClass(h).data("bs."+this.type,this),this.options.container?f.appendTo(this.options.container):f.insertAfter(this.$element),this.$element.trigger("inserted.bs."+this.type);var k=this.getPosition(),l=f[0].offsetWidth,m=f[0].offsetHeight;if(j){var n=h,o=this.getPosition(this.$viewport);h="bottom"==h&&k.bottom+m>o.bottom?"top":"top"==h&&k.top-m<o.top?"bottom":"right"==h&&k.right+l>o.width?"left":"left"==h&&k.left-l<o.left?"right":h,f.removeClass(n).addClass(h)}var p=this.getCalculatedOffset(h,k,l,m);this.applyPlacement(p,h);var q=function(){var a=e.hoverState;e.$element.trigger("shown.bs."+e.type),e.hoverState=null,"out"==a&&e.leave(e)};a.support.transition&&this.$tip.hasClass("fade")?f.one("bsTransitionEnd",q).emulateTransitionEnd(c.TRANSITION_DURATION):q()}},c.prototype.applyPlacement=function(b,c){var d=this.tip(),e=d[0].offsetWidth,f=d[0].offsetHeight,g=parseInt(d.css("margin-top"),10),h=parseInt(d.css("margin-left"),10);isNaN(g)&&(g=0),isNaN(h)&&(h=0),b.top+=g,b.left+=h,a.offset.setOffset(d[0],a.extend({using:function(a){d.css({top:Math.round(a.top),left:Math.round(a.left)})}},b),0),d.addClass("in");var i=d[0].offsetWidth,j=d[0].offsetHeight;"top"==c&&j!=f&&(b.top=b.top+f-j);var k=this.getViewportAdjustedDelta(c,b,i,j);k.left?b.left+=k.left:b.top+=k.top;var l=/top|bottom/.test(c),m=l?2*k.left-e+i:2*k.top-f+j,n=l?"offsetWidth":"offsetHeight";d.offset(b),this.replaceArrow(m,d[0][n],l)},c.prototype.replaceArrow=function(a,b,c){this.arrow().css(c?"left":"top",50*(1-a/b)+"%").css(c?"top":"left","")},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle();a.find(".tooltip-inner")[this.options.html?"html":"text"](b),a.removeClass("fade in top bottom left right")},c.prototype.hide=function(b){function d(){"in"!=e.hoverState&&f.detach(),e.$element&&e.$element.removeAttr("aria-describedby").trigger("hidden.bs."+e.type),b&&b()}var e=this,f=a(this.$tip),g=a.Event("hide.bs."+this.type);if(this.$element.trigger(g),!g.isDefaultPrevented())return f.removeClass("in"),a.support.transition&&f.hasClass("fade")?f.one("bsTransitionEnd",d).emulateTransitionEnd(c.TRANSITION_DURATION):d(),this.hoverState=null,this},c.prototype.fixTitle=function(){var a=this.$element;(a.attr("title")||"string"!=typeof a.attr("data-original-title"))&&a.attr("data-original-title",a.attr("title")||"").attr("title","")},c.prototype.hasContent=function(){return this.getTitle()},c.prototype.getPosition=function(b){b=b||this.$element;var c=b[0],d="BODY"==c.tagName,e=c.getBoundingClientRect();null==e.width&&(e=a.extend({},e,{width:e.right-e.left,height:e.bottom-e.top}));var f=window.SVGElement&&c instanceof window.SVGElement,g=d?{top:0,left:0}:f?null:b.offset(),h={scroll:d?document.documentElement.scrollTop||document.body.scrollTop:b.scrollTop()},i=d?{width:a(window).width(),height:a(window).height()}:null;return a.extend({},e,h,i,g)},c.prototype.getCalculatedOffset=function(a,b,c,d){return"bottom"==a?{top:b.top+b.height,left:b.left+b.width/2-c/2}:"top"==a?{top:b.top-d,left:b.left+b.width/2-c/2}:"left"==a?{top:b.top+b.height/2-d/2,left:b.left-c}:{top:b.top+b.height/2-d/2,left:b.left+b.width}},c.prototype.getViewportAdjustedDelta=function(a,b,c,d){var e={top:0,left:0};if(!this.$viewport)return e;var f=this.options.viewport&&this.options.viewport.padding||0,g=this.getPosition(this.$viewport);if(/right|left/.test(a)){var h=b.top-f-g.scroll,i=b.top+f-g.scroll+d;h<g.top?e.top=g.top-h:i>g.top+g.height&&(e.top=g.top+g.height-i)}else{var j=b.left-f,k=b.left+f+c;j<g.left?e.left=g.left-j:k>g.right&&(e.left=g.left+g.width-k)}return e},c.prototype.getTitle=function(){var a,b=this.$element,c=this.options;return a=b.attr("data-original-title")||("function"==typeof c.title?c.title.call(b[0]):c.title)},c.prototype.getUID=function(a){do a+=~~(1e6*Math.random());while(document.getElementById(a));return a},c.prototype.tip=function(){if(!this.$tip&&(this.$tip=a(this.options.template),1!=this.$tip.length))throw new Error(this.type+" `template` option must consist of exactly 1 top-level element!");return this.$tip},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".tooltip-arrow")},c.prototype.enable=function(){this.enabled=!0},c.prototype.disable=function(){this.enabled=!1},c.prototype.toggleEnabled=function(){this.enabled=!this.enabled},c.prototype.toggle=function(b){var c=this;b&&(c=a(b.currentTarget).data("bs."+this.type),c||(c=new this.constructor(b.currentTarget,this.getDelegateOptions()),a(b.currentTarget).data("bs."+this.type,c))),b?(c.inState.click=!c.inState.click,c.isInStateTrue()?c.enter(c):c.leave(c)):c.tip().hasClass("in")?c.leave(c):c.enter(c)},c.prototype.destroy=function(){var a=this;clearTimeout(this.timeout),this.hide(function(){a.$element.off("."+a.type).removeData("bs."+a.type),a.$tip&&a.$tip.detach(),a.$tip=null,a.$arrow=null,a.$viewport=null,a.$element=null})};var d=a.fn.tooltip;a.fn.tooltip=b,a.fn.tooltip.Constructor=c,a.fn.tooltip.noConflict=function(){return a.fn.tooltip=d,this}}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.popover"),f="object"==typeof b&&b;!e&&/destroy|hide/.test(b)||(e||d.data("bs.popover",e=new c(this,f)),"string"==typeof b&&e[b]())})}var c=function(a,b){this.init("popover",a,b)};if(!a.fn.tooltip)throw new Error("Popover requires tooltip.js");c.VERSION="3.3.7",c.DEFAULTS=a.extend({},a.fn.tooltip.Constructor.DEFAULTS,{placement:"right",trigger:"click",content:"",template:'<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'}),c.prototype=a.extend({},a.fn.tooltip.Constructor.prototype),c.prototype.constructor=c,c.prototype.getDefaults=function(){return c.DEFAULTS},c.prototype.setContent=function(){var a=this.tip(),b=this.getTitle(),c=this.getContent();a.find(".popover-title")[this.options.html?"html":"text"](b),a.find(".popover-content").children().detach().end()[this.options.html?"string"==typeof c?"html":"append":"text"](c),a.removeClass("fade top bottom left right in"),a.find(".popover-title").html()||a.find(".popover-title").hide()},c.prototype.hasContent=function(){return this.getTitle()||this.getContent()},c.prototype.getContent=function(){var a=this.$element,b=this.options;return a.attr("data-content")||("function"==typeof b.content?b.content.call(a[0]):b.content)},c.prototype.arrow=function(){return this.$arrow=this.$arrow||this.tip().find(".arrow")};var d=a.fn.popover;a.fn.popover=b,a.fn.popover.Constructor=c,a.fn.popover.noConflict=function(){return a.fn.popover=d,this}}(jQuery),+function(a){"use strict";function b(c,d){this.$body=a(document.body),this.$scrollElement=a(a(c).is(document.body)?window:c),this.options=a.extend({},b.DEFAULTS,d),this.selector=(this.options.target||"")+" .nav li > a",this.offsets=[],this.targets=[],this.activeTarget=null,this.scrollHeight=0,this.$scrollElement.on("scroll.bs.scrollspy",a.proxy(this.process,this)),this.refresh(),this.process()}function c(c){return this.each(function(){var d=a(this),e=d.data("bs.scrollspy"),f="object"==typeof c&&c;e||d.data("bs.scrollspy",e=new b(this,f)),"string"==typeof c&&e[c]()})}b.VERSION="3.3.7",b.DEFAULTS={offset:10},b.prototype.getScrollHeight=function(){return this.$scrollElement[0].scrollHeight||Math.max(this.$body[0].scrollHeight,document.documentElement.scrollHeight)},b.prototype.refresh=function(){var b=this,c="offset",d=0;this.offsets=[],this.targets=[],this.scrollHeight=this.getScrollHeight(),a.isWindow(this.$scrollElement[0])||(c="position",d=this.$scrollElement.scrollTop()),this.$body.find(this.selector).map(function(){var b=a(this),e=b.data("target")||b.attr("href"),f=/^#./.test(e)&&a(e);return f&&f.length&&f.is(":visible")&&[[f[c]().top+d,e]]||null}).sort(function(a,b){return a[0]-b[0]}).each(function(){b.offsets.push(this[0]),b.targets.push(this[1])})},b.prototype.process=function(){var a,b=this.$scrollElement.scrollTop()+this.options.offset,c=this.getScrollHeight(),d=this.options.offset+c-this.$scrollElement.height(),e=this.offsets,f=this.targets,g=this.activeTarget;if(this.scrollHeight!=c&&this.refresh(),b>=d)return g!=(a=f[f.length-1])&&this.activate(a);if(g&&b<e[0])return this.activeTarget=null,this.clear();for(a=e.length;a--;)g!=f[a]&&b>=e[a]&&(void 0===e[a+1]||b<e[a+1])&&this.activate(f[a])},b.prototype.activate=function(b){
this.activeTarget=b,this.clear();var c=this.selector+'[data-target="'+b+'"],'+this.selector+'[href="'+b+'"]',d=a(c).parents("li").addClass("active");d.parent(".dropdown-menu").length&&(d=d.closest("li.dropdown").addClass("active")),d.trigger("activate.bs.scrollspy")},b.prototype.clear=function(){a(this.selector).parentsUntil(this.options.target,".active").removeClass("active")};var d=a.fn.scrollspy;a.fn.scrollspy=c,a.fn.scrollspy.Constructor=b,a.fn.scrollspy.noConflict=function(){return a.fn.scrollspy=d,this},a(window).on("load.bs.scrollspy.data-api",function(){a('[data-spy="scroll"]').each(function(){var b=a(this);c.call(b,b.data())})})}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.tab");e||d.data("bs.tab",e=new c(this)),"string"==typeof b&&e[b]()})}var c=function(b){this.element=a(b)};c.VERSION="3.3.7",c.TRANSITION_DURATION=150,c.prototype.show=function(){var b=this.element,c=b.closest("ul:not(.dropdown-menu)"),d=b.data("target");if(d||(d=b.attr("href"),d=d&&d.replace(/.*(?=#[^\s]*$)/,"")),!b.parent("li").hasClass("active")){var e=c.find(".active:last a"),f=a.Event("hide.bs.tab",{relatedTarget:b[0]}),g=a.Event("show.bs.tab",{relatedTarget:e[0]});if(e.trigger(f),b.trigger(g),!g.isDefaultPrevented()&&!f.isDefaultPrevented()){var h=a(d);this.activate(b.closest("li"),c),this.activate(h,h.parent(),function(){e.trigger({type:"hidden.bs.tab",relatedTarget:b[0]}),b.trigger({type:"shown.bs.tab",relatedTarget:e[0]})})}}},c.prototype.activate=function(b,d,e){function f(){g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!1),b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded",!0),h?(b[0].offsetWidth,b.addClass("in")):b.removeClass("fade"),b.parent(".dropdown-menu").length&&b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded",!0),e&&e()}var g=d.find("> .active"),h=e&&a.support.transition&&(g.length&&g.hasClass("fade")||!!d.find("> .fade").length);g.length&&h?g.one("bsTransitionEnd",f).emulateTransitionEnd(c.TRANSITION_DURATION):f(),g.removeClass("in")};var d=a.fn.tab;a.fn.tab=b,a.fn.tab.Constructor=c,a.fn.tab.noConflict=function(){return a.fn.tab=d,this};var e=function(c){c.preventDefault(),b.call(a(this),"show")};a(document).on("click.bs.tab.data-api",'[data-toggle="tab"]',e).on("click.bs.tab.data-api",'[data-toggle="pill"]',e)}(jQuery),+function(a){"use strict";function b(b){return this.each(function(){var d=a(this),e=d.data("bs.affix"),f="object"==typeof b&&b;e||d.data("bs.affix",e=new c(this,f)),"string"==typeof b&&e[b]()})}var c=function(b,d){this.options=a.extend({},c.DEFAULTS,d),this.$target=a(this.options.target).on("scroll.bs.affix.data-api",a.proxy(this.checkPosition,this)).on("click.bs.affix.data-api",a.proxy(this.checkPositionWithEventLoop,this)),this.$element=a(b),this.affixed=null,this.unpin=null,this.pinnedOffset=null,this.checkPosition()};c.VERSION="3.3.7",c.RESET="affix affix-top affix-bottom",c.DEFAULTS={offset:0,target:window},c.prototype.getState=function(a,b,c,d){var e=this.$target.scrollTop(),f=this.$element.offset(),g=this.$target.height();if(null!=c&&"top"==this.affixed)return e<c&&"top";if("bottom"==this.affixed)return null!=c?!(e+this.unpin<=f.top)&&"bottom":!(e+g<=a-d)&&"bottom";var h=null==this.affixed,i=h?e:f.top,j=h?g:b;return null!=c&&e<=c?"top":null!=d&&i+j>=a-d&&"bottom"},c.prototype.getPinnedOffset=function(){if(this.pinnedOffset)return this.pinnedOffset;this.$element.removeClass(c.RESET).addClass("affix");var a=this.$target.scrollTop(),b=this.$element.offset();return this.pinnedOffset=b.top-a},c.prototype.checkPositionWithEventLoop=function(){setTimeout(a.proxy(this.checkPosition,this),1)},c.prototype.checkPosition=function(){if(this.$element.is(":visible")){var b=this.$element.height(),d=this.options.offset,e=d.top,f=d.bottom,g=Math.max(a(document).height(),a(document.body).height());"object"!=typeof d&&(f=e=d),"function"==typeof e&&(e=d.top(this.$element)),"function"==typeof f&&(f=d.bottom(this.$element));var h=this.getState(g,b,e,f);if(this.affixed!=h){null!=this.unpin&&this.$element.css("top","");var i="affix"+(h?"-"+h:""),j=a.Event(i+".bs.affix");if(this.$element.trigger(j),j.isDefaultPrevented())return;this.affixed=h,this.unpin="bottom"==h?this.getPinnedOffset():null,this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix","affixed")+".bs.affix")}"bottom"==h&&this.$element.offset({top:g-b-f})}};var d=a.fn.affix;a.fn.affix=b,a.fn.affix.Constructor=c,a.fn.affix.noConflict=function(){return a.fn.affix=d,this},a(window).on("load",function(){a('[data-spy="affix"]').each(function(){var c=a(this),d=c.data();d.offset=d.offset||{},null!=d.offsetBottom&&(d.offset.bottom=d.offsetBottom),null!=d.offsetTop&&(d.offset.top=d.offsetTop),b.call(c,d)})})}(jQuery);
(function() {
	'use strict';

	angular
	.module('client')
	.factory('adminData', adminData);

	/** @ngInject */
	function adminData($rootScope, $http, $q, $location) {
		var titlebarUrl = 'https://account-int-stage.trade.tt';
		var availabilityUrl = 'https://availability-dev.debesys.net/api';
		var results = [];
		var service = {
			getToken : getToken,
			updateToken : updateToken,
			getEvents : getEvents,
			updateEvent : updateEvent,
			batchUpdateEvents : batchUpdateEvents,
			batchAddEvent : batchAddEvent,
			addEvent : addEvent,
			getUsername : getUsername,
			getNotifications : getNotifications,
			postNotification : postNotification,
			editNotification : editNotification,
			deleteUpdate : deleteUpdate,
			sendEmail : sendEmail,
			data : results
		};

		return service;


		/*****************************************************************************
		Get Token
		*****************************************************************************/

		function getToken() {
			var defer = $q.defer();

			// Renew token
			function getNewToken() {
				var titlebarJsUrl = titlebarUrl + '/titlebar/js/titlebar.php?bsver=3.0&message=false&help=false';

				$.getScript(titlebarJsUrl).then(function() {
						var request = $(document.body).titlebar({
							app: 'TT Status',
							loginOnTokenFail: true,
							showApps: false,
							loginOnLogOut: true
						});

						request
							.on('token-received', function(event, token, env) {
								// Get User Name
								getUsername(token.token).then(function(name) {
									token['name'] = name;

									// Validate token contains scope
									if (token.scopes.indexOf('status/v') === -1) {
										defer.reject('User does not have permission to access this resource');
										return;
									}
									// Store token
									updateToken(token);

									defer.resolve(token);
								});
							})
							.on('token-received-failed', function(response) {
								defer.reject(response);
							});
					});
			}

			// Check if token exists
			if (localStorage && localStorage.user) {
				var user = JSON.parse(localStorage.user);

				// Check if token is expired
				if (moment().unix() < user.expiration)
					defer.resolve(user);
				else
					getNewToken();
			} else {
				getNewToken();
			}

			return defer.promise;
		}


		/*****************************************************************************
		Update Token
		*****************************************************************************/

		function updateToken(token) {
			// Clear data
			localStorage.removeItem('user');

			// Store new data
			localStorage.setItem('user', JSON.stringify(token));
		}


		/*****************************************************************************
		Handle Success
		*****************************************************************************/

		function handleSuccess(response, name) {
			results[name] = response.data;
		}


		/*****************************************************************************
		Handle Error
		*****************************************************************************/

		function handleError(response) {
			throw response;
		}


		/*****************************************************************************
		Get User Info
		*****************************************************************************/

		function uuidv4() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		}


		/*****************************************************************************
		Get User Info
		NOTE: https://admin-int-stage-sim.trade.tt is being switch to the prod url in
		the backend (src/Backend/Startup.cs).
		*****************************************************************************/

		function getUsername(token) {
			var host = $location.host();
			var adminApiUrl = 'https://admin-int-stage-sim.trade.tt/api/1/persons/me?request_id=ttstatus-' + host + '--' + uuidv4();

			return $http({
					method: 'GET',
					url : adminApiUrl,
					headers : {
						'Authorization' :'Bearer '+ token
					}
				})
				.then(function(response) {
					return response.data.aResult[0].oInfo.sFirstName + " " + response.data.aResult[0].oInfo.sLastName;
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Get Events
		*****************************************************************************/

		function getEvents(token, params) {
			var env = (params.env) ? params.env : 'ext-prod-live';
			var metric = (params.metric) ? params.metric : 'all';
			var name = (params.name) ? params.name : 'any_name';
			var approval_status = (params.approval_status) ? params.approval_status : 'Pending';
			var url = availabilityUrl + '/events/'+env+'/'+metric+'/'+name;
			var requestParam = {
				startTime: params.startTime,
				endTime: params.endTime,
				approval_status: (params.approval_status) ? params.approval_status : 'Pending'
			};

			return $http({
					method: 'GET',
					url : url,
					headers : {
						'Authorization' :'Bearer '+token
					},
					params:requestParam
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Update Events
		*****************************************************************************/

		function updateEvent(token, params) {
			var approval_status = params.approval_status;
			var status_percent = params.status_percent;
			var operator = params.operator;
			var note = params.note;
			var mod_ver = params.mod_ver;
			var url = availabilityUrl + '/event_update/'+params.env+'/'+params.metric+'/'+params.component+'/'+params.event_time+'?approval_status='+approval_status+'&operator='+operator+'&note='+note+'&mod_ver='+mod_ver;

			return $http({
					method: 'GET',
					url : url,
					headers : {
						'Authorization' :'Bearer '+token
					}
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Batch Update Events
		*****************************************************************************/

		function batchUpdateEvents(token, params) {
			var approval_status = (params.approval_status) ? 'approval_status='+params.approval_status : '';
			var operator = (params.operator) ? '&operator='+params.operator : '';
			var note = (params.note) ? '&note='+params.note : '';
			var mod_ver = (params.mod_ver) ? '&mod_ver='+params.mod_ver : '';
			var url = availabilityUrl + '/update_events/'+params.env+'?'+approval_status+operator+note+mod_ver;

			return $http({
					method: 'POST',
					url : url,
					headers : {
						'Authorization' : 'Bearer ' + token
					},
					data : {'events' : params.data}
				})
				.then(function(response) {
					return response
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Batch Update Events
		*****************************************************************************/

		function batchAddEvent(token, params) {
			var approval_status = (params.approval_status) ? 'approval_status='+params.approval_status : '';
			var operator = (params.operator) ? '&operator='+params.operator : '';
			var note = (params.note) ? '&note='+params.note : '';
			var mod_ver = (params.mod_ver) ? '&mod_ver='+params.mod_ver : '';
			var url = availabilityUrl + '/2/events_bulk_add/'+params.env+'?'+approval_status+operator+note+mod_ver;

			return $http({
					method: 'POST',
					url : url,
					headers : {
						'Authorization' : 'Bearer ' + token
					},
					data : {'events' : params.selectedComponents}
				})
				.then(function(response) {
					return response
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Add Event
		*****************************************************************************/

		function addEvent(token, params) {
			var approval_status = params.approval_status;
			var status_percent = params.status_percent;
			var operator = params.operator;
			var note = params.note;
			var mod_ver = params.mod_ver;
			var url = availabilityUrl + '/event_add/'+params.env+'/'+params.metric+'/'+params.name+'/'+params.event_time+'?approval_status='+approval_status+'&status_percent='+status_percent+'&operator='+operator+'&note='+note+'&mod_ver='+mod_ver;

			return $http({
					method: 'GET',
					url : url,
					headers : {
						'Authorization' : 'Bearer '+token
					}
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Get Notification
		*****************************************************************************/

		function getNotifications(token, params) {
			var start = (params.start_ts) ? '&start_ts='+params.start_ts : '';
			var end = (params.end_ts) ? '&end_ts='+params.end_ts : '';
			var operator = (params.operator) ? '&operator='+params.operator : '';
			var url = availabilityUrl + '/notifications/'+params.env+'?exclude_notification_status_revoked=false&admin_view=true'+start+end+operator;

			return $http({
					method: 'GET',
					url : url,
					headers : {
						'Authorization' :'Bearer '+token
					}
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Post New Notification
		*****************************************************************************/

		function postNotification(token, params) {
			var notification_type = (params.notification_type) ? '?notification_type='+params.notification_type : '';
			var notification_status = (params.notification_status) ? '&notification_status='+params.notification_status : '';
			var title = (params.title) ? '&title='+params.title : '';
			var start_ts = (params.start_ts) ? '&start_ts='+params.start_ts : '';
			var resolution_ts = (params.resolution_ts) ? '&resolution_ts='+params.resolution_ts : '';
			var message = (params.message) ? '&message='+params.message : '';
			var customer_action = (params.customer_action) ? '&customer_action='+params.customer_action : '';
			var vendor_name = (params.vendor_name) ? '&vendor_name='+params.vendor_name : '';
			var components_affected = (params.components_affected) ? '&components_affected='+params.components_affected : '';
			var operator = (params.operator) ? '&operator='+params.operator : '';

			var url = availabilityUrl + '/notifications/'+
				params.env+
				notification_type+
				notification_status+
				title+
				start_ts+
				resolution_ts+
				message+
				customer_action+
				vendor_name+
				components_affected+
				operator;

			return $http({
					method: 'POST',
					url : url,
					headers : {
						'Authorization' :'Bearer '+token
					}
				})
				.then(function(response) {
					return response
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Edit Notification
		*****************************************************************************/

		function editNotification(token, params) {
			var notification_status = (params.notification_status) ? 'notification_status='+params.notification_status : '';
			var title = (params.title) ? '&title='+params.title : '';
			var start_ts = (params.start_ts) ? '&start_ts='+params.start_ts : '';
			var resolution_ts = (params.resolution_ts) ? '&resolution_ts='+params.resolution_ts : '';
			var message = (params.message) ? '&message='+params.message : '';
			var customer_action = (params.customer_action) ? '&customer_action='+params.customer_action : '';
			var vendor_name = (params.vendor_name) ? '&vendor_name='+params.vendor_name : '';
			var message_index = (params.message_index) ? '&message_index='+params.message_index : '';
			var message_ts = (params.message_ts) ? '&message_ts='+params.message_ts : '';
			var components_affected = (params.components_affected) ? '&components_affected='+params.components_affected : '';
			var operator = (params.operator) ? '&operator='+params.operator : '';

			var url =  availabilityUrl + '/notifications/'+params.env+'/'+params.notification_id+'?'+
				notification_status+
				title+
				start_ts+
				resolution_ts+
				message+
				customer_action+
				vendor_name+
				message_index+
				message_ts+
				components_affected+
				operator;

			return $http({
					method: 'PUT',
					url : url,
					headers : {
						'Authorization' :'Bearer '+token
					}
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Send Email
		*****************************************************************************/

		function sendEmail(token, url, params) {
			var content = {
				mailChimpName: params.title,
				emailSubject: params.title,
				emailBody: params.body
			};

			return $http({
					method: 'POST',
					url : url,
					data: content,
					headers : {
						'Authorization':'Bearer '+token,
						'Content-Type':'application/json'
					}
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}


		/*****************************************************************************
		Delete Update
		*****************************************************************************/

		function deleteUpdate(token, params) {
			var url =  availabilityUrl + '/notification/'+params.env+'/'+params.notification_id+'?message_index='+params.message_index+'&operator='+params.operator;
			return $http({
					method: 'DELETE',
					url : url,
					headers : {
						'Authorization' :'Bearer '+token
					}
				})
				.then(function(response) {
					return response.data
				})
				.catch(handleError);
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.controller('NotifyController', NotifyController);

	/** @ngInject */
	function NotifyController($scope, $q, $filter, $state, $stateParams, $uibModal, statusData, adminData, $sce) {
		// Data
		$scope.systemEnv = '';
		$scope.environment = statusData.env;
		$scope.events = [];
		$scope.servicesList = [];
		$scope.componentsList = [];
		$scope.notifications = [];
		$scope.newNotification = {
			selectedComponent : undefined,
			notification_type : '',
			title : '',
			start_ts : new Date(moment().unix()*1000),
			resolution_ts : new Date(moment().unix()*1000),
			message : '',
			customer_action : '',
			components_affected : [],
			markResolved : false,
			sendEmail : false
		};

		// UI
		$scope.requestStatus = {
			display: true,
			type: 'loading',
			details: 'One moment...'
		};
		$scope.listFilter = {};
		$scope.timeRange = 'week';
		$scope.timeStart = moment().subtract(7, 'days').unix();
		$scope.timeEnd = moment().unix();
		$scope.tinymceOptions = {
			menubar: false,
			skin: false,
			inline_styles: true,
			browser_spellcheck: true,
			plugins: 'link image code lists textcolor',
			toolbar: 'numlist bullist | addCustomerImpact addCustomerAction',
			height: '150',
			setup: function(editor) {
				// Add Customer Impact Button
				editor.addButton('addCustomerImpact', {
					text: 'Impact',
					icon: 'plus',
					onclick: function() {
						editor.insertContent('<br><p class="customer-impact"><strong><small class="glyphicon glyphicon-asterisk"></small> Impact:</strong>&nbsp;</p>');
					}
				});
				// Add Customer Action Button
				editor.addButton('addCustomerAction', {
					text: 'Customer Action',
					icon: 'plus',
					onclick: function() {
						editor.insertContent('<br><p class="customer-action"><strong><small class="glyphicon glyphicon-asterisk"></small> Customer Action:</strong>&nbsp;</p>');
					}
				});
			}
		};

		// Action
		$scope.toggleForm = toggleForm;
		$scope.updateTimeRange = updateTimeRange;
		$scope.removeAffected = removeAffected;
		$scope.addAffected = addAffected;
		$scope.addMultiple = addMultiple;
		$scope.postNotification = postNotification;
		$scope.postUpdate = postUpdate;
		$scope.editNotification = editNotification;
		$scope.clearNotificationForm = clearNotificationForm;
		$scope.editUpdate = editUpdate;
		$scope.deleteUpdate = deleteUpdate;


		/*****************************************************************************
		Set Mailchimp URL
		*****************************************************************************/
		var mailChimpURL = '';

		statusData.getSystemEnv().then(function(response) {
			$scope.systemEnv = response.data.environment;

			if ($scope.systemEnv === 'Staging') {
				mailChimpURL =  'https://9w5iws0pb8.execute-api.us-east-1.amazonaws.com/staging';
			}
			else if ($scope.systemEnv === 'Production') {
				mailChimpURL = 'https://9w5iws0pb8.execute-api.us-east-1.amazonaws.com/production';
			}
		});


		/*****************************************************************************
		Update Environment
		*****************************************************************************/

		if ($stateParams.environment)  {
			$scope.environment = $stateParams.environment;

			statusData.updateEnv($stateParams.environment);
		}


		/*****************************************************************************
		Get Token
		*****************************************************************************/

		function getToken() {
			return adminData.getToken()
				.then(function(token) {
					return token;
				})
				.catch(function(response) {
					$scope.requestStatus = {
						display : true,
						type : 'error',
						details : 'You are not authorized.'
					}

					return response;
				});
		}


		/*****************************************************************************
		Get list of services first, if not present
		*****************************************************************************/

		function getLists() {
			return statusData.getLists($scope.environment)
				.then(function(response) {
					// Clear lists
					$scope.servicesList = [];
					$scope.componentsList = [];

					// Apply new data
					$scope.servicesList = response.services;
					$scope.componentsList = response.components;

					return response;
				});
		}

		// Get components & services list on load
		getLists();


		/*****************************************************************************
		Get list of services first, if not present
		*****************************************************************************/

		function getNotifications(user) {
			var params = {
				env: $scope.environment,
				start_ts: $scope.timeStart,
				end_ts: $scope.timeEnd,
				operator: user.name
			};

			// Clear prev data
			$scope.notifications = [];

			return adminData.getNotifications(user.token, params)
				.then(function(response) {
					$scope.notifications = (response.notifications) ? response.notifications : [];

					// Update request state
					$scope.requestStatus = {
						display : false,
						type : 'success'
					}

					return response;
				})
				.catch(function(response) {
					$scope.requestStatus = {
						display : true,
						type : 'error',
						details : 'We are unable to retrieve the data. Please try refreshing the page.'
					}

					return response;
				});
		}


		/*****************************************************************************
		HTML Email Functions
		Note: Used when sending New Notifications and Update Notifications
		*****************************************************************************/

		function formatType(type) {
			switch(type) {
				case 1:
					type = 'General';
					break;
				case 2:
					type = 'Disruption';
					break;
				case 3:
					type = 'Maintenance';
					break;
				case 4:
					type = 'Provider';
					break;
				case 5:
					type = 'Outage';
					break;
			}

			return type;
		}
		function getColor(type) {
			var color = '#000';

			switch(type) {
				// General
				case 1:
				// Maintenance
				case 3:
					color = '#31708f';
					break;
				// Disruption
				case 2:
					color = '#ec971f';
					break;
				// Provider
				case 4:
				// Outage
				case 5:
					color = '#a94442';
					break;
			}

			return color;
		}
		function getIcon(type) {
			var iconUrl = '#000';

			switch(type) {
				// General
				case 1:
				// Maintenance
				case 3:
					iconUrl = 'https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/85a24727-6de3-4754-be62-30bbf6a6e896.png';
					break;
				// Disruption
				case 2:
					iconUrl = 'https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/0330cefd-7bd9-4cba-bcbc-3e16d2d85063.png';
					break;
				// Provider
				case 4:
					iconUrl = 'https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/587326aa-ae13-459f-84d8-6dacf67bc687.png';
					break;
				// Outage
				case 5:
					iconUrl = 'https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/62f8f473-1f3d-4bd8-8c32-4df8d65a49cc.png';
					break;
			}

			return iconUrl;
		}
		function getComponentNames(components) {
			var componentHtml = '';

			angular.forEach(components, function(component) {
				var prettyComponentName = $filter('prettyComponent')(component.name, $scope.componentsList);
				var prettyMetricName = $filter('prettyService')(component.metric, $scope.servicesList);
				var html = '<span style="display:inline-block;padding:3px 10px;background-color:#ddd;border-radius:4px;margin:0 5px 5px 0;">'+prettyMetricName+' : '+prettyComponentName+'</span>';

				if (prettyMetricName) {
					componentHtml = componentHtml + html;
				}
			});

			return componentHtml;
		}
		function getFullThread(messages) {
			var messageHtml = '';

			angular.forEach(messages, function(message, i) {
				if (i===0) {
					return;
				}

				var ts = moment.utc(parseInt(message.ts, 10)*1000).format('MM/DD/YY h:mma z');
				var html =
				'<div style="margin-bottom:30px;">'+
					'<h3 style="margin:0 0 5px;font-size:13px;color:#4a4a4a;">'+
						ts + ' | Update'+
					'</h3>'+
					'<p style="margin:0 0 5px;font-size:13px;color:#4a4a4a;">'+
						message.message +
					'</p>'+
					(message.customer_action ? '<p style="margin:0 0 5px;font-size:13px;color:#7d7d7d;">Customer action: ' + message.customer_action +'</p>' : '') +
				'</div>';

				messageHtml = messageHtml + html;
			});

			return messageHtml;
		}


		/*****************************************************************************
		Post New Notification
		NOTE: Shows confirmation modal
		*****************************************************************************/

		function postNotification(notification, type) {
			var modalInstance = $uibModal.open({
				windowClass: 'confirm-post',
				templateUrl: 'confirmPost.html',
				controller: PostModalController,
				controllerAs: '$ctrl',
				resolve: {
					notification: function () {
						return notification;
					},
					type: function () {
						return type;
					}
				}
			})
			// Workaround to silence error, triggered by dismissing modal
			// This error is caused by the latest update of Angularjs
			.result.then(function(){}, function(r){});
		}

		// Modal Controller
		function PostModalController($uibModalInstance, notification, type) {
			var $ctrl = this;
			var components_affected = function() {
				var data = [];

				angular.forEach(notification.components_affected, function(obj) {
					data.push({
						name: obj.name,
						metric: obj.metric
					});
				});

				if (data.length) {
					return JSON.stringify(data);
				} else {
					return '';
				}
			};

			// Data
			$ctrl.notification = notification;
			$ctrl.servicesList = $scope.servicesList;
			$ctrl.componentsList = $scope.componentsList;

			// UI
			$ctrl.requestStatus = {
				display: false,
				type: 'success',
				details: ''
			};

			// Actions
			$ctrl.ok = ok;
			$ctrl.cancel = cancel;

			// Confirm Post
			function newNotification(user) {
				var params = {
					env: $scope.environment,
					notification_type: notification.notification_type,
					notification_status: (notification.markResolved) ? 4 : 2,
					title: notification.title,
					start_ts: moment(notification.start_ts).unix(),
					resolution_ts: (notification.markResolved) ? moment(notification.resolution_ts).unix() : '',
					message: encodeURIComponent(notification.message),
					customer_action: notification.customer_action,
					vendor_name: notification.vendor_name,
					components_affected: components_affected(),
					operator: user.name
				};

				// Show loading
				$ctrl.requestStatus = {
					display: true,
					type: 'loading',
					details: 'One moment...'
				};

				adminData.postNotification(user.token, params)
					.then(function(response) {
						// Send Email
						if (notification.sendEmail) {
							var template =
									'<html>'+
										'<head>'+
											'<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />'+
											'<title>TT Status Notification</title>'+
											'<style type="text/css">'+
												'#outlook a{padding:0;}'+
												'body{width:100% !important;} .ReadMsgBody{width:100%;} .ExternalClass{width:100%;}'+
												'body{-webkit-text-size-adjust:none;}'+
												'body{margin:0; padding:0;}'+
												'img{border:0; outline:none; text-decoration:none;}'+
												'table td{border-collapse:collapse;}'+
												'#backgroundTable{height:100% !important; margin:0; padding:0; width:100% !important;}'+
											'</style>'+
										'</head>'+
										'<body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0" height="100%" width="100%" style="background-color:#dedede;font-weight:normal;font-size:14px;font-family:Arial,sans-serif;">'+
											'<table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" bgcolor="#dedede">'+
												'<tr>'+
													'<td height="20" style="height:20px;">&nbsp;</td>'+
												'</tr>'+
												'<tr>'+
													'<td align="center" valign="top">'+
														'<table border="0" cellspacing="0" width="600" bgcolor="#ffffff" style="padding: 20px 0;">'+
															'<tr>'+
																'<td style="padding:0 30px 20px 30px;">'+
																	'<img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/b8c68769-153e-42f7-a9d6-6665981d57e8.png" alt="Trading Technologies" title="Trading Technologies"/>'+
																'</td>'+
															'</tr>'+
															'<tr>'+
																'<td valign="top" style="max-width:600px;padding:0 30px 60px 30px;color:#4a4a4a;font-size:16px;">'+
																	'<center><h1>TT Status Notification</h1></center>'+
																	'<div style="margin-bottom:60px;padding:20px;background-color:#f6f6f6;">'+
																		'<div style="font-size:13px;">'+
																			'<span style="display:inline-block;margin:0 20px 10px 0;color:'+ getColor(notification.notification_type) +'">'+
																				'<img src="'+ getIcon(notification.notification_type) +'" height="12" width="14" /> '+ formatType(notification.notification_type) + (notification.notification_type===4 ? ': ' + notification.vendor_name : '') +
																			'</span>'+
																			'<span style="display:inline-block;margin-bottom:10px;"><span style="color:#7d7d7d;">Environment:</span> '+ $filter('prettyEnv')($scope.environment) +'</span>'+
																		'</div>'+
																		'<div style="font-size:13px;">'+
																			'<span style="display:inline-block;margin:0 20px 10px 0;">'+
																				'<span style="display:inline-block;color:#7d7d7d;"><img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/3729fc60-3658-4cbe-9bed-9184a71d6415.png" height="12" width="14" />Started: </span>'+
																				'<span style="display:inline-block;">'+ moment.utc(notification.start_ts).format('MM/DD/YY h:mma z') +'</span>'+
																			'</span>'+
																			(notification.markResolved ? '<span style="display:inline-block;"><span style="display:inline-block;color:#3C763D;"><img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/019efabe-efba-4b18-8850-192e247f8d43.png" height="12" width="14" /> Resolved: </span><span style="display:inline-block;">'+ moment.utc(notification.resolution_ts).format('MM/DD/YY h:mma z') +'</span></span>' : '') +
																		'</div>'+
																		(notification.components_affected && notification.components_affected.length ? '<div style="margin-top:15px;font-size:13px;"><span style="display:inline-block;color:#7d7d7d;">Affected:</span><div>'+getComponentNames(notification.components_affected)+'</div></div>' : '') +
																	'</div>'+
																	'<div style="margin-bottom:60px;">'+
																		'<div style="margin-bottom:20px;">'+
																			'<h2 style="margin-bottom:10px;color:#4a4a4a;font-size:26px;line-height:30px;font-weight:normal;">'+ notification.title +'</h2>'+
																			'<p style="margin-top:0px;color:#4a4a4a;">'+ notification.message +'</p>'+
																		'</div>'+
																		(notification.customer_action ? '<div><h2 style="margin-bottom:5px;color:#7d7d7d;font-weight:normal;font-size:16px;">Customer Action:</h2><p style="margin-top:0px;">'+ notification.customer_action +'</p></div>' : '')+
																	'</div>'+
																	'<div style="margin-bottom:30px;border-top:1px solid #ddd;font-size:13px;">'+
																		'<p>If you have any questions, please contact TT Support:</p>'+
																		'<table width="100%" style="margin-bottom:50px;font-size:13px;">'+
																			'<tr>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">U.S. Toll Free:</span> <span style="display:inline-block;color:#4a4a4a;">+1 877 424 8844</span></td>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Singapore:</span> <span style="display:inline-block;color:#4a4a4a;">+65 6395 7002</span></td>'+
																			'</tr>'+
																			'<tr>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Chicago:</span> <span style="display:inline-block;color:#4a4a4a;">+1 312 476 1002</span></td>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Sydney:</span> <span style="display:inline-block;color:#4a4a4a;">+61 2 8022 1702</span></td>'+
																			'</tr>'+
																			'<tr>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">London:</span> <span style="display:inline-block;color:#4a4a4a;">+44 20 7621 8181</span></td>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Tokyo:</span> <span style="display:inline-block;color:#4a4a4a;">+81 3 4577 8345</span></td>'+
																			'</tr>'+
																		'</table>'+
																		'<p>For the real-time status of all TT services, visit <a href="https://status.trade.tt" style="color:#21a4a6;">TT Status</a>.</p>'+
																	'</div>'+
																'</td>'+
															'</tr>'+
															'<tr>'+
																'<td style="padding-top:10px;padding:10px 30px 0 30px;border-top:solid 1px #d9d9d9;">'+
																	'<p style="line-height:130%;color:#7b7b7b;font-size:11px;">'+
																		'Please do not reply to this email. Replies are not monitored or answered. To reach a live person at TT, visit <a href="https://www.tradingtechnologies.com/contact" style="color:#21a4a6;">https://www.tradingtechnologies.com/contact</a>.'+
																	'</p>'+
																'</td>'+
															'</tr>'+
														'</table>'+
													'</td>'+
												'</tr>'+
											'</table>'+
										'</body>'+
									'</html>';
							var email = {
								title: 'TT Status Notification: ' + notification.title,
								body: template
							};

							// Show loading
							$ctrl.requestStatus = {
								display: true,
								type: 'loading',
								details: 'Notification posted. Sending email...'
							};

							adminData.sendEmail(user.token, mailChimpURL, email)
								.then(function(response) {
									// Show confirmation
									$ctrl.requestStatus = {
										display: true,
										type: 'success',
										details: 'The notification was posted and the email successfully sent.'
									};
								})
								.catch(function(error) {
									// Show Error
									$ctrl.requestStatus = {
										display: true,
										type: 'error',
										details: 'The notification was posted, but we were unable to send the email.'
									};
								});
						} else {
							// Show confirmation
							$ctrl.requestStatus = {
								display: true,
								type: 'success',
								details: 'Notification successfully posted.'
							};
						}

						// Get new data
						getNotifications(user);

						// Clear add notification form
						$scope.clearNotificationForm();

						return response;
					})
					.catch(function(error) {
						// Show Error
						$ctrl.requestStatus = {
							display: true,
							type: 'error',
							details: 'Something went wrong. We were unable to complete your request.'
						};

						return error;
					});
			}

			// Submit
			function ok() {
				getToken().then(newNotification);
			}

			// Cancel
			function cancel() {
				$uibModalInstance.dismiss('cancel');
			}
		}


		/*****************************************************************************
		Edit Notification
		*****************************************************************************/

		function editNotification(notification) {
			return getToken().then(function(user) {
				var status = '';
				var components_affected = function() {
					var data = [];

					angular.forEach(notification.components_affected, function(obj) {
						data.push({
							name: obj.name,
							metric: obj.metric
						});
					});

					if (data.length) {
						return JSON.stringify(data);
					} else {
						return '';
					}
				};

				// Marking as resolved
				if (notification.updateStatusResolved) {
					status = 4;

					// Set message time and resolution time to be the same.
					notification.message_ts = notification.resolution_ts;
				}

				// Editing a resolved notification
				if (notification.notification_status===4) {
					status = 4;
				}
				if (notification.updateStatusRevoke || notification.notification_status===3) {
					status = 3;
				}

				// Add resolution_ts only for revoked and resolved notifications
				if (!status) {
					notification.resolution_ts = '';
				}

				var params = {
					env : $scope.environment,
					notification_id : notification.notification_id,
					notification_status : status,
					title : notification.title,
					start_ts : (notification.newStartTime) ? moment(notification.newStartTime).unix() : '',
					resolution_ts : (notification.resolution_ts) ? moment(notification.resolution_ts).unix() : '',
					message : notification.updateMessage,
					customer_action : notification.customer_action,
					vendor_name : notification.vendor_name,
					message_index : (notification.message_index) ? notification.message_index : 0,
					message_ts : (notification.message_ts) ? moment(notification.message_ts).unix() : 0,
					components_affected : components_affected(),
					operator : user.name
				};

				return adminData.editNotification(user.token, params)
					.then(function(response) {
						getNotifications(user);

						return response;
					}).catch(function(response) {
						$scope.requestStatus = {
							display : true,
							type : 'error',
							details : 'Something went wrong. We were unable to complete your request.'
						}

						return response;
					});
			});
		}


		/*****************************************************************************
		Post Notification Update
		NOTE: Shows confirmation modal
		*****************************************************************************/

		function postUpdate(notification) {
			var modalInstance = $uibModal.open({
				windowClass: 'post-update',
				templateUrl: 'postUpdate.html',
				controller: postUpdateModalController,
				controllerAs: '$ctrl',
				resolve: {
					notification: function () {
						return notification;
					}
				}
			})
			// Workaround to silence error, triggered by dismissing modal
			// This error is caused by the latest update of Angularjs
			.result.then(function(){}, function(r){});
		}

		// Modal Controller
		function postUpdateModalController($uibModalInstance, notification) {
			var $ctrl = this;
			var components_affected = function() {
				var data = [];

				angular.forEach(notification.components_affected, function(obj) {
					data.push({
						name: obj.name,
						metric: obj.metric
					});
				});

				if (data.length) {
					return JSON.stringify(data);
				} else {
					return '';
				}
			};

			// Data
			$ctrl.notification = notification;
			$ctrl.servicesList = $scope.servicesList;
			$ctrl.componentsList = $scope.componentsList;

			// UI
			$ctrl.requestStatus = {
				display: false,
				type: 'success',
				details: ''
			};

			// Actions
			$ctrl.ok = ok;
			$ctrl.cancel = cancel;

			// Mark notification as Revoked
			if (notification.updateStatusRevoke) {
				notification.notification_status = 3;
			}

			// Mark notification as Resolved
			if (notification.updateStatusResolved) {
				notification.notification_status = 4;
			}

			// Post Update
			function updateNotification(user) {
				var params = {
					env : $scope.environment,
					notification_id : notification.notification_id,
					notification_status : notification.notification_status,
					title : notification.title,
					start_ts : (notification.newStartTime) ? moment(notification.newStartTime).unix() : '',
					resolution_ts : (notification.resolution_ts) ? moment(notification.resolution_ts).unix() : '',
					message : encodeURIComponent(notification.updateMessage),
					customer_action : notification.customer_action,
					vendor_name : notification.vendor_name,
					message_index : (notification.message_index) ? notification.message_index : 0,
					message_ts : (notification.message_ts) ? moment(notification.message_ts).unix() : 0,
					components_affected : components_affected(),
					operator : user.name
				};

				// Show loading
				$ctrl.requestStatus = {
					display: true,
					type: 'loading',
					details: 'One moment...'
				};

				adminData.editNotification(user.token, params)
					.then(function(response) {

						if (notification.sendEmail) {
							var template =
									'<html>'+
										'<head>'+
											'<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />'+
											'<title>TT Status Notification</title>'+
											'<style type="text/css">'+
												'#outlook a{padding:0;}'+
												'body{width:100% !important;} .ReadMsgBody{width:100%;} .ExternalClass{width:100%;}'+
												'body{-webkit-text-size-adjust:none;}'+
												'body{margin:0; padding:0;}'+
												'img{border:0; outline:none; text-decoration:none;}'+
												'table td{border-collapse:collapse;}'+
												'#backgroundTable{height:100% !important; margin:0; padding:0; width:100% !important;}'+
											'</style>'+
										'</head>'+
										'<body leftmargin="0" marginwidth="0" topmargin="0" marginheight="0" offset="0" height="100%" width="100%" style="background-color:#dedede;font-weight:normal;font-size:14px;font-family:Arial,sans-serif;">'+
											'<table border="0" cellpadding="0" cellspacing="0" height="100%" width="100%" bgcolor="#dedede">'+
												'<tr>'+
													'<td height="20" style="height:20px;">&nbsp;</td>'+
												'</tr>'+
												'<tr>'+
													'<td align="center" valign="top">'+
														'<table border="0" cellspacing="0" width="600" bgcolor="#ffffff" style="padding: 20px 0;">'+
															'<tr>'+
																'<td style="padding:0 30px 20px 30px;">'+
																	'<img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/b8c68769-153e-42f7-a9d6-6665981d57e8.png" alt="Trading Technologies" title="Trading Technologies"/>'+
																'</td>'+
															'</tr>'+
															'<tr>'+
																'<td valign="top" style="max-width:600px;padding:0 30px 60px 30px;color:#4a4a4a;font-size:16px;">'+
																	'<center><h1 style="color:#4a4a4a;">TT Status Notification Update</h1></center>'+
																	'<div style="margin-bottom:60px;padding:20px;background-color:#f6f6f6;">'+
																		'<div style="font-size:13px;">'+
																			'<span style="display:inline-block;margin:0 20px 10px 0;color:'+ getColor(notification.notification_type) +'">'+
																				'<img src="'+ getIcon(notification.notification_type) +'" height="12" width="14" /> '+ formatType(notification.notification_type) + (notification.notification_type===4 ? ': ' + notification.vendor_name : '') +
																			'</span>'+
																			'<span style="display:inline-block;margin-bottom:10px;"><span style="color:#7d7d7d;">Environment:</span> '+ $filter('prettyEnv')($scope.environment) +'</span>'+
																		'<div style="font-size:13px;">'+
																		'</div>'+
																			'<span style="display:inline-block;margin:0 20px 10px 0;">'+
																				'<span style="display:inline-block;color:#7d7d7d;"><img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/3729fc60-3658-4cbe-9bed-9184a71d6415.png" height="12" width="14" /> Started: </span>'+
																				'<span style="display:inline-block;">'+ moment.utc(parseInt(notification.start_ts)*1000).format('MM/DD/YY h:mma z') +'</span>'+
																			'</span>'+
																			(notification.updateStatusResolved || notification.notification_status===4 ? '<span style="display:inline-block;"><span style="color:#3C763D;"><img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/019efabe-efba-4b18-8850-192e247f8d43.png" height="12" width="14" /> Resolved: </span><span style="display:inline-block;">'+ moment.utc(notification.resolution_ts).format('MM/DD/YY h:mma z') +'</span></span>' : '') +
																			(notification.updateStatusRevoke || notification.notification_status===3 ? '<span style="display:inline-block;"><span style="color:#a94442;"><img src="https://gallery.mailchimp.com/28c68b7375223b0bd44b45cda/images/7e6cd4c2-06b6-419b-a2f4-a7581da3e459.png" height="12" width="14" /> Revoked</span></span>' : '') +
																		'</div>'+
																		(notification.components_affected && notification.components_affected.length ? '<div style="margin-top:15px;font-size:13px;"><span style="display:inline-block;margin-bottom:5px;color:#7d7d7d;">Affected:</span><div>'+getComponentNames(notification.components_affected)+'</div></div>' : '') +
																	'</div>'+
																	'<div style="margin-bottom:60px;">'+
																		'<div style="margin-bottom:20px;">'+
																			'<h2 style="margin-bottom:10px;color:#4a4a4a;font-size:26px;line-height:30px;font-weight:normal;">Re: '+ notification.title +'</h2>'+
																			'<h2 style="margin-bottom:5px;color:#7d7d7d;font-weight:normal;font-size:16px;">Latest Update:</h2>'+
																			'<p style="margin-top:0px;color:#4a4a4a;">'+ notification.updateMessage +'</p>'+
																		'</div>'+
																		(notification.customer_action ? '<div><h2 style="margin-bottom:5px;color:#7d7d7d;font-weight:normal;font-size:16px;">Customer Action:</h2><p style="margin-top:0px;">'+ notification.customer_action +'</p></div>' : '')+
																	'</div>'+
																	'<div style="margin-bottom:60px;">'+
																		'<h2 style="margin:0 0 20px;color:#4a4a4a;font-size:26px;line-height:30px;font-weight:normal;">Previous Notifications</h2>'+
																		'<div style="margin-bottom:30px;">'+
																			'<h3 style="margin:0 0 5px;font-size:13px;color:#4a4a4a;">' + moment.utc(parseInt(notification.start_ts, 10)*1000).format('MM/DD/YY h:mma z') + ' | ' + notification.title + '</h3>'+
																			'<p style="margin:0 0 5px;font-size:13px;color:#4a4a4a;">' + notification.messages[0].message + '</p>'+
																			(notification.messages[0].customer_action ? '<p style="margin:0 0 5px;font-size:13px;color:#7d7d7d;">Customer action: ' + notification.messages[0].customer_action +'</p>' : '') +
																		'</div>'+
																		getFullThread(notification.messages)+
																	'</div>'+
																	'<div style="margin-bottom:30px;border-top:1px solid #ddd;font-size:13px;">'+
																		'<p>If you have any questions, please contact TT Support:</p>'+
																		'<table width="100%" style="margin-bottom:50px;font-size:13px;">'+
																			'<tr>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">U.S. Toll Free:</span> <span style="display:inline-block;color:#4a4a4a;">+1 877 424 8844</span></td>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Singapore:</span> <span style="display:inline-block;color:#4a4a4a;">+65 6395 7002</span></td>'+
																			'</tr>'+
																			'<tr>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Chicago:</span> <span style="display:inline-block;color:#4a4a4a;">+1 312 476 1002</span></td>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Sydney:</span> <span style="display:inline-block;color:#4a4a4a;">+61 2 8022 1702</span></td>'+
																			'</tr>'+
																			'<tr>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">London:</span> <span style="display:inline-block;color:#4a4a4a;">+44 20 7621 8181</span></td>'+
																				'<td style="padding:5px 0;"><span style="display:inline-block;color:#7d7d7d">Tokyo:</span> <span style="display:inline-block;color:#4a4a4a;">+81 3 4577 8345</span></td>'+
																			'</tr>'+
																		'</table>'+
																		'<p>For the real-time status of all TT services, visit <a href="https://status.trade.tt" style="color:#21a4a6;">TT Status</a>.</p>'+
																	'</div>'+
																'</td>'+
															'</tr>'+
															'<tr>'+
																'<td style="padding-top:10px;padding:10px 30px 0 30px;border-top:solid 1px #d9d9d9;">'+
																	'<p style="line-height:130%;color:#7b7b7b;font-size:11px;">'+
																		'Please do not reply to this email. Replies are not monitored or answered. To reach a live person at TT, visit <a href="https://www.tradingtechnologies.com/contact" style="color:#21a4a6;">https://www.tradingtechnologies.com/contact</a>.'+
																	'</p>'+
																'</td>'+
															'</tr>'+
														'</table>'+
													'</td>'+
												'</tr>'+
											'</table>'+
										'</body>'+
									'</html>';
							var email = {
								title: 'Re: TT Status Notification: ' + notification.title,
								body: template
							};

							// Update Loading message
							$ctrl.requestStatus = {
								display: true,
								type: 'loading',
								details: 'Update posted. Sending email...'
							};

							adminData.sendEmail(user.token, mailChimpURL, email)
								.then(function(response) {
									// Show confirmation
									$ctrl.requestStatus = {
										display: true,
										type: 'success',
										details: 'The update was posted and the email successfully sent.'
									};

									return response;
								})
								.catch(function(error) {
									// Show Error
									$ctrl.requestStatus = {
										display: true,
										type: 'error',
										details: 'The update was posted, but we were unable to send the email.'
									};

									return error;
								});
						} else {
							// Show confirmation
							$ctrl.requestStatus = {
								display: true,
								type: 'success',
								details: 'Update successfully posted.'
							};
						}

						getNotifications(user);

						return response;
					})
					.catch(function(error) {
						$ctrl.requestStatus = {
							display : true,
							type : 'error',
							details : 'Something went wrong. We were unable to complete your request.'
						}

						return response;
					});
			}

			// Submit
			function ok() {
				getToken().then(updateNotification);
			}

			// Cancel
			function cancel() {
				$uibModalInstance.dismiss('cancel');
			}
		}


		/*****************************************************************************
		Edit Notification Update
		*****************************************************************************/

		function editUpdate(index, message, notification) {
			var newNotification = angular.copy(notification);
			var params = {
				updateMessage : encodeURIComponent(message.copy.message),
				notification_id : notification.notification_id,
				message_index : index+1,
				message_ts: message.copy.message_ts,
				customer_action: message.copy.customer_action
			}

			editNotification(params);
		}


		/*****************************************************************************
		Clear Notification Form
		NOTE: API requires index to begin at 1 not 0
		*****************************************************************************/

		function deleteUpdate(id, index) {
			return getToken().then(function(user) {
				var params = {
					env: $scope.environment,
					notification_id: id,
					message_index: index+1,
					operator: user.name
				}

				return adminData.deleteUpdate(user.token, params)
					.then(function(response) {
						getNotifications(user);

						return response;
					}).catch(function(response) {
						$scope.requestStatus = {
							display : true,
							type : 'error',
							details : 'Something went wrong. We were unable to complete your request.'
						}

						return response;
					});
			});
		}


		/*****************************************************************************
		Update Date Range
		*****************************************************************************/

		function updateTimeRange(range) {
			$scope.timeRange = range;

			switch(range) {
				case 'hour':
					$scope.timeStart = moment().subtract(1, 'hours').unix();
					break;
				case 'day':
					$scope.timeStart = moment().subtract(1, 'days').unix();
					break;
				case 'week':
					$scope.timeStart = moment().subtract(7, 'days').unix();
					break;
				case 'month':
					$scope.timeStart = moment().subtract(30, 'days').unix();
					break;
				case 'all':
					$scope.timeStart = '';
					$scope.timeEnd = '';
					break;
			}
		}

		// Update Notifications when time range changes
		$scope.$watchGroup(['timeRange', 'timeStart'],
			function(newVal, oldVal, scope) {
				getToken().then(getNotifications);
			});


		/*****************************************************************************
		Toggle Form
		NOTE: All editing is done in the "copy" object
		*****************************************************************************/

		function toggleForm(data, showForm) {
			// Create copy of original data, used for the edit form.
			data['copy'] = angular.copy(data);

			// For Edit Form
			if (showForm==='showEdit') {

				// Set resolution timestamp, used for editing message timestamp
				if (data.resolution_ts)
					data.copy['resolution_ts'] = new Date(data.resolution_ts*1000);
			}
			// For Add Update Form
			if (showForm==='showAddUpdate') {
				data.copy['sendEmail'] = false;

				// Format resolution time
				if (data.notification_status===4)
					data.copy['resolution_ts'] = new Date(data.resolution_ts*1000);
				else
					data.copy['resolution_ts'] = new Date(moment().unix()*1000);
			}
			// For Edit Updates (Messages) Form
			if (showForm==='showEditUpdate') {
				// Set prev update timestamp, used for editing message timestamp
				data.copy['message_ts'] = new Date(data.ts*1000);
			}

			if (data[showForm]) {
				data[showForm] = false;
			} else {
				data[showForm] = true;
			}

			return data;
		}


		/*****************************************************************************
		Remove Affected Component
		*****************************************************************************/

		function removeAffected(component, collection) {
			angular.forEach(collection.components_affected, function(obj, i) {
				if(obj.metric===component.metric&&obj.name===component.name) {
					collection.components_affected.splice(i, 1);
				}
			});

			return component;
		}


		/*****************************************************************************
		Add Component to Affected Component List
		*****************************************************************************/

		function addAffected(component, collection) {
			var selected = { 'metric':component.metric, 'name':component.backendName };

			if (!collection.components_affected) {
				collection['components_affected'] = [];
			}

			// Add component to queue
			var exists = _.findIndex(collection.components_affected, selected);

			if (exists<0) {
				collection['components_affected'].push(selected);
			}

			// Clear input
			collection['selectedComponent'] = undefined;

			return component;
		}


		/*****************************************************************************
		Add Multiple Components to Affected Component List
		*****************************************************************************/

		function addMultiple() {
			var modalInstance = $uibModal.open({
				windowClass: 'add-multiple',
				templateUrl: 'addMultiple.html',
				controller: AddModalController,
				controllerAs: '$ctrl',
				resolve: {
					servicesList : function() {return $scope.servicesList},
					componentsList : function() {return $scope.componentsList},
					newNotification : function() {return $scope.newNotification},
					addAffected: function() {return $scope.addAffected},
					removeAffected: function() {return $scope.removeAffected}
				},
				size: 'lg'
			})
			// Workaround to silence error, triggered by dismissing modal
			// This error is caused by the latest update of Angularjs
			.result.then(function(){}, function(r){});
		}

		// Modal Controller
		function AddModalController($uibModalInstance, servicesList, componentsList, newNotification, addAffected, removeAffected) {
			var $ctrl = this;

			// Data
			$ctrl.servicesList = servicesList;
			$ctrl.componentsList = componentsList;
			$ctrl.newNotification = newNotification;

			// UI
			$ctrl.selectedComponent = {};

			// Actions
			$ctrl.addAll = addAll;
			$ctrl.ok = ok;
			$ctrl.cancel = cancel;
			$ctrl.addAffected = addAffected;
			$ctrl.removeAffected = removeAffected;

			function addAll() {
				var components = $filter('filter')(componentsList, $ctrl.selectedComponent.metric);

				angular.forEach(components, function(component) {
					addAffected(component, newNotification);
				});
			}

			// Submit
			function ok() {
				getToken().then();
			}

			// Cancel
			function cancel() {
				$uibModalInstance.dismiss('cancel');
			}
		}


		/*****************************************************************************
		Clear Notification Form
		*****************************************************************************/

		function clearNotificationForm() {
			$scope.newNotification = {
				selectedComponent : undefined,
				notification_type : '',
				title : '',
				start_ts : new Date(moment().unix()*1000),
				resolution_ts : new Date(moment().unix()*1000),
				message : '',
				components_affected : []
			};
		}


		/*****************************************************************************
		Update Data
		*****************************************************************************/

		$scope.$on('envUpdated', function(response, env) {
			$scope.environment = env;
			$scope.requestStatus.type = 'loading';
			$scope.requestStatus.details = 'One moment...';
			$scope.requestStatus.display = true;

			// Update URL
			$state.go('.', { environment:env }, { notify:false });

			// Get Components & Services, then get Notifications
			getLists().then(getToken().then(getNotifications));
		});

		return $scope;
	}
})();


(function() {
	'use strict';

	angular
	.module('client')
	.controller('ServiceController', ServiceController);

	/** @ngInject */
	function ServiceController($rootScope, $scope, $q, $location, $http, $state, $stateParams, $timeout, $anchorScroll, $sce, statusData) {
		// Data
		$scope.environment = statusData.env;
		$scope.availability = null;
		$scope.chart = null;
		$scope.chartParams = {};
		$scope.components = null;
		$scope.serviceName = $stateParams.name;
		$scope.metric = $stateParams.metric;
		$scope.history = [];
		$scope.servicesList = [];
		$scope.componentsList = [];
		$scope.rendered = false;

		// UI
		$scope.requestStatus = {
			display: true,
			type: 'loading',
			details: 'One moment...'
		};
		$scope.timeRange = 'hour';
		$scope.timeStart = null;
		$scope.timeEnd = null;

		// Action
		$scope.refreshChart = refreshChart;
		$scope.zoomIn = zoomIn;
		$scope.updateTimeRange = updateTimeRange;
		$scope.showDetails = showDetails;

		$scope.popoverData = {
			notifications: [],
			availability: null
		};


		/*****************************************************************************
		Update Environment
		*****************************************************************************/

		if ($stateParams.environment)  {
			$scope.environment = $stateParams.environment;

			statusData.updateEnv($stateParams.environment);
		}


		/*****************************************************************************
		Scroll to selected component
		*****************************************************************************/

		$location.hash($stateParams.component);

		function scrollTo() {
			$timeout(function() {
				$anchorScroll.yOffset = 190;
				$anchorScroll();
			}, 100)
		}


		/*****************************************************************************
		Get list of services and components first, if not present
		*****************************************************************************/

		function getLists() {
			return statusData.getLists($scope.environment, true)
				.then(function(response) {
					// Clear lists
					$scope.servicesList = [];
					$scope.componentsList = [];

					// Apply new data
					$scope.servicesList = response.services;
					$scope.componentsList = response.components;

					return response;
				});
		}
		getLists();


		/*****************************************************************************
		Get Notifications
		*****************************************************************************/

		function getNotifications() {
			return statusData.getNotifications($scope.environment)
				.then(function(response) {
					// Clear old data
					$scope.history = [];

					// Apply new data
					$scope.history = response.data.notifications;

					return response;
				});
		}


		/*****************************************************************************
		Get Chart Data
		*****************************************************************************/

		function getChartData() {
			$rootScope.$broadcast('showSpinner');
			$scope.requestStatus.type = 'loading';

			return statusData.getChartData($scope.chartParams)
				.then(function(response) {
					if ($stateParams.component) {
						scrollTo();
					}

					$scope.availability = response.availability;
					$scope.components = response.graphSubDataList;

					if (response.graphSubDataList.length) {
						$scope.timeStart = response.graphSubDataList[0].startTime;
						$scope.timeEnd = response.graphSubDataList[0].endTime;
					}

					// Update time stamp
					statusData.updateTimestamp(moment().format());

					$rootScope.$broadcast('hideSpinner');

					// Update Request Status
					$scope.requestStatus.display = false;
					$scope.requestStatus.type = 'success';

					return response;
				})
				.catch(function(response) {
					$rootScope.$broadcast('hideSpinner');

					// Update Request Status
					$scope.requestStatus.display = true;
					$scope.requestStatus.type = 'error';
					$scope.requestStatus.details = 'We are unable to retrieve the data. Please try refreshing the page.';

					return response;
				});
		}


		/*****************************************************************************
		Update Date Range
		*****************************************************************************/

		function updateTimeRange(range, end) {
			var timezone = moment.tz.guess();
			var adjEnd = (end) ? moment(end) : moment();
			var dayEnd = adjEnd.add(1, 'days').startOf('day');
			var param = {
				params : {
					service : $stateParams.name,
					component : '',
					numberOfPoints : null,
					timePeriod : '',
					start: '',
					end: '',
					timeZone: timezone,
					environment: $scope.environment,
					metric: $scope.metric
				}
			};

			switch(range) {
				case 'hour':
					// Use current time if end is undefined
					end = (end) ? moment(end).add(1, 'hours').startOf('hour').format() : moment().format();

					param.params.end = end;
					param.params.start = moment(end).subtract(1, 'hours').format();
					param.params.timePeriod = 'minutes';
					break;
				case 'day':
					// Use current time if end is undefined
					end = (end) ? moment(end).add(1, 'days').startOf('day').format() : moment().add(1, 'hours').startOf('hour').format();

					param.params.end = end;
					param.params.start = moment(end).subtract(1, 'days').format();
					param.params.timePeriod = 'hours';
					break;
				case 'week':
					param.params.end = dayEnd.format();
					param.params.start = dayEnd.subtract(7, 'days').startOf('day').format();
					param.params.timePeriod = 'days';
					break;
				case 'month':
					param.params.end = dayEnd.format();
					param.params.start = dayEnd.subtract(30, 'days').startOf('day').format();
					param.params.timePeriod = 'days';
					break;
			}

			$scope.timeRange = range;
			$scope.chartParams = param;
		}

		// Get data for default time range
		updateTimeRange($scope.timeRange);


		/*****************************************************************************
		Refresh Chart
		*****************************************************************************/

		function refreshChart() {
			var result = {};

			return $q.all([
					getChartData().then(function(r) {
						result.components=r.graphSubDataList
					}),
					getNotifications().then(function(r) {
						result.notifications=r.data.notifications
					})
				]).then(function() {
					addVendorFlag(result);

					return result;
				});
		}


		/*****************************************************************************
		Show Details (Popover)
		*****************************************************************************/

		function showDetails(data, component) {
			var pcnt = (data.availability !== -1) ? true : false;
			var selected = {
				metric : component.graphDataCriteria.metric.toLowerCase(),
				name : component.graphDataCriteria.componentBackendName.toLowerCase()
			};
			var selStart = moment(data.startTime).unix();
			var selEnd = (function() {
				switch ($scope.timeRange) {
					case 'hour':
						return moment(data.startTime).endOf('minute').unix();
						break;
					case 'day':
						return moment(data.startTime).endOf('hour').unix();
						break;
					case 'week':
					case 'month':
						return moment(data.startTime).endOf('day').unix();
						break;
				}
			})();

			// Display Availability Data
			$scope.popoverData.availability = data;

			// Clear prev notifications
			$scope.popoverData.notifications = [];

			if ($scope.history.length) {
				// Search through incident history
				angular.forEach($scope.history, function(notif) {
					if (notif.notification_type!==1) {
						var notifStart = parseInt(notif.start_ts);
						var notifEnd = (notif.resolution_ts) ? parseInt(notif.resolution_ts) : parseInt(notif.last_updated_ts);

						// Check affected components of each incident
						angular.forEach(notif.components_affected, function(obj) {
							var affected = {
								metric : obj.metric.toLowerCase(),
								name : obj.name.toLowerCase()
							};

							// Check if component matches
							if (affected.metric===selected.metric && affected.name===selected.name) {
								// Check if selected range intersects notification
								if (
									// pcnt - Availability %
									// notifStart - Notification Start Time
									// notifEnd - Notification Resolution Time
									// selStart - Selected graph bar Start Time
									// selEnd - Selected graph bar End Time
									pcnt && notif.notification_status===2 && notifStart<=selEnd ||
									pcnt && notif.notification_status!==2 && notifStart>=selStart && notifStart<=selEnd ||
									pcnt && notif.notification_status!==2 && notifEnd>=selStart && notifEnd<=selEnd ||
									pcnt && notif.notification_status!==2 && notifStart<=selStart && notifEnd>=selEnd ||
									pcnt && notif.notification_status!==2 && notifStart>=selStart && notifStart<=selEnd
									) {
									// Display relevant notification
									$scope.popoverData.notifications.push(notif);
								}
							}
						});
					}

				});
			}
		}


		/*****************************************************************************
		Vendor Issue Indicator
		*****************************************************************************/

		function addVendorFlag(data) {
			var affected = [];

			angular.forEach(data.notifications, function(notification) {
				// If vendor incident(4)
				if (notification.notification_type===4) {
					// Add start time to component object
					_.each(notification.components_affected, function(component) {
						component['start_ts'] = notification.start_ts;
						component['resolution_ts'] = notification.resolution_ts;
					});

					// Update affected list
					affected = _.union(affected, notification.components_affected);
				}
			});

			$q.all(affected).then(function(affectedList) {
				// Use Affected Component List as Reference
				angular.forEach(affectedList, function(affected) {
					var affectedComponent = _.find($scope.components, function(component) {
						if (affected.metric===$scope.metric && component.graphDataCriteria.componentBackendName===affected.name) {
							// Add flag to affected data points
							angular.forEach(component.dataPoints, function(point) {
								var pcnt = (point.availability !== -1) ? true : false;
								var incidentStart = affected.start_ts;
								var incidentEnd = affected.resolution_ts;
								var pointStart = moment(point.startTime).unix();
								var pointEnd = (function() {
									// Adjust point end time according to time range filter
									switch ($scope.timeRange) {
										case 'hour':
											return moment(point.startTime).endOf('minute').unix();
											break;
										case 'day':
											return moment(point.startTime).endOf('hour').unix();
											break;
										case 'week':
										case 'month':
											return moment(point.startTime).endOf('day').unix();
											break;
										}
								})();

								if (
									// Resolved
									pcnt && incidentEnd && incidentStart<=pointStart && incidentEnd>=pointStart || // For "hours" time range
									pcnt && incidentEnd && incidentStart<=pointEnd && incidentEnd>=pointEnd || // For "hours" time range
									pcnt && incidentEnd && incidentStart>pointStart && incidentEnd<pointEnd || // For "days" time range

									// Not resolved
									pcnt && !incidentEnd && incidentStart<=pointStart ||
									pcnt && !incidentEnd && incidentStart<=pointEnd
									) {
									point['vendor'] = true;
								}
							});

							return component;
						}
					});
				});
			});
		}


		/*****************************************************************************
		Update Data
		*****************************************************************************/

		$scope.$on('envUpdated', function(response, env) {
			$scope.environment = env;

			// Update State Parameter
			$state.go('.', { environment:env }, { notify:false });

			// Get new data
			getLists().then(function() {
				updateTimeRange($scope.timeRange);
			});
		});

		$scope.$watch('chartParams', function (newVal, oldVal) {
			$scope.rendered = false;

			refreshChart().then(function() {
				// Show chart after DOM render
				$timeout(function () {
					$scope.rendered = true;
				});
			});
		}, true);

		/*****************************************************************************
		Zoom In (Zoom into specific time range)
		*****************************************************************************/

		// 'end' needs to be in epoch (10-digit) format
		function zoomIn(end) {
			switch ($scope.timeRange) {
				case 'month':
				case 'week':
					updateTimeRange('day', end);
					break;
				case 'day':
					updateTimeRange('hour', end);
					break;
			}
		}
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.controller('ManageController', ManageController);

	/** @ngInject */
	function ManageController($scope, $q, $state, $stateParams, $uibModal, statusData, adminData, $timeout) {
		var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

		// Data
		$scope.events = [];
		$scope.environment = statusData.env;
		$scope.servicesList = [];
		$scope.componentsList = [];
		$scope.componentChart = {};
		$scope.timeRange = 'day';
		$scope.timeStart = moment().subtract(1, 'days').unix();
		$scope.timeEnd = moment().unix();
		$scope.timePeriod = '';
		$scope.selectedComponent = '';
		$scope.selectedService = '';
		$scope.selectedServiceMetric = '';
		$scope.customEvent = {
			env: $scope.environment,
			approval_status: 'Approved',
			event_time: moment().unix(),
			metric: '',
			mod_ver: 0,
			name: '',
			status_percent: '',
			operator: '',
			note: ''
		};

		// UI
		$scope.requestStatus = {
			display: true,
			type: 'loading',
			details: 'One moment...'
		};
		$scope.chartReqStatus = {
			display: false,
			type: 'success',
			details: ''
		};
		$scope.showChart = false;
		$scope.showAddEvent = false;
		$scope.eventFilter = {
			start: '',
			end: ''
		};
		$scope.pageSize = 100;

		// Actions
		$scope.getComponent = getComponent;
		$scope.updateTimeRange = updateTimeRange;
		$scope.showAll = showAll;
		$scope.toggleComment = toggleComment;
		$scope.applyAction = applyAction;
		$scope.addEvent = addEvent;
		$scope.rangeFilter = rangeFilter;
		$scope.zoomIn = zoomIn;
		$scope.refreshData = refreshData;
		$scope.batchAdd = batchAdd;


		/*****************************************************************************
		Update Environment
		*****************************************************************************/

		if ($stateParams.environment)  {
			$scope.environment = $stateParams.environment;

			statusData.updateEnv($stateParams.environment);
		}


		/*****************************************************************************
		Get Token
		*****************************************************************************/

		function getToken() {
			return adminData.getToken()
				.then(function(token) {
					return token;
				})
				.catch(function(response) {
					$scope.requestStatus = {
						display : true,
						type : 'error',
						details : 'You are not authorized.'
					}

					return response;
				});
		}


		/*****************************************************************************
		Get list of services first, if not present
		*****************************************************************************/

		function getLists() {
			return statusData.getLists($scope.environment)
				.then(function(response) {
					// Clear lists
					$scope.servicesList = [];
					$scope.componentsList = [];

					// Apply new data
					$scope.servicesList = response.services;
					$scope.componentsList = response.components;

					return response;
				});
		}

		// Get components & services list, then events, on load
		getLists().then(getToken().then(getEvents));


		/*****************************************************************************
		Refresh Lists and Events
		*****************************************************************************/

		function refreshData() {
			if ($scope.selectedComponent)
				getChartData().then(getToken().then(getEvents));
			else
				getToken().then(getEvents);
		}


		/*****************************************************************************
		Get Chart Data
		NOTE: 'end' and 'start' needs to be string format (2013-03-13T10:13:33-05:00)
		*****************************************************************************/

		function getChartData() {
			$scope.chartReqStatus.type = 'loading';
			$scope.chartReqStatus.display = true;

			var param = {
				params : {
					service : $scope.selectedService,
					component : $scope.selectedComponent,
					timePeriod : $scope.timePeriod,
					start: $scope.timeStart,
					end: $scope.timeEnd,
					timeZone: timezone,
					environment: $scope.environment,
					metric: $scope.selectedServiceMetric,
					isCached : false
				}
			};

			return statusData.getChartData(param)
				.then(function(response) {
					// Clear current chart
					$scope.componentChart = [];

					// Apply new chart
					$scope.componentChart = response.graphSubDataList[0];

					// Update Request status
					$scope.chartReqStatus.display = false;
					$scope.chartReqStatus.type = 'success';

					return response;
				})
				.catch(function(response) {
					$scope.chartReqStatus.type = 'error';
					$scope.chartReqStatus.details = 'We are unable to retrieve the data. Please try refreshing the page.';

					return response;
				});
		}


		/*****************************************************************************
		Get Events
		*****************************************************************************/

		function getEvents(user) {
			$scope.requestStatus.type = 'loading';
			$scope.requestStatus.details = 'One moment...';
			$scope.requestStatus.display = true;

			var params = {
				env : $scope.environment,
				metric : $scope.selectedServiceMetric,
				name : $scope.selectedComponent,
				startTime: moment($scope.timeStart).unix(),
				endTime: moment($scope.timeEnd).unix(),
				approval_status: 'Approved, Rejected'
			};

			return adminData.getEvents(user.token, params).then(function(response) {
				var events = []

				if (response.events) {
					events = response.events;
				}

				// Apply new events
				$scope.events = events;

				// Update 'last updated' time stamp
				statusData.updateTimestamp(moment().format());

				// Update request state
				$scope.requestStatus.display = false;
				$scope.requestStatus.type = 'success';

				return response;
			}).catch(function(response) {
				$scope.requestStatus.type = 'error';
				$scope.requestStatus.details = 'We are unable to retrieve the data. Please try refreshing the page.';

				return response;
			});
		}


		/*****************************************************************************
		Show Add Event Panel
		*****************************************************************************/

		function showAddEvent(time){
			$scope.customEvent.event_time = time;
			$scope.showAddEvent = true;
		}


		/*****************************************************************************
		Add Event
		*****************************************************************************/

		function addEvent() {
			return getToken().then(function(user) {
				var params = $scope.customEvent;

				params['metric'] = $scope.selectedServiceMetric;
				params['operator'] = user.name;
				params['event_time'] = moment(params.event_time).unix();
				params['name'] = $scope.selectedComponent;
				params['env'] = $scope.environment;

				return adminData.addEvent(user.token, params)
					.then(function(response) {
						// Reset custom event
						$scope.customEvent = {
							env: $scope.environment,
							approval_status: 'Approved',
							event_time: moment().unix(),
							metric: '',
							mod_ver: 0,
							name: '',
							status_percent: '',
							operator: '',
							note: ''
						};

						$scope.showAddEvent = false;

						// Get latest Data
						refreshData();

						// Update request state
						$scope.requestStatus = {
							display : false,
							type : 'success'
						};

						return response;
					}).catch(function(response) {
						$scope.requestStatus = {
							display : true,
							type : 'error',
							details : 'We are unable to retrieve the data. Please try refreshing the page.'
						};

						return response;
					});
			});
		}


		/*****************************************************************************
		Apply Action
		NOTE: When user approves or rejects
		*****************************************************************************/

		function applyAction(event, action) {
			return getToken().then(function(user) {
				var param = {
					env: $scope.environment,
					metric: event.metric,
					component: event.name,
					approval_status: action,
					status_percent: event.status_percent,
					operator: user.name,
					event_time: event.event_time,
					note: (event.comment) ? event.comment : '',
					mod_ver: event.mod_version
				}

				return adminData.updateEvent(user.token, param)
					.then(function(response) {
						// Get latest Data
						refreshData();

						return response;
					})
					.catch(function(response) {
						$scope.requestStatus = {
							display : true,
							type : 'error',
							details : 'We are unable to complete the actions you requested. Please refresh the page and try again.'
						};

						return response;
					});
			});
		}


		/*****************************************************************************
		Get Component Events & Chart
		*****************************************************************************/

		function getComponent(component) {
			// Show Chart
			$scope.showChart = true;

			// Update Selected Component & Service
			$scope.selectedComponent = component.backendName;
			$scope.selectedService = component.service;
			$scope.selectedServiceMetric = component.metric;
		}


		/*****************************************************************************
		Update Date Range
		*****************************************************************************/

		function updateTimeRange(range, end) {
			var adjEnd = (end) ? moment(end) : moment();
			var dayEnd = adjEnd.add(1, 'days').startOf('day');

			$scope.timeRange = range;

			switch(range) {
				case 'hour':
					// Use current time if end is undefined
					end = (end) ? moment(end).add(1, 'hours').startOf('hour').format() : moment().format();

					$scope.timeEnd = end;
					$scope.timeStart = moment(end).subtract(1, 'hours').format();
					$scope.timePeriod = 'minutes';
					break;
				case 'day':
					// Use current time if end is undefined
					end = (end) ? moment(end).add(1, 'days').startOf('day').format() : moment().add(1, 'hours').startOf('hour').format();

					$scope.timeEnd = end;
					$scope.timeStart = moment(end).subtract(1, 'days').format();
					$scope.timePeriod = 'hours';
					break;
				case 'week':
					$scope.timeEnd = dayEnd.format();
					$scope.timeStart = dayEnd.subtract(7, 'days').startOf('day').format();
					$scope.timePeriod = 'days';
					break;
				case 'month':
					$scope.timeEnd = dayEnd.format();
					$scope.timeStart = dayEnd.subtract(30, 'days').startOf('day').format();
					$scope.timePeriod = 'days';
					break;
			}
		}

		// Set initial time range
		updateTimeRange($scope.timeRange);


		/*****************************************************************************
		Time Range Filter
		NOTE: Show if event passes time range criteria
		*****************************************************************************/

		function rangeFilter(event) {
			if ($scope.showChart){
				return ((moment($scope.timeStart).unix() <= parseInt(event.event_time)) && (parseInt(event.event_time) <= moment($scope.timeEnd).unix()));
			} else {
				return true;
			}
		}


		/*****************************************************************************
		Show All
		*****************************************************************************/

		function showAll() {
			$scope.showChart = false;
			$scope.selectedComponent = '';
			$scope.selectedService = '';
			$scope.selectedServiceMetric = '';
			$scope.search = '';
		}


		/*****************************************************************************
		Toggle Comment
		NOTE: Hides and shows comment text field for each alert
		*****************************************************************************/

		function toggleComment(event) {
			if (event.showComment) {
				return event.showComment = false;
			} else {
				return event.showComment = true;
			}
		}


		/*****************************************************************************
		Zoom In (Zoom into specific time range)
		NOTE: 'end' time needs to be in epoch (10-digit) format
		*****************************************************************************/

		function zoomIn(end) {
			switch ($scope.timeRange) {
				case 'month':
				case 'week':
					updateTimeRange('day', end);
					break;
				case 'day':
					updateTimeRange('hour', end);
					break;
				case 'hour':
					showAddEvent(end);
					break;
			}
		}

		/*****************************************************************************
		Add Event to multiple components
		*****************************************************************************/

		function batchAdd() {
			var modalInstance = $uibModal.open({
				windowClass: 'modal-batch-add',
				templateUrl: 'batchAdd.html',
				controller: batchAddController,
				controllerAs: '$ctrl',
				resolve: {
					servicesList : function() {return $scope.servicesList},
					componentsList : function() {return $scope.componentsList}
				},
				size: 'lg'
			})
			// Workaround to silence error, triggered by dismissing modal
			// This error is caused by the latest update of Angularjs
			.result.then(function(){}, function(r){});
		}

		// Modal Controller
		function batchAddController($uibModalInstance, $filter, servicesList, componentsList) {
			var $ctrl = this;

			// Data
			$ctrl.servicesList = servicesList;
			$ctrl.componentsList = componentsList;
			$ctrl.selectedService = {};
			$ctrl.selectedComponents = [];
			$ctrl.eventStatus = null;
			$ctrl.eventTime = null;
			$ctrl.eventAvailability = '';
			$ctrl.eventNote = '';

			// UI
			$ctrl.showSelectTimePanel = false;
			$ctrl.showAddEventPanel = false;
			$ctrl.startTime = moment().subtract(1,'hours').format();
			$ctrl.endTime = moment().format();
			$ctrl.zoomTime = null;
			$ctrl.timeRange = 'hour';
			$ctrl.chartPoints = [];

			// Actions
			$ctrl.addAll = addAll;
			$ctrl.ok = ok;
			$ctrl.cancel = cancel;
			$ctrl.addAffected = addAffected;
			$ctrl.removeAffected = removeAffected;
			$ctrl.zoomIn = zoomIn;


			// Remove Affected Component
			function removeAffected(component, collection) {
				angular.forEach(collection, function(obj, i) {
					if(obj.metric===component.metric&&obj.name===component.name) {
						collection.splice(i, 1);
					}
				});

				return component;
			}

			// Add Component to Affected Component List
			function addAffected(component, collection) {
				var selected = { 'metric':component.metric, 'name':component.backendName };

				if (!collection) {
					collection = [];
				}

				// Add component to queue
				var exists = _.findIndex(collection, selected);

				if (exists<0) {
					collection.push(selected);
				}

				// Clear input
				collection = undefined;

				return component;
			}

			// Add all components
			function addAll() {
				var components = $filter('filter')(componentsList, $ctrl.selectedService.metric);

				angular.forEach(components, function(component) {
					addAffected(component, $ctrl.selectedComponents);
				});
			}

			// Generate points for time picker chart
			function updateChart() {
				var startTime;
				var endTime;
				var chartData = [];
				var points;
				var unit;

				switch ($ctrl.timeRange) {
					case 'hour':
						points = 60;
						unit = 'minutes';
						// True if Zooming In, see zoomIn()
						startTime = ($ctrl.zoomTime) ? moment($ctrl.zoomTime).subtract(1,'minutes').format() : moment().startOf('minute').subtract(1,'hours').format();
						endTime = ($ctrl.zoomTime) ? moment($ctrl.zoomTime).endOf('hour').format() : moment().format();
						break;
					case 'day':
						points = 24;
						unit = 'hours';
						// True if Zooming In, see zoomIn()
						startTime = ($ctrl.zoomTime) ? moment($ctrl.zoomTime).subtract(1,'hours').format() : moment().startOf('hour').subtract(24,'hours').format();
						endTime = ($ctrl.zoomTime) ? moment($ctrl.zoomTime).endOf('day').format() : moment().format();
						break;
					case 'week':
						points = 7;
						unit = 'days';
						startTime = moment().startOf('day').subtract(7,'days').format();
						endTime = moment().endOf('day').format();
						break;
					case 'month':
						points = 30;
						unit = 'days';
						startTime = moment().startOf('day').subtract(30,'days').format();
						endTime = moment().endOf('day').format();
						break;
				}

				// Build array for chart data
				for (var i=0; i<points; i++) {
					var data = {
						'startTime' : moment(startTime).add(i+1,unit).unix() * 1000
					};

					chartData.push(data);
				}

				// Update model with new chart data
				$q.all(chartData).then(function() {
					$ctrl.chartData = chartData;
					$ctrl.startTime = chartData[0].startTime;
					$ctrl.endTime = endTime;

					return chartData;
				});
			}

			// Update chart when "Time Range" changes
			$scope.$watch(function() {return $ctrl.timeRange}, function(newV,oldV) {
				updateChart();
			});

			// Zoom In
			function zoomIn(zoomTime) {
				switch ($ctrl.timeRange) {
					case 'month':
					case 'week':
						$ctrl.zoomTime = zoomTime;
						$ctrl.timeRange = 'day';
						break;
					case 'day':
						$ctrl.zoomTime = zoomTime;
						$ctrl.timeRange = 'hour';
						break;
					case 'hour':
						$ctrl.showAddEventPanel = true;
						$ctrl.eventTime = zoomTime;
						break;
				}
			}

			function batchAddEvent(params) {
				getToken().then(function(user) {
					params.operator = user.name;

					return adminData.batchAddEvent(user.token, params)
						.then(function(response) {
							// Get latest Data
							refreshData();

							// Close modal
							cancel();
							return response;
						})
						.catch(function(response) {
							return response;
						});
				});
			}

			// Submit
			function ok() {
				var selectedComponents = [];
				var newEvent = {
					env: $scope.environment,
					approval_status: "Approved",
					operator: '',
					note: $ctrl.eventNote,
					mod_ver: 0
				};

				angular.forEach($ctrl.selectedComponents, function(component) {
					component.event_time = ($ctrl.eventTime/1000);
					component.status_percent = $ctrl.eventAvailability;

					selectedComponents.push(component);
				});

				$q.all(selectedComponents).then(function(components) {
					newEvent.selectedComponents = components;

					batchAddEvent(newEvent);
				});
			}

			// Cancel
			function cancel() {
				$uibModalInstance.dismiss('cancel');
			}
		}


		/*****************************************************************************
		Update Data
		*****************************************************************************/

		$scope.$on('envUpdated', function(response, env) {
			$scope.environment = env;

			$scope.requestStatus = {
				display : true,
				type : 'loading',
				details : 'One moment...'
			};

			// Update URL
			$state.go('.', { environment:env }, { notify:false });

			// Get new data
			getLists().then(function() {
				refreshData();
			});

			// Show All
			showAll();
		});

		$scope.$watchGroup(['timeRange', 'timeStart', 'selectedServiceMetric', 'selectedComponent'], function(newVal, oldVal, scope) {

				// Check if array is equal.
				// Guarantees that refreshData() only fires once
				function arraysEqual(arr1, arr2) {
					if(arr1.length !== arr2.length)
						return false;
					for(var i = arr1.length; i--;) {
						if(arr1[i] !== arr2[i])
							return false;
					}

					return true;
				}

				if (!arraysEqual(newVal, oldVal)) {
					refreshData();
				}
			});

		return $scope;
	}
})();

(function() {
	'use strict';

	angular
		.module('client')
		.controller('MainController', MainController);

	/** @ngInject */
	function MainController($rootScope, $scope, $q, $http, $uibModal, $state, $stateParams, $filter, $interval, statusData, $sce, adminData) {
		// Data
		$scope.systemEnv = '';
		$scope.environment = statusData.env;
		$scope.allStatus = [];
		$scope.client = [];
		$scope.core = [];
		$scope.connectivity = [];
		$scope.server = [];
		$scope.history = [];
		$scope.servicesList = [];
		$scope.componentsList = [];

		// UI
		$scope.status = {
			display: true,
			type: 'loading',
			details: 'One moment...'
		};
		$scope.showService = [];

		// Actions
		$scope.scrollToSubscribe = scrollToSubscribe;


		/*****************************************************************************
		Set System Environment
		*****************************************************************************/

		statusData.getSystemEnv().then(function(response) {
			$scope.systemEnv = response.data.environment;
		});


		/*****************************************************************************
		Update Environment
		*****************************************************************************/

		if ($stateParams.environment)  {
			$scope.environment = $stateParams.environment;

			statusData.updateEnv($stateParams.environment);
		} else {
			statusData.updateEnv('ext-prod-live');
		}

		/*****************************************************************************
		Get Token
		*****************************************************************************/

		function getToken() {
			return adminData.getToken()
				.then(function(token) {
					return token;
				})
				.catch(function(response) {
					$rootScope.$broadcast('hideSpinner');

					// Update request status
					$scope.status.display = true;
					$scope.status.details = 'It appears that this TTID does not have the correct authorization to access the Status Page. Please open a ticket (https://tradingtechnologies.com/resources/support/) to get access.';
					$scope.status.type = 'error';

					return response;
				});
		}


		/*****************************************************************************
		Get list of services and components first, if not present
		*****************************************************************************/

		function getLists() {
			return statusData.getLists($scope.environment, true)
				.then(function(response) {
					// Clear lists
					$scope.showService = [];
					$scope.servicesList = [];
					$scope.componentsList = [];

					// Build Show Service List
					angular.forEach(response.services, function(service) {
						// Maintains expanded services, when data is refreshed
						$scope.showService[service.metric]=false;
					});

					// Apply new data
					$scope.servicesList = response.services;
					$scope.componentsList = response.components;

					return response;
				});
		}


		/*****************************************************************************
		Get Notifications
		*****************************************************************************/

		function getNotifications() {
			return statusData.getNotifications($scope.environment)
				.then(function(response) {
					// Clear old data
					$scope.history = [];

					// Apply new data
					$scope.history = response.data.notifications;

					return response;
				});
		}


		/*****************************************************************************
		Get Data
		*****************************************************************************/

		function getStatus() {
			return statusData.getStatus($scope.environment)
				.then(function(response) {
					$scope.allStatus = response.data.groups;

					// Update "Last Updated" time stamp
					statusData.updateTimestamp(moment().format());

					return response;
				});
		}


		/*****************************************************************************
		Get Data
		*****************************************************************************/

		function getData() {
			$rootScope.$broadcast('showSpinner');

			return $q.all([
					getStatus(),
					getNotifications()
				])
				.then(function(response) {
					$rootScope.$broadcast('hideSpinner');

					// Update request status
					$scope.status.type = 'success';
					$scope.status.display = false;
					$scope.status.details = '';

					return response;
				})
				.catch(function(response) {
					$rootScope.$broadcast('hideSpinner');

					// Update request status
					$scope.status.display = true;
					$scope.status.details = 'We are unable to retrieve the data. Please try refreshing the page.';
					$scope.status.type = 'error';

					return response;
				});
		}


		/*****************************************************************************
		Show Vendor Incident Indicator
		*****************************************************************************/

		function addVendorFlag(data) {
			var affected = [];

			angular.forEach(data.notifications, function(obj, i) {
				// If vendor incident(4) and ongoing(2)
				if (obj.notification_type===4 &&  obj.notification_status===2) {
					affected = _.union(affected, obj.components_affected);
				}
			});

			$q.all(affected).then(function(affectedList) {
				// Use Affected Component List as Reference
				angular.forEach(affectedList, function(affected, i) {
					// Loop Status List
					return _.find($scope.allStatus, function(group) {
						// Loop all Services
						return _.find(group.services, function(service) {
							if (service.metric === affected.metric) {
								// Add vendor flag
								service.vendor = true;

								// Loop all Components
								return _.find(service.components, function(component) {
									if (component.backendName === affected.name) {
										// Add vendor flag
										component.vendor = true;
									}
								});
							}
						});
					});
				});
			});
		}

		$scope.$on('notificationUpdated', function(response, data) {
			addVendorFlag(data);
		});


		/*****************************************************************************
		Refresh Data
		NOTE: Get components & services list, get notifications & status,
		start auto update.
		*****************************************************************************/

		function refreshData() {
			return getToken()
				.then(function(response) {
						return getLists()
					})
				.then(function(response) {
						return getData();
					});
		}
		// Initialize
		refreshData();


		/*****************************************************************************
		Scroll To Subscribe
		*****************************************************************************/

		function scrollToSubscribe() {
			$('html, body').animate({ scrollTop: $(document).height() });
		}


		/*****************************************************************************
		Auto Update
		*****************************************************************************/

		var timer = $interval(getData, 120000);

		function stopUpdate() {
			$interval.cancel(timer);
		}

		$scope.$on('$destroy', function() {
			stopUpdate();
		});


		/*****************************************************************************
		Update Data
		*****************************************************************************/

		$scope.$on('envUpdated', function(response, env) {
			$scope.environment = env;

			// Update State Parameter
			$state.go('.', { environment:env }, { notify:false });

			// Refresh Data
			refreshData();
		});
	}
})();

(function() {
	'use strict';

	angular
	.module('client')
	.controller('AlertsController', AlertsController);

	/** @ngInject */
	function AlertsController($rootScope, $scope, $q, $filter, $state, $stateParams, $interval, statusData, adminData, $uibModal) {
		// Data
		$scope.environment = statusData.env;
		$scope.events = [];
		$scope.servicesList = [];
		$scope.selectedEvents = [];
		$scope.batchComment = '';

		// UI
		$scope.showMultiAction = false;
		$scope.toggleSelectAllBool = true;
		$scope.batchActionConfirmed = false;
		$scope.sort = {
			'key' : 'date',
			'reverse' : true
		};
		$scope.requestStatus = {
			display: true,
			type: 'loading',
			details: 'One moment...'
		};
		$scope.pageSize = 100;

		// Action
		$scope.toggleSelect = toggleSelect;
		$scope.toggleSelectAll = toggleSelectAll;
		$scope.toggleComment = toggleComment;
		$scope.applyAction = applyAction;
		$scope.batchAction = batchAction;

		$scope.toggleMultiAction = toggleMultiAction;
		$scope.startUpdate = startUpdate;
		$scope.stopUpdate = stopUpdate;


		/*****************************************************************************
		Update Environment
		*****************************************************************************/

		if ($stateParams.environment)  {
			$scope.environment = $stateParams.environment;

			statusData.updateEnv($stateParams.environment);
		}


		/*****************************************************************************
		Get Token
		*****************************************************************************/

		function getToken() {
			return adminData.getToken()
				.then(function(token) {
					return token;
				})
				.catch(function(response) {
					$scope.requestStatus = {
						display : true,
						type : 'error',
						details : 'You are not authorized.'
					}

					return response;
				});
		}


		/*****************************************************************************
		Get list of services first, if not present
		*****************************************************************************/

		function getLists() {
			return statusData.getLists($scope.environment)
				.then(function(response) {
					$scope.servicesList = response.services;

					return response;
				});
		}


		/*****************************************************************************
		Get Events
		*****************************************************************************/

		function getEvents(user) {
			var params = {
					env : $scope.environment,
					metric : 'all',
					name : $scope.selectedComponent,
					filter: 'Pending'
				};

			// Stop timer
			$scope.stopUpdate();

			// Show loading icon
			$rootScope.$broadcast('showSpinner');
			$scope.requestStatus = {
				display : true,
				type : 'loading',
				details : 'One moment...'
			}

			// Get Events
			adminData.getEvents(user.token, params).then(function(response) {
				if (response.events) {
					$scope.events = response.events;
				} else {
					$scope.events = [];
				}

				// Update time stamp
				statusData.updateTimestamp(moment().format());

				// Start timer
				$scope.startUpdate();

				// Update request state
				$rootScope.$broadcast('hideSpinner');
				$scope.requestStatus = {
					display : false,
					type : 'success',
					details: ''
				};
			}).catch(function(response) {
				$rootScope.$broadcast('hideSpinner');
				$scope.requestStatus = {
					display : true,
					type : 'error',
					details : 'We are unable to retrieve the data. Please try refreshing the page.'
				}
			});
		}

		// Get components & services list, then events, on load
		getLists().then(getToken().then(getEvents));


		/*****************************************************************************
		Toggle Select
		*****************************************************************************/

		function toggleSelect(event, bool) {
			// Discard unnecessary properties, less data for API
			var prunedEvent = _.pick(event, ['metric', 'name', 'event_time']);
			var index = _.findIndex($scope.selectedEvents, prunedEvent);

			// toggle select
			event.selected = bool;

			// Store in selectedEvents[]
			if (bool && index < 0) {
				$scope.selectedEvents.push(prunedEvent);
			}

			// Remove from selectedEvents[]
			if (!bool && index >= 0) {
				$scope.selectedEvents.splice(index, 1);
			}
		}


		/*****************************************************************************
		Toggle Multi Action
		NOTE: Hides and shows the multi-action panel for approving/rejecting items
		*****************************************************************************/

		function toggleMultiAction() {
			// When 1 checkbox is checked
			if ($scope.selectedEvents.length >= 1) {
				$scope.showMultiAction = true;
				$scope.stopUpdate();
			}
			// When less than 1 is checked
			else {
				$scope.showMultiAction = false;
				$scope.startUpdate();
			}
		}


		/*****************************************************************************
		Toggle Select
		NOTE: Selects and deselects all checkboxes
		*****************************************************************************/

		function toggleSelectAll() {
			angular.forEach($scope.events, function(event) {
				if (!event.actioned) {
					toggleSelect(event, $scope.toggleSelectAllBool);
				}
			});
		}


		/*****************************************************************************
		Watcher
		*****************************************************************************/

		$scope.$watch(function() {return $scope.selectedEvents}, function() {
			toggleMultiAction();

			// Toggle Select All / Deselect All instruction
			if ($scope.selectedEvents.length === $scope.events.length) {
				$scope.toggleSelectAllBool = false;
			}

			if (!$scope.selectedEvents.length || $scope.selectedEvents.length < $scope.events.length) {
				$scope.toggleSelectAllBool = true;
			}
		}, true);


		/*****************************************************************************
		Toggle Comment
		NOTE: Hides and shows comment text field for each alert
		*****************************************************************************/

		function toggleComment(event) {
			if (event.showComment) {
				$scope.startUpdate();
				return event.showComment = false;
			} else {
				$scope.stopUpdate();
				return event.showComment = true;
			}
		}


		/*****************************************************************************
		Apply Action
		NOTE: When user approves or rejects
		*****************************************************************************/

		function applyAction(event, action) {
			return getToken().then(function(user){
				var param = {
					env: $scope.environment,
					metric: event.metric,
					component: event.name,
					approval_status: action,
					status_percent: event.status_percent,
					operator: user.name,
					event_time: event.event_time,
					note: (event.comment) ? event.comment : '',
					mod_ver: event.mod_version
				}

				if (event.showComment) {
					toggleComment(event);
				}

				return adminData.updateEvent(user.token, param)
					.then(function(response) {
						// Update UI
						event.actioned = true;
						event.approval_status = action;

						$rootScope.$broadcast('hideSpinner');
						$scope.requestStatus = {
							display : false,
							type : 'success',
							details: ''
						};

						return response;
					})
					.catch(function(response) {
						$rootScope.$broadcast('hideSpinner');
						$scope.requestStatus = {
							display : true,
							type : 'error',
							details : 'We are unable to complete the actions you requested. Please refresh the page and try again.'
						};

						return response;
					});
			});
		}


		/*****************************************************************************
		Batch Action
		NOTE: Shows confirmation modal
		*****************************************************************************/

		function batchAction(action, comment) {
			var modalInstance = $uibModal.open({
				windowClass: 'confirm-batch-action',
				templateUrl: 'confirmBatchAction.html',
				backdrop: 'static',
				controller: ModalController,
				controllerAs: '$ctrl',
				resolve: {
					action: function() {
						return action;
					},
					comment: function() {
						return comment;
					}
				}
			})
			// Workaround to silence error, triggered by dismissing modal
			// This error is caused by the latest update of Angularjs
			.result.then(function(){}, function(r){});
		}

		// Modal Controller
		function ModalController($uibModalInstance, action, comment) {
			var $ctrl = this;

			// Data
			$ctrl.action = action;
			$ctrl.events = $scope.selectedEvents;

			// UI
			$ctrl.requestStatus = {
				display: false,
				type: 'success',
				details: ''
			};

			// Actions
			$ctrl.ok = ok;
			$ctrl.cancel = cancel;

			// Confirm Batch Action
			function confirmBatchAction(user) {
				var params = {
					env: $scope.environment,
					approval_status: action,
					operator: user.name,
					note: (comment) ? comment : '',
					mod_ver: 0,
					data: $scope.selectedEvents
				};

				// Show loading
				$ctrl.requestStatus = {
					display: true,
					type: 'loading',
					details: 'One moment...'
				};

				return adminData.batchUpdateEvents(user.token, params)
					.then(function(response) {
						// Clear comments
						$scope.batchComment = '';

						// Clear events list
						$scope.events = [];

						// Refresh data
						getEvents(user);

						// Hide multi-action panel
						$scope.showMultiAction = false;

						// Toggle select all button
						$scope.toggleSelectAllBool = true;

						// Update request status
						$ctrl.requestStatus = {
							display: true,
							type: 'success',
							details: $filter('number')(response.data.events.length) + ' event(s) successfully '+response.data.approval_status+'.'
						};

						return response;
					})
					.catch(function(response) {
						// Show loading
						$ctrl.requestStatus = {
							display: true,
							type: 'error',
							details: 'We are unable to complete the actions you requested. Please refresh the page and try again.'
						};

						return response;
					});
			}

			// Submit
			function ok() {
				getToken().then(confirmBatchAction);
			}

			// Cancel
			function cancel() {
				// Close modal
				$uibModalInstance.dismiss('cancel');

				// Re-init timer
				$scope.startUpdate();
			}
		}


		/*****************************************************************************
		Sort
		*****************************************************************************/

		$scope.sortBy = function(key) {
			$scope.sort.key = key;
			$scope.sort.reverse = ($scope.sort.reverse) ? false : true;

			if (key==='metric') {
				key=['-metric' , '-name']
			}

			$scope.events = $filter('orderBy')($scope.events, key, $scope.sort.reverse);
		};


		/*****************************************************************************
		Auto Update
		*****************************************************************************/

		var timer;

		function startUpdate() {
			// Stop all running timer
			$scope.stopUpdate();

			// Get Data every 2 minutes
			timer = $interval(function() {
				if ($state.current.name==='admin')
					getToken().then(getEvents);
			}, 30000);
		}

		function stopUpdate() {
			$interval.cancel(timer);
		}

		$scope.$on('$destroy', function() {
			$scope.stopUpdate();
		});

		// Start Timer
		$scope.startUpdate();


		/*****************************************************************************
		Update Data
		*****************************************************************************/

		$scope.$on('envUpdated', function(response, env) {
			$scope.environment = env;
			$rootScope.$broadcast('showSpinner');

			$scope.requestStatus = {
				display : true,
				type : 'loading',
				details : 'One moment...'
			};

			// Clear events list
			$scope.events = [];
			$scope.selectedEvents = [];

			// Stop all running timers
			$scope.stopUpdate();

			// Update State Parameter
			$state.go('.', { environment:env }, { notify:false });

			// Get new data
			getLists().then(getToken().then(getEvents));

			// Start auto update
			$scope.startUpdate();
		});

		return $scope;
	}
})();

(function() {
  'use strict';

  angular
    .module('client')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('client')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $stateProvider
      .state('home', {
        url: '/?environment',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      })
      .state('service', {
        url: '/service/:name?environment&component&metric',
        templateUrl: 'app/service/service.html',
        controller: 'ServiceController',
        controllerAs: 'service'
      })
      .state('admin', {
        url: '/admin?environment',
        templateUrl: 'app/alerts/alerts.html',
        controller: 'AlertsController',
        controllerAs: 'alerts'
      })
      .state('manage', {
        url: '/manage?environment',
        templateUrl: 'app/manage/manage.html',
        controller: 'ManageController',
        controllerAs: 'manage'
      })
      .state('notify', {
        url: '/notify?environment',
        templateUrl: 'app/notify/notify.html',
        controller: 'NotifyController',
        controllerAs: 'notify'
      });

    $urlRouterProvider.otherwise('/');
  }

})();

/* global moment:false */
(function() {
  'use strict';

  angular
    .module('client')
    .constant('moment', moment)
    .constant('_', _);

})();

(function() {
  'use strict';

  angular
    .module('client')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Disable URL "hash bang" (#!)
    $locationProvider.hashPrefix('');
  }

})();

angular.module("client").run(["$templateCache", function($templateCache) {$templateCache.put("app/alerts/alerts.html","<div class=page data-name=alerts><div class=container><header class=page-head><admin-nav class=admin-nav></admin-nav></header><div class=page-body><div class=\"list alerts-list\"><div class=list-control><div class=control-row><button type=button class=\"btn btn-default toggle-select\" ng-disabled=!events.length ng-click=toggleSelectAll()>{{(toggleSelectAllBool) ? \'Select All\' : \'Deselect All\'}}</button> <span class=list-total>Total: {{events.length | number}}</span><div class=\"control-sort form-group\"><label>Sort</label><span class=btn-group><button type=button class=\"btn btn-default\" ng-model=sort ng-click=\"sortBy(\'event_time\')\" ng-disabled=!events.length>Date <small class=\"glyphicon text-muted\" ng-show=\"sort.key===\'event_time\'\" ng-class=\"{\'glyphicon-triangle-bottom\':sort.reverse,\'glyphicon-triangle-top\':!sort.reverse}\"></small></button> <button type=button class=\"btn btn-default\" ng-model=sort ng-click=\"sortBy(\'metric\')\" ng-class=\"{\'active\':sort.key===\'metric\'}\" ng-disabled=!events.length>Service <small class=\"glyphicon text-muted\" ng-show=\"sort.key===\'metric\'\" ng-class=\"{\'glyphicon-triangle-bottom\':!sort.reverse,\'glyphicon-triangle-top\':sort.reverse}\"></small></button></span></div></div><!-- Batch Action --><div class=multi-action ng-show=showMultiAction><h2 class=h4>Batch Approve/Reject</h2><div class=input-group><input type=text class=form-control placeholder=\"Enter comment\" ng-model=batchComment> <span class=input-group-btn><button type=button class=\"btn btn-default\"><span class=\"glyphicon glyphicon-remove-sign\" ng-click=\"batchAction(\'Rejected\', batchComment)\"></span></button> <button type=button class=\"btn btn-default\"><span class=\"glyphicon glyphicon-ok-sign\" ng-click=\"batchAction(\'Approved\', batchComment)\"></span></button></span></div></div></div></div><div class=list-body><!-- Request Status Message --><div class=request-status ng-class=\"{\'text-danger\':requestStatus.type===\'error\'}\" ng-show=\"!events.length && requestStatus.display\"><div class=content><div class=icon><img src=./assets/theme/images/icon-spinner.gif alt=\"One moment...\" ng-if=\"requestStatus.type === \'loading\'\"> <span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"requestStatus.type === \'error\'\"></span></div><p class=details>{{ requestStatus.details }}</p></div></div><div class=list-notification ng-show=\"!events.length && !requestStatus.display\">No events found</div><!-- Events List --><infinite-scroll parent-controller=alerts page-size=100></infinite-scroll><div class=list-item ng-repeat=\"event in events | orderBy:\'-event_time\' | limitTo:pageSize\" ng-if=events.length><span class=item-select><input type=checkbox ng-model=event.selected ng-disabled=event.actioned ng-change=\"toggleSelect(event, event.selected)\"></span><div class=item-row><strong class=item-name><span class=\"item-indicator md\" ng-class=\"{\'up\':event.status_percent===100, \'degraded\': event.status_percent>0 && event.status_percent<100, \'down\':event.status_percent===0}\"></span> <span class=item-service>{{event.metric|prettyService:servicesList}}</span> : <span class=item-component>{{event.name}}</span></strong><div class=item-control><div class=item-status ng-class=\"{\'actioned\':event.approval_status!==\'Pending\'}\"><span class=\"approved text-success\" ng-if=\"event.approval_status==\'Approved\'\"><span class=\"glyphicon glyphicon-ok-sign\"></span> Approved</span> <span class=\"rejected text-danger\" ng-if=\"event.approval_status==\'Rejected\'\"><span class=\"glyphicon glyphicon-remove-sign\"></span> Rejected</span></div><div class=item-actions ng-class=\"{\'actioned\':event.approval_status!==\'Pending\'}\"><button type=button class=approve ng-click=\"applyAction(event,\'Approved\')\" ng-class=\"{\'disabled\':event.selected}\" ng-disabled=event.selected><span class=\"glyphicon glyphicon-ok-sign\" ng-class=\"{\'text-success\':event.approval_status==\'Approved\'}\"></span></button> <button type=button class=reject ng-click=\"applyAction(event,\'Rejected\')\" ng-class=\"{\'disabled\':event.selected}\" ng-disabled=event.selected><span class=\"glyphicon glyphicon-remove-sign\" ng-class=\"{\'text-danger\':event.approval_status==\'Rejected\'}\"></span></button></div></div><div class=item-comment><input type=text placeholder=\"Enter comments\" ng-model=event.comment ng-if=event.showComment> <button type=button class=comment ng-click=toggleComment(event) ng-class=\"{\'disabled\':event.selected}\" ng-disabled=event.selected><span class=\"glyphicon glyphicon-comment\" ng-class=\"{\'text-info\':event.comment}\"></span></button></div><small class=item-date>{{event.event_time * 1000 | date:\'short\' }}</small></div><div class=item-row><small class=item-description ng-if=event.hint title=Hint><span class=\"glyphicon glyphicon glyphicon-info-sign\"></span> {{ event.hint }}</small></div><ul class=\"item-row item-history\" ng-if=event.approval_history.length><li ng-repeat=\"history in event.approval_history | orderBy:\'utc_time\' track by $index\"><small class=history-status>{{history.status_percent}}%</small> <small class=history-note>{{history.note}}</small> <small class=history-date>{{history.utc_time * 1000 | date:\'short\' }} UTC</small> <small class=history-approved-by><span class=\"glyphicon glyphicon-user\"></span> {{history.operator}}</small> <small class=history-state><span class=approved ng-if=\"history.action==\'Approved\'\"><span class=\"glyphicon glyphicon-ok-sign\"></span> Approved</span> <span class=rejected ng-if=\"history.action==\'Rejected\'\"><span class=\"glyphicon glyphicon-remove-sign\"></span> Rejected</span></small></li></ul></div></div></div></div></div><script type=text/ng-template id=confirmBatchAction.html><div class=\"modal-header\">\r\n		<h3 class=\"modal-title h4\">Confirm</h3>\r\n	</div>\r\n	<div class=\"modal-body\">\r\n		<div class=\"modal-request-status\" ng-show=\"$ctrl.requestStatus.display\" ng-class=\"{\'text-danger\':$ctrl.requestStatus.type===\'error\', \'text-success\':$ctrl.requestStatus.type===\'success\'}\">\r\n			<div class=\"icon\">\r\n				<img src=\"./assets/theme/images/icon-spinner.gif\" alt=\"One moment...\" ng-if=\"$ctrl.requestStatus.type === \'loading\'\">\r\n				<span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"$ctrl.requestStatus.type === \'error\'\"></span>\r\n				<span class=\"glyphicon glyphicon-ok\" ng-if=\"$ctrl.requestStatus.type === \'success\'\"></span>\r\n			</div>\r\n			<p class=\"details\">\r\n				{{ $ctrl.requestStatus.details }}\r\n			</p>\r\n		</div>\r\n		<div ng-hide=\"$ctrl.requestStatus.display\">\r\n			Are you sure you want to\r\n			<strong class=\"text-success\" ng-if=\"$ctrl.action===\'Approved\'\"><small class=\"glyphicon glyphicon-ok-sign\"></small> approve</strong>\r\n			<strong class=\"text-danger\" ng-if=\"$ctrl.action===\'Rejected\'\"><small class=\"glyphicon glyphicon-remove-sign\"></small> reject</strong>\r\n			{{$ctrl.events.length | number}} {{($ctrl.events.length > 1) && \'events\' || \'event\' }}?\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-show=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\'\">Close</button>\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\'\" ng-disabled=\"$ctrl.requestStatus.type===\'loading\'\">Cancel</button>\r\n		<button class=\"btn btn-success\" type=\"button\" ng-click=\"$ctrl.ok()\" ng-if=\"$ctrl.action===\'Approved\'\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\'\" ng-disabled=\"$ctrl.requestStatus.type===\'loading\'\">Approve</button>\r\n		<button class=\"btn btn-danger\" type=\"button\" ng-click=\"$ctrl.ok()\" ng-if=\"$ctrl.action===\'Rejected\'\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\'\" ng-disabled=\"$ctrl.requestStatus.type===\'loading\'\">Reject</button>\r\n	</div></script>");
$templateCache.put("app/main/main.html","<div class=page data-name=status><div class=container><header class=page-head><h1>TT&reg; Status</h1><p class=content>Check this page for the real-time status of TT services. We continuously monitor all services and if there are any interruptions, we will report details here. You can also find information about current, upcoming and past maintenance as well as past incidents here.<br><br><b>CONFIDENTIAL INFORMATION</b><br>The information on these website pages is TT Confidential Information and is being made available only to TT authorized customers for their internal viewing and usage. You are not authorized to copy, reproduce, recompile, decompile, disassemble, reverse engineer, distribute, publish, display, modify, upload to, create derivative works from, transmit or in any way exploit all or any part of the information provided on this website.</p></header><div class=request-status ng-class=\"{\'text-danger\':status.type===\'error\'}\" ng-show=status.display><div class=content><div class=icon><img src=./assets/theme/images/icon-spinner.gif ng-if=\"status.type === \'loading\'\"> <span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"status.type === \'error\'\"></span></div><p class=details>{{ status.details }} <span class=details ng-if=\"status.type===\'error\'\">If you need immediate help, please contact <a href=https://www.tradingtechnologies.com/en/contact/ target=_blank>TT Support</a>.</span></p></div><div class=backdrop></div></div><div class=row data-name=overview ng-if=allStatus.length><div class=col-sm-3 ng-repeat=\"group in allStatus | orderBy:\'order\'\"><section class=\"section well\" data-name={{group.name}}><div class=section-head><h2 class=section-header>{{group.name}}</h2></div><div class=section-body><ul class=status-list><li class=status-item ng-repeat=\"item in group.services track by $index\" ng-click=\"showService[item.metric] = !showService[item.metric]\" ng-class=\"{\'active\':showService[item.metric]}\" status></li></ul></div></section></div></div><div data-name=subscribe-anchor><button type=button class=\"btn btn-default\" ng-click=scrollToSubscribe()><small class=\"glyphicon glyphicon-envelope\"></small> Subscribe</button></div><section class=section data-name=history><header class=section-head><h2 class=section-header>History</h2></header><div class=section-body><ul class=history-list><li class=\"history-item text-muted\" ng-if=!history.length>No incidents found in the last 30 days.</li><li class=history-item ng-class=\"{\'exchange-issue\':item.notification_type===4}\" ng-repeat=\"item in history | orderBy:\'-start_ts\' track by $index\"><small class=item-date>{{ item.start_ts*1000 | date:\'MM/dd/yy hh:mm a\' }}</small> <small class=\"item-status text-warning\" ng-if=\"item.notification_type===5 && item.notification_status===2 ||item.notification_type===2 && item.notification_status===2 || item.notification_type===4 && item.notification_status===2\"><small class=\"glyphicon glyphicon-time\"></small> Ongoing </small><small class=\"item-status text-success\" ng-if=\"item.notification_type===2 && item.notification_status===4 || item.notification_type===4 && item.notification_status===4 || item.notification_type===5 && item.notification_status===4\"><small class=\"glyphicon glyphicon-ok\"></small> Resolved <span ng-if=item.resolution_ts>({{item.resolution_ts*1000 | date:\'MM/dd/yy hh:mm a\' }})</span></small><h3 class=item-title><span class=text-warning ng-if=\"item.notification_type===2\"><span class=\"glyphicon glyphicon-warning-sign\"></span> Disruption : </span><span class=text-danger ng-if=\"item.notification_type===5\"><span class=\"glyphicon glyphicon-warning-sign\"></span> Outage : </span><span class=text-info ng-if=\"item.notification_type===3\"><span class=\"glyphicon glyphicon-wrench\"></span> Maintenance : </span><span class=text-info ng-if=\"item.notification_type===1\"><span class=\"glyphicon glyphicon-info-sign\"></span> General : </span><span class=text-danger ng-if=\"item.notification_type===4\"><span class=\"glyphicon glyphicon-exclamation-sign\"></span> Exchange Issue : </span>{{ item.title }}</h3><ul class=item-messages><li class=message-item ng-repeat=\"message in item.messages | orderBy:\'-ts\'\"><div class=time>{{ message.ts*1000 | date:\'MM/dd/yy hh:mm a\' }}</div><div class=details><div class=message ng-bind-html=\"message.message | fullHtml\"></div><div class=customer-action ng-if=message.customer_action><strong>Customer Action:</strong> {{ message.customer_action }}</div></div></li></ul><div class=affected-components ng-if=item.components_affected.length><small class=affected-label>Affected:</small> <small class=affected-component ng-repeat=\"component in item.components_affected\">{{ component.metric | prettyService:servicesList }} : {{component.name | prettyComponent:componentsList}}</small></div></li></ul></div></section><section class=section data-name=subscribe><!-- Begin MailChimp Signup Form --><div id=mc_embed_signup><form ng-if=\"systemEnv===\'Staging\'\" action=\"https://tradingtechnologies.us18.list-manage.com/subscribe/post?u=f533268a685bea1eda14b1e2e&amp;id=b4d6cd55a3\" method=post id=mc-embedded-subscribe-form name=mc-embedded-subscribe-form class=validate target=_blank novalidate><div id=mc_embed_signup_scroll><h2>Subscribe to our notifications</h2><h3>Notification Policy</h3><p>Updates on this page may be sent by email to subscribers when an issue is widespread or results in a complete outage. For more localized or limited issues, updates may be posted here without an accompanying email. This approach ensures that critical communications reach all subscribers without unnecessary volume, while all updates remain available in real time on this page.</p><div class=\"mc-field-group form-group\"><span class=required-label>Required</span><label for=mce-EMAIL>Email Address</label><input type=email name=EMAIL class=\"required email form-control\" id=mce-EMAIL></div><div id=mce-responses class=clear><div class=response id=mce-error-response style=display:none></div><div class=response id=mce-success-response style=display:none></div></div><!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--><div style=\"position: absolute; left: -5000px\" aria-hidden=true><input type=text name=b_f533268a685bea1eda14b1e2e_b4d6cd55a3 tabindex=-1></div><div class=subscribe-foot><input type=submit value=Subscribe name=subscribe id=mc-embedded-subscribe class=\"button btn btn-default\"></div></div></form><form ng-if=\"systemEnv===\'Production\'\" action=\"https://tradingtechnologies.us6.list-manage.com/subscribe/post?u=28c68b7375223b0bd44b45cda&amp;id=4cee0fea0f\" method=post id=mc-embedded-subscribe-form name=mc-embedded-subscribe-form class=validate target=_blank novalidate><div id=mc_embed_signup_scroll><h2>Subscribe to our notifications</h2><h3>Notification Policy</h3><p>Updates on this page may be sent by email to subscribers when an issue is widespread or results in a complete outage. For more localized or limited issues, updates may be posted here without an accompanying email. This approach ensures that critical communications reach all subscribers without unnecessary volume, while all updates remain available in real time on this page.</p><div class=\"mc-field-group form-group\"><span class=required-label>Required</span><label for=mce-EMAIL>Email Address</label><input type=email name=EMAIL class=\"required email form-control\" id=mce-EMAIL></div><div id=mce-responses class=clear><div class=response id=mce-error-response style=display:none></div><div class=response id=mce-success-response style=display:none></div></div><!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups--><div style=\"position: absolute; left: -5000px\" aria-hidden=true><input type=text name=b_28c68b7375223b0bd44b45cda_4cee0fea0f tabindex=-1></div><div class=subscribe-foot><input type=submit value=Subscribe name=subscribe id=mc-embedded-subscribe class=\"button btn btn-default\"></div></div></form></div><!-- <script type=\'text/javascript\' src=\'//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js\'></script><script type=\'text/javascript\'>(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]=\'EMAIL\';ftypes[0]=\'email\';}(jQuery));var $mcj = jQuery.noConflict(true);</script> --><!--End mc_embed_signup--></section></div></div>");
$templateCache.put("app/manage/manage.html","<div class=page data-name=manage><div class=container><header class=page-head><admin-nav class=admin-nav></admin-nav></header><div class=page-body><div class=row><div class=col-sm-3><div class=component-search><input type=text class=form-control placeholder=Search ng-model=search> <span class=\"glyphicon glyphicon-search\"></span></div><ul class=component-list><li class=list-item ng-click=showAll() ng-class=\"{\'active\': !selectedComponent}\"><strong>Show All</strong></li><li class=list-item ng-repeat=\"component in componentsList | filter:search\" ng-click=getComponent(component) ng-class=\"{\'active\':selectedComponent===component.backendName && selectedServiceMetric===component.metric}\"><span>{{component.metric|prettyService:servicesList}}</span> <strong>{{component.backendName}}</strong></li></ul></div><div class=col-sm-9><div class=\"list events-list\"><div class=list-controls><div class=control-row><button class=\"btn btn-default btn-sm control-batch\" ng-click=batchAdd()><span class=\"glyphicon glyphicon-plus\"></span> Batch Add</button> <button class=\"btn btn-default btn-sm control-refresh\" ng-click=refreshData()><span class=\"glyphicon glyphicon-refresh\"></span> Refresh</button><div class=control-range><span class=\"set-range btn-group btn-group-sm\"><button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'hour\')\" ng-class=\"{\'active\':timeRange===\'hour\'}\">1H</button> <button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'day\')\" ng-class=\"{\'active\':timeRange===\'day\'}\">24H</button> <button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'week\')\" ng-class=\"{\'active\':timeRange===\'week\'}\">7D</button> <button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'month\')\" ng-class=\"{\'active\':timeRange===\'month\'}\">30D</button></span></div></div><div class=\"control-row selected-component\"><h2><span>{{(selectedServiceMetric) && (selectedServiceMetric | prettyService:servicesList)+\' :\' || \'All Components\'}}</span> <strong ng-show=selectedComponent>{{selectedComponent}}</strong></h2></div><div class=\"control-row selected-range\"><span class=current-range><div ng-show=\"chartReqStatus.type ===\'loading\'\">One moment...</div><div ng-show=\"chartReqStatus.type !==\'loading\'\"><span class=start>{{ (componentChart.startTime) && (componentChart.startTime | date:\'MMM d, h:mma\') || (timeStart | date:\'MMM d, h:mma\') }}</span> <span class=\"glyphicon glyphicon-arrow-right\"></span> <span class=end>{{ (componentChart.endTime) && (componentChart.endTime | date:\'MMM d, h:mma\') || (timeEnd | date:\'MMM d, h:mma\') }}</span></div></span><strong class=availability ng-show=\"componentChart.availability && showChart\" ng-cloak>{{componentChart.availability | truncate:2}}%</strong></div><div class=control-row ng-if=showChart><div class=text-muted ng-show=\"!componentChart.dataPoints.length && chartReqStatus.type !==\'loading\'\" ng-cloak><small class=\"glyphicon glyphicon-info-sign\"></small> <small>Availability data is currently not available</small></div><div class=chart ng-show=componentChart.dataPoints.length ng-class=\"{\'hour\':timeRange===\'hour\'}\"><ul ng-class=\"{\'requesting\': chartReqStatus.type===\'loading\' }\"><li ng-if=!chartReqStatus.display ng-repeat=\"data in componentChart.dataPoints track by $index\" ng-click=zoomIn(data.startTime) title=\"{{ data.startTime | date : \'short\' }}\" ng-class=\"{\r\n												\'down\':data.availability===0,\r\n												\'degraded\':data.availability<100 && data.availability>0,\r\n												\'up\':data.availability===100,\r\n												\'active\':data.startTime==customEvent.event_time && showAddEvent\r\n											}\" uib-tooltip=\"{{ (data.availability >= 0) && (data.availability | truncate:2) + \'%\' || \'N/A\'}}\" tooltip-append-to-body=true><span class=time ng-if=\"$parent.timeRange===\'hour\' && $first || $parent.timeRange===\'hour\' && $last\" ng-cloak>{{($first) && \'From:\' || \'\'}} {{($last) && \'To:\' || \'\'}} {{ data.startTime | date : \'hh:mma\' }}</span> <span class=time ng-if=\"$parent.timeRange===\'day\'\">{{ data.startTime | date : \'HH:mm\' }}</span> <span class=time ng-if=\"$parent.timeRange===\'month\' || $parent.timeRange===\'week\'\" ng-cloak>{{ data.startTime | date:\'M/d\' }}</span> <span class=arrow ng-if=data.event></span></li></ul></div></div><div ng-form=addEventForm class=\"control-row add-event\" ng-class=\"{\'active\':showAddEvent}\" ng-show=showAddEvent><div class=event-body><div class=event-status><span class=event-range><span class=range-label>Time: </span><span class=range-start>{{ customEvent.event_time | date:\'MMM d, h:mma\' }}</span> <span class=\"glyphicon glyphicon-arrow-right\"></span> <span class=range-end>Ongoing</span> </span><span class=\"set-status btn-group btn-group-sm\"><button type=button class=\"btn btn-default\" ng-class=\"{active:customEvent.status_text===\'up\'}\" ng-click=\"customEvent.status_text = \'up\'; customEvent.status_percent=100\"><span class=\"item-indicator sm up\"></span></button> <button type=button class=\"btn btn-default\" ng-class=\"{active:customEvent.status_text===\'degraded\'}\" ng-click=\"customEvent.status_text = \'degraded\'; customEvent.status_percent=50\"><span class=\"item-indicator sm degraded\"></span></button> <button type=button class=\"btn btn-default\" ng-class=\"{active:customEvent.status_text===\'down\'}\" ng-click=\"customEvent.status_text = \'down\'; customEvent.status_percent=0\"><span class=\"item-indicator sm down\"></span></button> </span><span class=event-availability ng-show=customEvent.status_text><span class=availability-value ng-show=\"customEvent.status_text!==\'degraded\'\">{{customEvent.status_percent}}%</span> <span class=availability-custom ng-show=\"customEvent.status_text===\'degraded\'\">Enter Availability: <input type=text name=availability ng-model=customEvent.status_percent placeholder=% required></span></span></div><div class=event-comment><input type=text name=comments class=form-control placeholder=\"Add comments\" ng-model=customEvent.note required></div></div><div class=event-foot><small class=\"help-block text-danger\" ng-show=\"addEventForm.comments.$invalid && addEventForm.comments.$touched\">Please add comments</small> <small class=\"help-block text-danger\" ng-show=\"addEventForm.availability.$invalid && addEventForm.comments.$valid\">Please select status</small> <button type=button class=\"btn btn-default\" ng-click=\"showAddEvent=false\">Cancel</button> <button type=button class=\"btn btn-primary\" ng-click=addEvent() ng-disabled=addEventForm.$invalid><span class=\"glyphicon glyphicon-plus\"></span> Add Event</button></div></div><div class=\"control-row hr\"><span class=control-total>Total : {{(requestStatus.display) && \'0\' || (events.length | number)}}</span></div></div><!-- Request Status Message --><div class=request-status ng-class=\"{\'text-danger\':requestStatus.type===\'error\'}\" ng-show=requestStatus.display><div class=content><div class=icon><img src=./assets/theme/images/icon-spinner.gif alt=\"One moment...\" ng-if=\"requestStatus.type === \'loading\'\"> <span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"requestStatus.type === \'error\'\"></span></div><p class=details>{{ requestStatus.details }}</p></div></div><div class=list-notification ng-show=\"!filteredEvents.length && !requestStatus.display\">No events found</div><div class=list-body ng-show=filteredEvents.length><!-- Events List --><infinite-scroll parent-controller=manage page-size=100></infinite-scroll><div class=list-item ng-repeat=\"event in filteredEvents = (events | filter:{metric:selectedServiceMetric, name:selectedComponent} | filter:rangeFilter | orderBy:\'-event_time\' | limitTo:pageSize) track by $index\" ng-show=\"filteredEvents.length && !requestStatus.display\"><div class=item-row><strong class=item-name><span class=\"item-indicator md\" ng-class=\"{\'up\':event.status_percent===100, \'degraded\': event.status_percent>0 && event.status_percent<100, \'down\':event.status_percent===0}\"></span> <span class=item-service>{{event.metric|prettyService:servicesList}}</span> : <span class=item-component>{{event.name}}</span></strong><div class=item-control><div class=item-status ng-class=\"{\'actioned\':event.approval_status!==\'Pending\'}\"><span class=\"approved text-success\" ng-show=\"event.approval_status==\'Approved\'\"><span class=\"glyphicon glyphicon-ok-sign\"></span> Approved</span> <span class=\"rejected text-danger\" ng-show=\"event.approval_status==\'Rejected\'\"><span class=\"glyphicon glyphicon-remove-sign\"></span> Rejected</span></div><div class=item-actions ng-class=\"{\'actioned\':event.approval_status!==\'Pending\'}\"><button type=button class=reject ng-click=\"applyAction(event,\'Rejected\')\"><span class=\"glyphicon glyphicon-remove-sign\" ng-class=\"{\'text-danger\':event.approval_status==\'Rejected\'}\"></span></button> <button type=button class=approve ng-click=\"applyAction(event,\'Approved\')\"><span class=\"glyphicon glyphicon-ok-sign\" ng-class=\"{\'text-success\':event.approval_status==\'Approved\'}\"></span></button></div></div><div class=item-comment><input type=text placeholder=\"Enter comments\" ng-model=event.comment ng-show=event.showComment> <button type=button class=comment ng-click=toggleComment(event)><span class=\"glyphicon glyphicon-comment\" ng-class=\"{\'text-info\':event.comment}\"></span></button></div><small class=item-date>{{event.event_time * 1000 | date:\'short\' }}</small></div><div class=item-row><small class=item-description ng-if=event.hint title=Hint><small class=\"glyphicon glyphicon glyphicon-info-sign\"></small> {{ event.hint }}</small></div><ul class=\"item-row item-history\"><li class=latest><small class=history-status>{{event.status_percent | truncate:2}}%</small> <small class=history-note>{{event.approval_note}}</small> <small class=history-date>{{(event.approval_utc_time) && (event.approval_utc_time * 1000 | date:\'short\') || \'N/A\' }}</small> <small class=history-approved-by><span class=\"glyphicon glyphicon-user\"></span> {{(event.approval_operator) && event.approval_operator || \'N/A\'}}</small> <small class=history-state><span class=approved ng-if=\"event.approval_status==\'Approved\'\"><span class=\"glyphicon glyphicon-ok-sign\"></span> Approved</span> <span class=rejected ng-if=\"event.approval_status==\'Rejected\'\"><span class=\"glyphicon glyphicon-remove-sign\"></span> Rejected</span></small></li><li ng-repeat=\"history in event.approval_history | orderBy:\'-\' track by $index\"><small class=history-status>{{history.status_percent | truncate:2}}%</small> <small class=history-note>{{history.note}}</small> <small class=history-date>{{(history.utc_time) && (history.utc_time * 1000 | date:\'short\') || \'N/A\' }}</small> <small class=history-approved-by><span class=\"glyphicon glyphicon-user\"></span> {{(history.operator) && history.operator || \'N/A\'}}</small> <small class=history-state><span class=approved ng-if=\"history.action==\'2\'\"><span class=\"glyphicon glyphicon-ok-sign\"></span> Approved</span> <span class=rejected ng-if=\"history.action==\'3\'\"><span class=\"glyphicon glyphicon-remove-sign\"></span> Rejected</span></small></li></ul></div></div></div></div></div></div></div></div><!-- Modal - Events Batch Add --><script type=text/ng-template id=batchAdd.html><div ng-form=\"batchEventForm\">\r\n		<div class=\"modal-header\">\r\n			<button type=\"button\" class=\"close\" ng-click=\"$ctrl.cancel()\"><span aria-hidden=\"true\">&times;</span></button>\r\n			<h3 class=\"modal-title h4\">Batch Add</h3>\r\n		</div>\r\n		<div class=\"modal-body select-components\" ng-hide=\"$ctrl.showSelectTimePanel\">\r\n			<p>Select a service, then choose the components you would like to add an event to.</p>\r\n			<div class=\"row\">\r\n				<div class=\"col-sm-4 service-list\">\r\n					<div class=\"tt-well\">\r\n						<div class=\"list-head\">Services</div>\r\n						<ul class=\"list-body\">\r\n							<li\r\n								ng-repeat=\"service in $ctrl.servicesList | orderBy:\'name\'\"\r\n								ng-class=\"{\'active\':$ctrl.selectedService.metric===service.metric}\"\r\n								ng-click=\"$ctrl.selectedService=service\">\r\n								{{service.name}}\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n				<div class=\"col-sm-4 component-list\">\r\n					<div class=\"tt-well\" ng-if=\"$ctrl.selectedService.metric\">\r\n						<div class=\"list-head\">{{($ctrl.selectedService.name) && $ctrl.selectedService.name || \'Components\'}} <span ng-if=\"$ctrl.selectedService.name\">: {{$ctrl.filteredComponents.length | number}}</span></div>\r\n						<ul class=\"list-body\">\r\n							<li class=\"add-all\" ng-click=\"$ctrl.addAll()\"><small class=\"glyphicon glyphicon-plus text-muted\"></small> <strong>Add all</strong></li>\r\n							<li\r\n								ng-repeat=\"component in $ctrl.filteredComponents = ($ctrl.componentsList | filter:$ctrl.selectedService.metric:true | orderBy:\'name\')\"\r\n								ng-click=\"$ctrl.addAffected(component, $ctrl.selectedComponents)\">\r\n								{{component.backendName}}\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n				<div class=\"col-sm-4 selected-list\">\r\n					<div class=\"tt-well\" ng-if=\"$ctrl.selectedService.metric\">\r\n						<div class=\"list-head\">Selected Components <span ng-if=\"$ctrl.selectedComponents.length\">: {{$ctrl.selectedComponents.length | number}}</span></div>\r\n						<ul class=\"list-body\" ng-show=\"$ctrl.selectedComponents && $ctrl.selectedComponents.length\">\r\n							<li class=\"remove-all\" ng-click=\"$ctrl.selectedComponents=[]\"><small class=\"glyphicon glyphicon-remove text-muted\"></small> <strong>Remove all</strong></li>\r\n							<li class=\"affected-component\" ng-repeat=\"component in $ctrl.selectedComponents\">\r\n								<small>{{component.metric | prettyService:$ctrl.servicesList}}</small>\r\n								<strong>{{component.name}}</strong>\r\n								<button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.removeAffected(component, $ctrl.selectedComponents)\">\r\n									<small class=\"glyphicon glyphicon-remove-sign\"></small>\r\n								</button>\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n			</div>\r\n		</div>\r\n		<div class=\"modal-body new-event\" ng-show=\"$ctrl.showSelectTimePanel\">\r\n			<section class=\"section selected-components\">\r\n				<div class=\"section-head\"><strong>Selected Components</strong></div>\r\n				<div class=\"section-body affected-components\">\r\n					<small class=\"affected-component\" ng-repeat=\"component in $ctrl.selectedComponents\">\r\n						{{ component.metric | prettyService:$ctrl.servicesList }} : {{component.name | prettyComponent:$ctrl.componentsList}}\r\n					</small>\r\n				</div>\r\n			</section>\r\n			<section class=\"section select-time hr\">\r\n				<div class=\"section-head\"><strong>Choose time &amp; enter event details</strong></div>\r\n				<div class=\"section-body time-range\">\r\n					<span class=\"set-range btn-group btn-group-sm\">\r\n						<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.timeRange=\'hour\'\" ng-class=\"{\'active\':$ctrl.timeRange===\'hour\'}\">\r\n							1H\r\n						</button>\r\n						<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.timeRange=\'day\'\" ng-class=\"{\'active\':$ctrl.timeRange===\'day\'}\">\r\n							24H\r\n						</button>\r\n						<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.timeRange=\'week\'\" ng-class=\"{\'active\':$ctrl.timeRange===\'week\'}\">\r\n							7D\r\n						</button>\r\n						<button type=\"button\" class=\"btn btn-default\" ng-click=\"$ctrl.timeRange=\'month\'\" ng-class=\"{\'active\':$ctrl.timeRange===\'month\'}\">\r\n							30D\r\n						</button>\r\n					</span>\r\n					<span class=\"selected-range\">\r\n						<div ng-show=\"chartReqStatus.type !==\'loading\'\">\r\n							<span class=\"start\">{{$ctrl.startTime | date: \'short\'}}</span>\r\n							<span class=\"glyphicon glyphicon-arrow-right\"></span>\r\n							<span class=\"end\">{{$ctrl.endTime | date: \'short\'}}</span>\r\n						</div>\r\n					</span>\r\n				</div>\r\n				<div class=\"section-body chart\">\r\n					<div class=\"chart\" ng-class=\"{\'hour\':$ctrl.timeRange===\'hour\'}\">\r\n						<ul ng-class=\"{\'requesting\': chartReqStatus.type===\'loading\' }\">\r\n							<li\r\n								ng-repeat=\"data in $ctrl.chartData track by $index\"\r\n								title=\"{{ data.startTime | date : \'short\' }}\"\r\n								uib-tooltip=\"{{ data.startTime | date : \'short\' }}\"\r\n								tooltip-append-to-body=\"true\"\r\n								ng-click=\"$ctrl.zoomIn(data.startTime)\"\r\n								ng-class=\"{\'active\':$ctrl.eventTime===data.startTime && $ctrl.timeRange===\'hour\'}\">\r\n\r\n								<span class=\"time\" ng-if=\"$ctrl.timeRange===\'hour\' && $first || $ctrl.timeRange===\'hour\' && $last\" ng-cloak>{{($first) && \'From:\' || \'\'}} {{($last) && \'To:\' || \'\'}} {{ data.startTime | date : \'hh:mma\' }}</span>\r\n								<span class=\"time\" ng-if=\"$ctrl.timeRange===\'day\'\">{{ data.startTime | date : \'HH:mm\' }}</span>\r\n								<span class=\"time\" ng-if=\"$ctrl.timeRange===\'month\' || $ctrl.timeRange===\'week\'\" ng-cloak>{{ data.startTime | date:\'M/d\' }}</span>\r\n							</li>\r\n						</ul>\r\n					</div>\r\n				</div>\r\n			</section>\r\n			<section class=\"hr add-event\" ng-if=\"$ctrl.showAddEventPanel\">\r\n				<div class=\"section-body event-status\">\r\n					<span class=\"event-range\">\r\n						<span class=\"range-label\">Time: </span>\r\n						<span class=\"range-start\">{{ $ctrl.eventTime | date:\'MMM d, h:mma\' }}</span>\r\n						<span class=\"glyphicon glyphicon-arrow-right\"></span>\r\n						<span class=\"range-end\">Ongoing</span>\r\n					</span>\r\n					<span class=\"set-status btn-group btn-group-sm\">\r\n						<button type=\"button\" class=\"btn btn-default\" ng-class=\"{active:$ctrl.eventStatus===\'up\'}\" ng-click=\"$ctrl.eventStatus = \'up\'; $ctrl.eventAvailability=100\">\r\n							<span class=\"item-indicator sm up\"></span>\r\n						</button>\r\n						<button type=\"button\" class=\"btn btn-default\" ng-class=\"{active:$ctrl.eventStatus===\'degraded\'}\" ng-click=\"$ctrl.eventStatus = \'degraded\'; $ctrl.eventAvailability=50\">\r\n							<span class=\"item-indicator sm degraded\"></span>\r\n						</button>\r\n						<button type=\"button\" class=\"btn btn-default\" ng-class=\"{active:$ctrl.eventStatus===\'down\'}\" ng-click=\"$ctrl.eventStatus = \'down\'; $ctrl.eventAvailability=0\">\r\n							<span class=\"item-indicator sm down\"></span>\r\n						</button>\r\n					</span>\r\n					<span class=\"event-availability\" ng-show=\"$ctrl.eventStatus\">\r\n						<span class=\"availability-value\" ng-show=\"$ctrl.eventStatus!==\'degraded\'\">{{$ctrl.eventAvailability}}%</span>\r\n						<span class=\"availability-custom\" ng-show=\"$ctrl.eventStatus===\'degraded\'\">\r\n							Enter Availability:\r\n							<input type=\"text\" name=\"availability\" ng-model=\"$ctrl.eventAvailability\" placeholder=\"%\" required=\"required\">\r\n						</span>\r\n					</span>\r\n				</div>\r\n				<div class=\"event-comment\">\r\n					<input type=\"text\" name=\"comments\" class=\"form-control\" placeholder=\"Add comments\" ng-model=\"$ctrl.eventNote\" required=\"required\">\r\n				</div>\r\n			</section>\r\n		</div>\r\n		<div class=\"modal-footer\">\r\n			<small class=\"help-block text-danger\" ng-show=\"!$ctrl.eventTime && $ctrl.showSelectTimePanel\">Select the event time</small>\r\n			<small class=\"help-block text-danger\" ng-show=\"!$ctrl.eventStatus && batchEventForm.availability.$invalid && $ctrl.showSelectTimePanel\">Please select status</small>\r\n			<small class=\"help-block text-danger\" ng-show=\"batchEventForm.comments.$invalid && $ctrl.eventStatus && $ctrl.showSelectTimePanel\">Please add comments</small>\r\n			<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.showSelectTimePanel=false\" ng-show=\"$ctrl.showSelectTimePanel\">\r\n				<span class=\"glyphicon glyphicon-chevron-left\"></span>\r\n				Back\r\n			</button>\r\n			<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-hide=\"$ctrl.showSelectTimePanel\">Cancel</button>\r\n			<button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.showSelectTimePanel=true\" ng-hide=\"$ctrl.showSelectTimePanel\" ng-disabled=\"!$ctrl.selectedComponents.length\">\r\n				Continue\r\n				<span class=\"glyphicon glyphicon-chevron-right\"></span>\r\n			</button>\r\n			<button type=\"button\" class=\"btn btn-primary\" ng-show=\"$ctrl.showSelectTimePanel\" ng-disabled=\"batchEventForm.$invalid || !$ctrl.eventTime\" ng-click=\"$ctrl.ok()\">\r\n				<span class=\"glyphicon glyphicon-plus\"></span> Add Event\r\n			</button>\r\n		</div>\r\n	</div></script>");
$templateCache.put("app/notify/notify.html","<div class=page data-name=notify><div class=container><header class=page-head><admin-nav class=admin-nav></admin-nav><h1 class=sr-only>Notify</h1></header><div class=page-body><section class=section data-name=post-notification><div class=\"section-head sr-only\"><h2 class=section-header>Post Notification</h2></div><div class=section-body ng-form=postNotificationForm><div class=\"well notification-type\"><div class=row><div class=col-sm-6><div class=form-group><label>Choose notification type</label><div class=btn-group><button type=button class=\"btn btn-default\" ng-click=\"newNotification.notification_type=2\" ng-class=\"{\'active\':newNotification.notification_type===2}\">Disruption</button> <button type=button class=\"btn btn-default\" ng-click=\"newNotification.notification_type=5\" ng-class=\"{\'active\':newNotification.notification_type===5}\">Outage</button> <button type=button class=\"btn btn-default\" ng-click=\"newNotification.notification_type=3\" ng-class=\"{\'active\':newNotification.notification_type===3}\">Maintenance</button> <button type=button class=\"btn btn-default\" ng-click=\"newNotification.notification_type=4\" ng-class=\"{\'active\':newNotification.notification_type===4}\">Provider</button> <button type=button class=\"btn btn-default\" ng-click=\"newNotification.notification_type=1\" ng-class=\"{\'active\':newNotification.notification_type===1}\">General</button></div></div></div><div class=col-sm-6><div class=form-group ng-show=\"newNotification.notification_type===4\"><label>Provider Name</label><input type=text class=form-control ng-model=newNotification.vendor_name ng-required=\"newNotification.notification_type===4\"></div></div></div></div><div class=\"notification-options well\" ng-if=newNotification.notification_type><div class=\"form-group notification-start-time\" ng-hide=\"newNotification.notification_type===1\"><label>Start Time</label><input type=datetime-local class=form-control ng-model=newNotification.start_ts ng-required=\"newNotification.notification_type!==1\"></div><div class=form-group ng-if=\"newNotification.notification_type && newNotification.notification_type!==3\"><label>Mark Resolved</label><div><span class=form-well ng-class=\"{\'active\':newNotification.markResolved}\"><input type=checkbox name=resolved ng-model=newNotification.markResolved> </span><input type=datetime-local name=resolutionTime class=form-control ng-show=newNotification.markResolved ng-required=newNotification.markResolved ng-model=newNotification.resolution_ts></div></div><div class=\"form-group notification-advisory\"><label>Send Advisory Email</label><div><span class=form-well ng-class=\"{\'active\':newNotification.sendEmail}\"><input type=checkbox ng-model=newNotification.sendEmail></span></div></div></div><div class=\"affected-components well\" ng-if=newNotification.notification_type><div class=\"affected-head clearfix\"><label>Affected Components</label><button type=button class=\"btn btn-default\" ng-click=addMultiple()><small class=\"glyphicon glyphicon-plus\"></small> Multiple</button><div class=component-search><input type=text class=form-control ng-model=newNotification.selectedComponent placeholder=\"Search components\" uib-typeahead=\"component as component.backendName for component in componentsList | filter:$viewValue\" typeahead-template-url=typeahead.html typeahead-show-hint=true typeahead-on-select=\"addAffected($item, newNotification)\"> <span class=\"glyphicon glyphicon-search\"></span></div></div><div class=affected-body ng-show=\"newNotification.components_affected && newNotification.components_affected.length\"><small class=affected-component ng-repeat=\"component in newNotification.components_affected\">{{component.metric | prettyService:servicesList}} : {{component.name}} <button type=button class=close aria-label=Close ng-click=\"removeAffected(component, newNotification)\"><span aria-hidden=true>&times;</span></button></small></div></div><div class=well ng-if=newNotification.notification_type><div class=row><div class=\"col-sm-6 col-sm-push-3\"><div class=\"form-group new-notification-title\"><label class=sr-only>Title</label><input type=text name=title class=form-control placeholder=Title ng-model=newNotification.title required></div><div class=\"form-group new-notification-message\"><label class=sr-only>Message</label><textarea class=form-control name=message rows=2 placeholder=Message ui-tinymce=tinymceOptions ng-model=newNotification.message ng-required=\"newNotification.notification_type!==1\"></textarea></div></div></div></div></div><div class=section-foot><small class=\"help-block text-danger\" ng-hide=\"newNotification.notification_type===1\" ng-show=\"!newNotification.notification_type || !newNotification.components_affected.length || postNotificationForm.$invalid\">Please complete all form input</small> <small class=\"help-block text-danger\" ng-show=\"newNotification.notification_type===1 && postNotificationForm.title.$invalid\">To post, enter a title</small> <button class=\"btn-clear btn btn-default\" ng-click=clearNotificationForm() ng-show=\"newNotification.notification_type || newNotification.components_affected.length || newNotification.title || newNotification.message\">Cancel</button> <button class=\"btn-post btn btn-primary\" ng-click=\"postNotification(newNotification, \'new\')\" ng-disabled=\"postNotificationForm.$invalid || !newNotification.notification_type\">Post Notification</button></div></section><section class=\"section hr\" data-name=notifications><div class=section-head><span class=list-total>Total: {{filteredNotifications.length | number}}</span><h2 class=section-header>Notifications</h2><div class=section-controls><div class=control-status><span class=\"set-range btn-group btn-group-sm\"><button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_status===2}\" ng-click=\"listFilter={notification_status:2}\">Ongoing</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_status===4}\" ng-click=\"listFilter={notification_status:4}\">Resolved</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_status===3}\" ng-click=\"listFilter={notification_status:3}\">Revoked</button></span></div><div class=control-type><span class=\"set-range btn-group btn-group-sm\"><button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_type===2}\" ng-click=\"listFilter={notification_type:2}\">Disruption</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_type===5}\" ng-click=\"listFilter={notification_type:5}\">Outage</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_type===3}\" ng-click=\"listFilter={notification_type:3}\">Maintenance</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_type===1}\" ng-click=\"listFilter={notification_type:1}\">General</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':listFilter.notification_type===4}\" ng-click=\"listFilter={notification_type:4}\">Provider</button></span></div><div class=control-range><span class=\"set-range btn-group btn-group-sm\"><button type=button class=\"btn btn-default\" ng-class=\"{\'active\':timeRange===\'all\'}\" ng-click=\"updateTimeRange(\'all\')\">All</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':timeRange===\'hour\'}\" ng-click=\"updateTimeRange(\'hour\')\">1H</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':timeRange===\'day\'}\" ng-click=\"updateTimeRange(\'day\')\">24H</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':timeRange===\'week\'}\" ng-click=\"updateTimeRange(\'week\')\">7D</button> <button type=button class=\"btn btn-default\" ng-class=\"{\'active\':timeRange===\'month\'}\" ng-click=\"updateTimeRange(\'month\')\">30D</button></span></div><button class=\"btn btn-default btn-sm control-reset\" ng-click=\"listFilter={}\">Reset</button></div></div><div class=section-body><div class=list-view><!-- Request Status Message --><div class=request-status ng-class=\"{\'text-danger\':requestStatus.type===\'error\'}\" ng-show=requestStatus.display><div class=content><div class=icon><img src=./assets/theme/images/icon-spinner.gif alt=\"One moment...\" ng-if=\"requestStatus.type === \'loading\'\"> <span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"requestStatus.type === \'error\'\"></span></div><p class=details>{{ requestStatus.details }}</p></div></div><div class=list-notification ng-show=\"!filteredNotifications.length && !requestStatus.display\">No notifications found</div><!-- Notifications List --><div class=list-body><div class=list-item ng-repeat=\"notification in filteredNotifications = (notifications | filter:listFilter:true) | orderBy:\'-creation_ts\'\"><!-- Edit: Read Section --><div class=\"editable editable-read\" ng-hide=notification.showEdit data-name=notification><div class=editable-head><strong class=item-title><span class=text-muted ng-class=\"{\'text-warning\':notification.notification_type===2, \'text-danger\':notification.notification_type===5||notification.notification_type===4, \'text-info\':notification.notification_type===1||notification.notification_type===3}\"><small class=\"glyphicon glyphicon-info-sign\" ng-if=\"notification.notification_type===1||notification.notification_type===3\"></small> <small class=\"glyphicon glyphicon-warning-sign\" ng-if=\"notification.notification_type===2 || notification.notification_type===5\"></small> <small class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"notification.notification_type===4\"></small> <span ng-if=\"notification.notification_type===2\">Disruption</span> <span ng-if=\"notification.notification_type===5\">Outage</span> <span ng-if=\"notification.notification_type===3\">Maintenance</span> <span ng-if=\"notification.notification_type===1\">General</span> <span ng-if=\"notification.notification_type===4\">Provider</span> </span>: {{ notification.title }} </strong><small class=item-time>Created: {{ notification.creation_ts*1000 | date:\'MM/dd/yy hh:mm a\' }}</small> <small class=item-status ng-class=\"{\'text-success\':notification.notification_status===4,\'text-warning\':notification.notification_status===2, \'text-danger\':notification.notification_status===3}\"><small class=\"glyphicon glyphicon-ok\" ng-show=\"notification.notification_status===4\"></small> <small class=\"glyphicon glyphicon-remove\" ng-show=\"notification.notification_status===3\"></small> <small class=\"glyphicon glyphicon-time\" ng-show=\"notification.notification_status===2\"></small> <span ng-if=\"notification.notification_status===1\">Scheduled</span> <span ng-if=\"notification.notification_status===2\">Ongoing</span> <span ng-if=\"notification.notification_status===3\">Revoked</span> <span ng-if=\"notification.notification_status===4\">Resolved <span ng-if=notification.resolution_ts>({{notification.resolution_ts*1000 | date:\'MM/dd/yy hh:mm a\'}})</span> </span></small><small class=item-by title={{notification.operator_id}}><small class=\"glyphicon glyphicon-user\"></small> {{ notification.operator }}</small></div><div class=editable-body><div class=item-vendor-name ng-if=\"notification.notification_type===4\"><small class=affected-label>Provider Name:</small> <strong>{{(notification.vendor_name) && notification.vendor_name || \'N/A\'}}</strong></div><div class=\"item-affected affected-components\" ng-if=notification.components_affected.length><small class=affected-label>Affected:</small> <small class=affected-component ng-repeat=\"component in notification.components_affected track by $index\">{{ component.metric|prettyService:servicesList }} : {{ component.name }}</small></div></div><div class=editable-foot><button type=button class=\"btn-edit btn btn-default\" ng-click=\"toggleForm(notification, \'showEdit\')\">Edit</button> <button type=button class=\"btn-update btn btn-default\" ng-click=\"toggleForm(notification, \'showAddUpdate\')\" ng-class=\"{\'active\':notification.showAddUpdate}\"><small class=\"glyphicon glyphicon-plus\"></small> Add Update</button></div></div><!-- Edit: Edit Section --><div class=\"editable editable-edit\" ng-show=notification.showEdit data-name=notification><div class=editable-head><h3 class=\"editable-header h4\">Edit</h3></div><div class=editable-body><div class=row><div class=col-sm-3><div class=form-group><label>Add Component(s)</label><div class=component-search><input type=text class=form-control ng-model=notification.copy.selectedComponent placeholder=\"Search component\" uib-typeahead=\"component as component.backendName for component in componentsList | filter:$viewValue\" typeahead-template-url=typeahead.html typeahead-show-hint=true typeahead-on-select=\"addAffected($item, notification.copy)\"> <span class=\"glyphicon glyphicon-search\"></span></div></div></div><div class=col-sm-5><div class=form-group><label>Title</label><input type=text class=form-control placeholder=Title ng-model=notification.copy.title></div></div><div class=col-sm-4 ng-if=notification.resolution_ts><div class=\"form-group resolution-time\"><label>Resolution Time</label><input type=datetime-local class=form-control ng-model=notification.copy.resolution_ts></div></div><div class=col-sm-3 ng-if=notification.vendor_name><div class=form-group><label>Provider Name</label><input type=text class=form-control ng-model=notification.copy.vendor_name></div></div></div><div class=\"affected-components hr\" ng-if=notification.copy.components_affected.length><small class=affected-label>Affected:</small> <small class=affected-component ng-repeat=\"component in notification.copy.components_affected track by $index\">{{ component.metric | prettyService:servicesList }} : {{ component.name }} <button type=button class=close aria-label=Close ng-click=\"removeAffected(component, notification.copy)\"><span aria-hidden=true>&times;</span></button></small></div></div><div class=editable-foot><button type=button class=\"btn btn-default\" ng-click=\"toggleForm(notification, \'showEdit\')\">Cancel</button> <button type=button class=\"btn btn-primary\" ng-click=editNotification(notification.copy)>Save Edits</button></div></div><!-- Add Update --><div class=add-update ng-form=addUpdateForm ng-show=notification.showAddUpdate><div class=update-head><h3 class=\"update-header h4\">Add Update</h3></div><div class=update-body><div class=form-group><label class=sr-only>Update Message</label><textarea name=update-message class=form-control rows=2 ui-tinymce=tinymceOptions ng-model=notification.copy.updateMessage placeholder=\"Notification message\" required></textarea></div><div class=notification-options><div class=form-group><label><input type=checkbox ng-model=notification.copy.sendEmail> Send Advisory Email</label></div><div class=\"form-group notification-revoking\" ng-if=\"notification.notification_status!==3\"><label class=text-danger><input type=checkbox name=resolved ng-model=notification.copy.updateStatusRevoke> Mark Revoked</label></div><div class=\"form-group option-mark-resolve\" ng-if=\"notification.notification_status!==4\"><label><input type=checkbox name=resolved ng-model=notification.copy.updateStatusResolved> Mark Resolved</label><input type=datetime-local name=resolutionTime class=\"form-control input-xs\" ng-show=notification.copy.updateStatusResolved ng-required=notification.copy.resolution_ts ng-model=notification.copy.resolution_ts></div></div></div><div class=update-foot><button type=button class=\"btn btn-default\" ng-click=\"toggleForm(notification, \'showAddUpdate\')\">Cancel</button> <button type=button class=\"btn btn-primary\" ng-disabled=addUpdateForm.$invalid ng-click=postUpdate(notification.copy)>Post Update</button></div></div><!-- Updates (Messages) --><div class=item-update-list ng-class=\"{\'hr\':notification.messages.length}\" ng-if=notification.messages.length><div class=item-update ng-repeat=\"message in notification.messages\"><!-- Edit: Read Section --><div class=\"editable editable-read\" ng-hide=message.showEditUpdate data-name=message><div class=row><div class=\"update-date col-md-2\">{{ message.ts*1000 | date:\'MM/dd/yy hh:mm a\' }}</div><div class=\"update-by col-md-8\" title={{message.operator_id}}><small class=\"glyphicon glyphicon-user\"></small> {{ message.operator }}</div><div class=\"update-controls col-md-2\"><button type=button class=update-delete ng-click=\"deleteUpdate(notification.notification_id, $index)\" ng-if=$index><small class=\"glyphicon glyphicon-trash\"></small> Delete</button> <button type=button class=update-edit ng-click=\"toggleForm(message, \'showEditUpdate\')\"><small class=\"glyphicon glyphicon-edit\"></small> Edit</button></div></div><div class=row><div class=\"update-message col-md-push-2 col-md-10\" ng-bind-html=\"message.message | fullHtml\"></div><div class=\"update-customer-action col-md-push-2 col-md-10\" ng-if=message.customer_action>Customer action: {{ message.customer_action }}</div></div></div><!-- Edit: Edit Section --><div class=\"editable editable-edit tt-well\" ng-show=message.showEditUpdate data-name=message><div class=form-horizontal><div class=\"form-group form-group-sm update-date\"><label class=col-sm-2>Date Posted</label><div class=col-sm-10><div class=input-group><div class=input-group-addon><small class=\"glyphicon glyphicon-calendar text-muted\"></small></div><input type=datetime-local class=form-control ng-model=message.copy.message_ts></div></div></div><div class=\"form-group form-group-sm update-message\"><label class=col-sm-2>Details</label><div class=col-sm-10><textarea type=text class=form-control ui-tinymce=tinymceOptions ng-model=message.copy.message></textarea></div></div><div class=\"form-group form-group-sm update-customer-action\" ng-if=message.copy.customer_action><label class=col-sm-2>Customer Action</label><div class=col-sm-10><input type=text class=form-control ng-model=message.copy.customer_action></div></div></div><div class=\"form-group update-controls\"><button type=button class=\"btn btn-sm btn-default\" ng-click=\"toggleForm(message, \'showEditUpdate\')\">Cancel</button> <button type=button class=\"btn btn-sm btn-primary\" ng-click=\"editUpdate($index, message, notification)\">Save</button></div></div></div></div></div></div></div></div></section></div></div></div><!-- Type Ahead Template --><script type=text/ng-template id=typeahead.html><a>\r\n		<span>{{match.model.service}}:</span>\r\n		<span>{{match.label}}</span>\r\n	</a></script><!-- Confirm New Post Modal Template --><script type=text/ng-template id=confirmPost.html><div class=\"modal-header\">\r\n		<h3 class=\"modal-title h4\">Confirm</h3>\r\n	</div>\r\n	<div class=\"modal-body\">\r\n		<div class=\"modal-request-status\" ng-show=\"$ctrl.requestStatus.display\" ng-class=\"{\'text-danger\':$ctrl.requestStatus.type===\'error\', \'text-success\':$ctrl.requestStatus.type===\'success\'}\">\r\n			<div class=\"icon\">\r\n				<img src=\"./assets/theme/images/icon-spinner.gif\" alt=\"One moment...\" ng-if=\"$ctrl.requestStatus.type === \'loading\'\">\r\n				<span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"$ctrl.requestStatus.type === \'error\'\"></span>\r\n				<span class=\"glyphicon glyphicon-ok\" ng-if=\"$ctrl.requestStatus.type === \'success\'\"></span>\r\n			</div>\r\n			<p class=\"details\">\r\n				{{ $ctrl.requestStatus.details }}\r\n			</p>\r\n		</div>\r\n		<div ng-hide=\"$ctrl.requestStatus.display\">\r\n			<section class=\"section\" data-name=\"preview-notification\">\r\n				<p class=\"modal-instructions\">Are you sure you want to publish the following message to all users?</p>\r\n				<div class=\"tt-well\">\r\n					<div class=\"bar\">\r\n						<small class=\"data-type\" ng-class=\"{\'text-warning\':$ctrl.notification.notification_type===2, \'text-danger\':$ctrl.notification.notification_type===5||$ctrl.notification.notification_type===4, \'text-info\':$ctrl.notification.notification_type===1||$ctrl.notification.notification_type===3}\">\r\n							<small class=\"glyphicon glyphicon-info-sign\" ng-if=\"$ctrl.notification.notification_type===1||$ctrl.notification.notification_type===3\"></small>\r\n							<small class=\"glyphicon glyphicon-warning-sign\" ng-if=\"$ctrl.notification.notification_type===2||$ctrl.notification.notification_type===5\"></small>\r\n							<small class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"$ctrl.notification.notification_type===4\"></small>\r\n							<span ng-if=\"$ctrl.notification.notification_type===2\">Disruption</span>\r\n							<span ng-if=\"$ctrl.notification.notification_type===5\">Outage</span>\r\n							<span ng-if=\"$ctrl.notification.notification_type===3\">Maintenance</span>\r\n							<span ng-if=\"$ctrl.notification.notification_type===1\">General</span>\r\n							<span ng-if=\"$ctrl.notification.notification_type===4\">Provider</span>\r\n						</small>\r\n						<small class=\"data-vendor-name\" ng-if=\"$ctrl.notification.notification_type===4\">\r\n							<span class=\"data-label\">Provider Name:</span>\r\n							<span>{{ $ctrl.notification.vendor_name }}</span>\r\n						</small>\r\n					</div>\r\n					<div class=\"hr\">\r\n						<div class=\"data-title\">{{ $ctrl.notification.title }}</div>\r\n						<div class=\"data-details\" ng-bind-html=\"$ctrl.notification.message | fullHtml\"></div>\r\n					</div>\r\n				</div>\r\n				<div class=\"tt-well\">\r\n					<div class=\"bar\">\r\n						<small class=\"data-start-time\">\r\n							<span class=\"data-label\">\r\n								<small class=\"glyphicon glyphicon-time\"></small>\r\n								Started:\r\n							</span>\r\n							<span>{{ $ctrl.notification.start_ts | date:\'M/d/yy hh:mm a\' }}</span>\r\n						</small>\r\n						<small class=\"data-resolution-time\" ng-if=\"$ctrl.notification.markResolved\">\r\n							<span class=\"data-label\">\r\n								<small class=\"glyphicon glyphicon-time\"></small>\r\n								Resolved:\r\n							</span>\r\n							<span>{{ $ctrl.notification.resolution_ts | date:\'M/d/yy hh:mm a\' }}</span>\r\n						</small>\r\n					</div>\r\n					<div class=\"hr\" ng-if=\"$ctrl.notification.customer_action || $ctrl.notification.components_affected.length\">\r\n						<span class=\"data-customer-action\" ng-if=\"$ctrl.notification.customer_action\">\r\n							<span class=\"data-label\">Customer Action:</span>\r\n							<span>{{ $ctrl.notification.customer_action }}</span>\r\n						</span>\r\n						<div class=\"data-affected-components affected-components\" ng-if=\"$ctrl.notification.components_affected.length\">\r\n							<span class=\"data-label\">Affected:</span>\r\n							<small class=\"affected-component\" ng-repeat=\"component in $ctrl.notification.components_affected\">\r\n								{{component.metric | prettyService:$ctrl.servicesList}} : {{component.name | prettyComponent:$ctrl.componentsList}}\r\n							</small>\r\n						</div>\r\n					</div>\r\n				</div>\r\n				<div class=\"tt-well data-resolved\" ng-if=\"$ctrl.notification.markResolved\">\r\n					<small class=\"glyphicon glyphicon-ok text-success\"></small>\r\n					Mark Resolved\r\n				</div>\r\n				<div class=\"tt-well data-send-email\" ng-if=\"$ctrl.notification.sendEmail\">\r\n					<small class=\"glyphicon glyphicon-envelope text-warning\"></small>\r\n					Sending Email\r\n				</div>\r\n			</section>\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-show=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\' || $ctrl.requestStatus.display && $ctrl.requestStatus.type===\'error\'\">Close</button>\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\' || $ctrl.requestStatus.display && $ctrl.requestStatus.type===\'error\'\">Cancel</button>\r\n		<button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\' || $ctrl.requestStatus.display && $ctrl.requestStatus.type===\'error\'\" ng-disabled=\"$ctrl.requestStatus.type===\'loading\'\">Post Notification</button>\r\n	</div></script><!-- Post Update Modal Template --><script type=text/ng-template id=postUpdate.html><div class=\"modal-header\">\r\n		<h3 class=\"modal-title h4\">Confirm Update</h3>\r\n	</div>\r\n	<div class=\"modal-body\">\r\n		<div class=\"modal-request-status\" ng-show=\"$ctrl.requestStatus.display\" ng-class=\"{\'text-danger\':$ctrl.requestStatus.type===\'error\', \'text-success\':$ctrl.requestStatus.type===\'success\'}\">\r\n			<div class=\"icon\">\r\n				<img src=\"./assets/theme/images/icon-spinner.gif\" alt=\"One moment...\" ng-if=\"$ctrl.requestStatus.type === \'loading\'\">\r\n				<span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"$ctrl.requestStatus.type === \'error\'\"></span>\r\n				<span class=\"glyphicon glyphicon-ok\" ng-if=\"$ctrl.requestStatus.type === \'success\'\"></span>\r\n			</div>\r\n			<p class=\"details\">\r\n				{{ $ctrl.requestStatus.details }}\r\n			</p>\r\n		</div>\r\n		<div ng-hide=\"$ctrl.requestStatus.display\">\r\n			<section class=\"section\" data-name=\"preview-notification\">\r\n				<p class=\"modal-instructions\">Are you sure you want to publish the following update to all users?</p>\r\n				<div class=\"tt-well\">\r\n					<div class=\"data-details\">\r\n						<span class=\"data-label\">Message:</span>\r\n						<p ng-bind-html=\"$ctrl.notification.updateMessage | fullHtml\"></p>\r\n					</div>\r\n					<span class=\"data-customer-action\" ng-if=\"$ctrl.notification.customer_action\">\r\n						<span class=\"data-label\">Customer Action:</span>\r\n						<span>{{ $ctrl.notification.customer_action }}</span>\r\n					</span>\r\n					<small class=\"data-resolution-time\" ng-if=\"$ctrl.notification.markResolved\">\r\n						<span class=\"data-label\">\r\n							<small class=\"glyphicon glyphicon-time\"></small>\r\n							Resolved:\r\n						</span>\r\n						<span>{{ $ctrl.notification.resolution_ts | date:\'M/d/yy hh:mm a\' }}</span>\r\n					</small>\r\n				</div>\r\n				<div class=\"tt-well data-revoked\" ng-if=\"$ctrl.notification.updateStatusRevoke\">\r\n					<small class=\"glyphicon glyphicon-remove text-danger\"></small>\r\n					Mark Revoked\r\n				</div>\r\n				<div class=\"tt-well data-resolved\" ng-if=\"$ctrl.notification.updateStatusResolved\">\r\n					<small class=\"glyphicon glyphicon-ok text-success\"></small>\r\n					Mark Resolved\r\n				</div>\r\n				<div class=\"tt-well data-send-email\" ng-if=\"$ctrl.notification.sendEmail\">\r\n					<small class=\"glyphicon glyphicon-envelope text-warning\"></small>\r\n					Sending Email\r\n				</div>\r\n			</section>\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-show=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\' || $ctrl.requestStatus.display && $ctrl.requestStatus.type===\'error\'\">Close</button>\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\' || $ctrl.requestStatus.display && $ctrl.requestStatus.type===\'error\'\">Cancel</button>\r\n		<button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\" ng-hide=\"$ctrl.requestStatus.display && $ctrl.requestStatus.type===\'success\' || $ctrl.requestStatus.display && $ctrl.requestStatus.type===\'error\'\" ng-disabled=\"$ctrl.requestStatus.type===\'loading\'\">Post Update</button>\r\n	</div></script><!-- Add Multiple Components Modal Template --><script type=text/ng-template id=addMultiple.html><div class=\"modal-header\">\r\n		<button type=\"button\" class=\"close\" ng-click=\"$ctrl.cancel()\"><span aria-hidden=\"true\">&times;</span></button>\r\n		<h3 class=\"modal-title h4\">Add Multiple Components</h3>\r\n	</div>\r\n	<div class=\"modal-body\">\r\n		<p>Select a service, then choose the components you would like to add.</p>\r\n		<div class=\"row\">\r\n			<div class=\"col-sm-4 service-list\">\r\n				<div class=\"tt-well\">\r\n					<div class=\"list-head\">Services</div>\r\n					<ul class=\"list-body\">\r\n						<li\r\n							ng-repeat=\"service in $ctrl.servicesList | orderBy:\'name\'\"\r\n							ng-class=\"{\'active\':$ctrl.selectedComponent.metric===service.metric}\"\r\n							ng-click=\"$ctrl.selectedComponent=service\">\r\n							{{service.name}}\r\n						</li>\r\n					</ul>\r\n				</div>\r\n			</div>\r\n			<div class=\"col-sm-4 component-list\">\r\n				<div class=\"tt-well\">\r\n					<div class=\"list-head\">{{($ctrl.selectedComponent.name) && $ctrl.selectedComponent.name || \'Components\'}} <span ng-if=\"$ctrl.selectedComponent.name\">: {{$ctrl.filteredComponents.length | number}}</span></div>\r\n					<ul class=\"list-body\" ng-if=\"$ctrl.selectedComponent.metric\">\r\n						<li class=\"add-all\" ng-click=\"$ctrl.addAll()\"><small class=\"glyphicon glyphicon-plus text-muted\"></small> <strong>Add all</strong></li>\r\n						<li\r\n							ng-repeat=\"component in $ctrl.filteredComponents = ($ctrl.componentsList | filter:$ctrl.selectedComponent.metric:true | orderBy:\'name\')\"\r\n							ng-click=\"$ctrl.addAffected(component, $ctrl.newNotification)\">\r\n							{{component.backendName}}\r\n						</li>\r\n					</ul>\r\n				</div>\r\n			</div>\r\n			<div class=\"col-sm-4 selected-list\">\r\n				<div class=\"tt-well\">\r\n					<div class=\"list-head\">Selected Components <span ng-if=\"$ctrl.newNotification.components_affected.length\">: {{$ctrl.newNotification.components_affected.length | number}}</span></div>\r\n					<ul class=\"list-body\" ng-show=\"$ctrl.newNotification.components_affected && $ctrl.newNotification.components_affected.length\">\r\n						<li class=\"remove-all\" ng-click=\"$ctrl.newNotification.components_affected=[]\"><small class=\"glyphicon glyphicon-remove text-muted\"></small> <strong>Remove all</strong></li>\r\n						<li class=\"affected-component\" ng-repeat=\"component in $ctrl.newNotification.components_affected\">\r\n							<small>{{component.metric | prettyService:$ctrl.servicesList}}</small>\r\n							<strong>{{component.name}}</strong>\r\n							<button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"$ctrl.removeAffected(component, $ctrl.newNotification)\">\r\n								<small class=\"glyphicon glyphicon-remove-sign\"></small>\r\n							</button>\r\n						</li>\r\n					</ul>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div>\r\n	<div class=\"modal-footer\">\r\n		<button class=\"btn btn-default\" type=\"button\" ng-click=\"$ctrl.cancel()\">Done</button>\r\n	</div></script>");
$templateCache.put("app/service/service.html","<div class=page data-name=service><div class=container><header class=page-head><a ui-sref=home({environment:environment}) class=back><img src=./assets/images/icon-chevron-left.svg height=20 width=20> <span class=back-label>Back</span></a><h1 ng-if=serviceName>{{ serviceName }} Availability</h1><p class=content>This page provides historical availability metrics for TT services. The “7-Days” and “30-Days” views display availability on a per-day basis, while the “1-Day” view displays per-hour availability and the “1-Hour” view displays per-minute availability in local times.</p></header><div class=request-status ng-class=\"{\'text-danger\':requestStatus.type===\'error\'}\" ng-show=requestStatus.display><div class=content><div class=icon><img src=./assets/theme/images/icon-spinner.gif alt=\"One moment...\" ng-if=\"requestStatus.type === \'loading\'\"> <span class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"requestStatus.type === \'error\'\"></span></div><p class=details>{{ requestStatus.details }} <span class=details ng-if=\"requestStatus.type===\'error\'\">If you need immediate help, please contact <a href=https://www.tradingtechnologies.com/en/contact/ target=_blank>TT Support</a>.</span></p></div><div class=backdrop></div></div><section class=section data-name=summary ng-class=\"{\'follow\':follow}\" ng-if=components.length offset=150 scroll-follow><div class=content><div ng-class=\"{\'container\':follow}\"><header class=scroll-follow-header ng-show=follow><a ui-sref=home({environment:environment}) class=back><img src=./assets/images/icon-chevron-left.svg height=20 width=20> <span class=back-label>Back</span> </a><strong>{{ serviceName }} Availability</strong></header><div class=section-controls><div class=availability><span ng-show=!rendered>%</span> <span ng-show=\"rendered && availability >= 0\">{{ availability | truncate:2 }}%</span></div><div class=\"set-timerange btn-group\"><button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'hour\')\" ng-class=\"{\'active\':timeRange===\'hour\'}\"><span class=default>1 Hour</span> <span class=short>1H</span></button> <button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'day\')\" ng-class=\"{\'active\':timeRange===\'day\'}\"><span class=default>24 Hours</span> <span class=short>24H</span></button> <button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'week\')\" ng-class=\"{\'active\':timeRange===\'week\'}\"><span class=default>7 Days</span> <span class=short>7D</span></button> <button type=button class=\"btn btn-default\" ng-click=\"updateTimeRange(\'month\')\" ng-class=\"{\'active\':timeRange===\'month\'}\"><span class=default>30 Days</span> <span class=short>30D</span></button></div><button type=button class=\"refresh btn btn-default\" ng-click=refreshChart()><span class=\"glyphicon glyphicon-refresh\"></span> <span class=default>Refresh</span></button></div><div class=time-range><div ng-show=!rendered>One moment...</div><div ng-show=\"timeStart && timeEnd && rendered\"><span class=start>{{ timeStart | date:\'MMM d, h:mma\' }}</span> <span class=\"glyphicon glyphicon-arrow-right\"></span> <span class=end>{{ timeEnd | date:\'MMM d, h:mma\' }}</span></div></div></div></div></section><section class=section data-name=components ng-if=components.length><ul class=list-view data-name=component-list><li class=list-item ng-repeat=\"component in components track by $index\"><a name=\"{{ component.graphDataCriteria.component }}\"></a><div class=list-item-row><strong class=item-availability><span ng-show=!rendered>%</span> <span ng-show=\"rendered && component.availability>=0\">{{ component.availability | truncate:2 }}%</span> </strong><span class=item-name>{{ component.graphDataCriteria.component }}</span></div><div class=list-item-row><small class=text-muted ng-if=!component.dataPoints.length><span class=\"glyphicon glyphicon-info-sign\"></span> Availability data is currently not available</small><div class=item-chart ng-if=component.dataPoints.length ng-class=\"{\'hour\':timeRange===\'hour\'}\"><ul ng-class=\"{\'requesting\': !rendered }\"><li ng-if=rendered ng-style=\"{\'background-color\': (data.availability | color)}\" ng-repeat=\"data in component.dataPoints track by $index\" ng-click=\"$parent.zoomIn(data.startTime )\" ng-mouseover=\"showDetails(data, component)\" uib-popover-template=\"\'popoverTemplate.html\'\" popover-class=availability-notifications popover-trigger=\"\'mouseenter\'\" popover-append-to-body=true><span class=time ng-if=\"$parent.timeRange===\'hour\' && $first || $parent.timeRange===\'hour\' && $last\">{{($first) && \'From:\' || \'\'}} {{($last) && \'To:\' || \'\'}} {{ data.startTime | date:\'M/d, hh:mma\' }}</span> <span class=time ng-if=\"$parent.timeRange===\'month\' || $parent.timeRange===\'week\'\">{{ data.startTime | date:\'M/d\' }}</span> <span class=time ng-if=\"$parent.timeRange===\'day\'\">{{ data.startTime | date:\'HH:mm\' }}</span> <small class=exchange-issue ng-if=data.vendor></small></li></ul></div></div></li></ul></section></div></div><script type=text/ng-template id=popoverTemplate.html><div class=\"availability-details\">\r\n		<strong class=\"availability-percent\">{{ (popoverData.availability.availability >= 0) && (popoverData.availability.availability | truncate:2) + \'%\' || \'N/A\'}}</strong>\r\n		<small class=\"availability-date\">{{ popoverData.availability.startTime | date:\'short\' }}</small>\r\n	</div>\r\n	<div class=\"notification-details\" ng-if=\"popoverData.notifications.length\">\r\n		<div class=\"notification\" ng-repeat=\"notification in popoverData.notifications track by $index\">\r\n			<div class=\"notification-title\">\r\n				<strong ng-class=\"{\'text-warning\':notification.notification_type===2, \'text-danger\':notification.notification_type===4 || notification.notification_type===5, \'text-info\':notification.notification_type===1||notification.notification_type===3}\">\r\n					<small class=\"glyphicon glyphicon-info-sign\" ng-if=\"notification.notification_type===1||notification.notification_type===3\"></small>\r\n					<small class=\"glyphicon glyphicon-warning-sign\" ng-if=\"notification.notification_type===2 || notification.notification_type===5\"></small>\r\n					<small class=\"glyphicon glyphicon-exclamation-sign\" ng-if=\"notification.notification_type===4\"></small>\r\n					<span ng-if=\"notification.notification_type===4\">Exchange Issue</span>\r\n					<span ng-if=\"notification.notification_type===2\">Disruption</span>\r\n					<span ng-if=\"notification.notification_type===5\">Outage</span>\r\n					<span ng-if=\"notification.notification_type===3\">Maintenance</span>\r\n					<span ng-if=\"notification.notification_type===1\">General</span>\r\n				</strong>\r\n				:\r\n				<strong>{{ notification.title }}</strong>\r\n			</div>\r\n			<div class=\"affected-components\" ng-if=\"notification.components_affected.length\">\r\n				<small class=\"affected-label\">Affected:</small>\r\n				<small class=\"affected-component\" ng-repeat=\"component in notification.components_affected track by $index\">\r\n					{{component.metric | prettyService:servicesList}} : {{component.name | prettyComponent:componentsList}}\r\n				</small>\r\n			</div>\r\n			<div class=\"notification-messages\" ng-if=\"notification.messages.length\">\r\n				<div class=\"message\" ng-repeat=\"message in notification.messages track by $index\">\r\n					<span class=\"message-time\">{{message.ts*1000 | date:\'M/d/yy hh:mm a\' }}</span>\r\n					<span class=\"message-details\" ng-bind-html=\"message.message | fullHtml\"></span>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div></script>");
$templateCache.put("app/components/adminNav/adminNav.html","<span class=\"btn-group admin-nav\"><a ui-sref-active=active ui-sref=admin({environment:env}) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-bell\"></span> Alerts</a> <a ui-sref-active=active ui-sref=manage({environment:env}) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-th-list\"></span> Manage</a> <a ui-sref-active=active ui-sref=notify({environment:env}) class=\"btn btn-default\"><span class=\"glyphicon glyphicon-volume-up\"></span> Notify</a> </span>");
$templateCache.put("app/components/environments/environments.html","<span class=env-label>Environment</span><div class=\"btn-group env-select\" uib-dropdown is-open=status.isopen><button type=button class=\"btn btn-default\" uib-dropdown-toggle ng-disabled=disabled>{{ (currRoute!==\'admin\' && currRoute!==\'manage\' && currRoute!==\'notify\') ? (env | prettyEnv:currRoute) : env }} <span class=caret></span></button><div class=dropdown-menu uib-dropdown-menu ng-if=error>{{ errorDetails }}</div><ul class=\"dropdown-menu dropdown-menu-right\" uib-dropdown-menu ng-if=!error><li ng-repeat=\"env in envList\"><a href=\"\" ng-click=updateEnv(env)>{{ (currRoute!==\'admin\' && currRoute!==\'manage\' && currRoute!==\'notify\') ? (env | prettyEnv:currRoute) : env }}</a></li></ul></div>");
$templateCache.put("app/components/lastUpdated/lastUpdated.html","<span title=\"Last Updated: {{ newTime | date:\'MMM d, h:mm:ssa\' }}\"><small class=\"glyphicon glyphicon-time\"></small> <span class=time-label>Updated</span>: <span class=time-data>{{ newTime | date:\'h:mm:ssa\' }}</span> </span>");
$templateCache.put("app/components/pageAlert/pageAlert.html","<div class=\"page-alert container\"><div class=\"alert alert-dismissible\" role=alert ng-repeat=\"alert in vm.alerts | orderBy: \'-last_updated_ts\' track by $index\" ng-class=\"{\'alert-warning\':alert.notification_type===2, \'alert-danger\':alert.notification_type===5 || alert.notification_type===4,\'alert-info\':alert.notification_type===3 || alert.notification_type===1}\"><button type=button class=close data-dismiss=alert aria-label=Close ng-if=\"alert.notification_type===3\" ng-click=$parent.vm.closeAlert($index)><span aria-hidden=true>&times;</span></button> <span class=time>{{ alert.last_updated_ts*1000 | date:\'short\' }}</span><div class=message><div class=alert-header><span ng-if=\"alert.notification_type===4\"><small class=\"glyphicon glyphicon-exclamation-sign\" uib-tooltip=\"Exchange Issue\"></small> Exchange Issue : </span><span ng-if=\"alert.notification_type===3\"><small class=\"glyphicon glyphicon-wrench\"></small> Maintenance : </span><span ng-if=\"alert.notification_type===1\"><small class=\"glyphicon glyphicon-info-sign\"></small> General Info : </span><span ng-if=\"alert.notification_type===2\"><small class=\"glyphicon glyphicon-warning-sign\"></small> Disruption : </span><span ng-if=\"alert.notification_type===5\"><small class=\"glyphicon glyphicon-warning-sign\"></small> Outage : </span><span class=title>{{ alert.title }}</span></div><div class=details ng-bind-html=\"alert.latest_message | fullHtml\"></div></div><div class=customer-action ng-if=alert.customer_action><strong class=action-label>Customer Action:</strong> <span class=action-message>{{ alert.customer_action }}</span></div><div class=affected-components ng-if=alert.components_affected.length><small class=affected-label>Affected:</small> <small class=affected-component ng-repeat=\"component in alert.components_affected\">{{component.metric | prettyService:vm.servicesList}} : {{component.name | prettyComponent:vm.componentsList}}</small></div></div><div class=\"alert alert-success all-systems-operational\" role=alert ng-if=vm.showAllSystemsOperational><div class=message><strong class=title>All Systems Operational</strong></div></div></div>");
$templateCache.put("app/components/status/status.html","<!-- This template uses view models from main.html, see <li status> elements in main.html for details --> <span class=item-arrow></span> <span class=\"item-indicator md\" ng-class=\"{\'up\':item.status==\'Up\', \'degraded\':item.status==\'Degraded\', \'down\':item.status==\'Down\'}\"></span> <span class=item-name>{{ item.name }} </span><small class=\"glyphicon glyphicon-exclamation-sign text-danger\" ng-if=item.vendor uib-tooltip=\"Exchange Issue\"></small><ul class=item-components ng-show=showService[item.metric]><li ng-repeat=\"component in item.components track by $index\"><a ui-sref=\"service({name:$parent.item.name, environment:$parent.environment, metric:$parent.item.metric, component:component.name})\"><span class=\"item-indicator sm\" ng-class=\"{\'up\':component.status==\'Up\', \'degraded\': component.status==\'Degraded\', \'down\':component.status==\'Down\'}\"></span> {{ component.name }} <small class=\"glyphicon glyphicon-exclamation-sign text-danger\" ng-if=component.vendor uib-tooltip=\"Exchange Issue\"></small></a></li></ul>");}]);